// // // // import React, { useState, useEffect } from 'react';
// // // // import {
// // // //   Dialog,
// // // //   DialogTitle,
// // // //   DialogContent,
// // // //   DialogActions,
// // // //   Button,
// // // //   Box,
// // // //   Typography,
// // // //   FormControlLabel,
// // // //   Checkbox,
// // // //   TextField,
// // // //   Link,
// // // //   Divider,
// // // // } from '@mui/material';
// // // // import api from '../../../api/axiosInterceptor';
// // // // import { SnackBarComponent } from '../../../Components/snackBar/snackBar';

// // // // const DocsEditModal = ({ open, onClose, excessId, refId, excessAmt }) => {
// // // //   const [loading, setLoading] = useState(false);

// // // //   const [snackbarOpen, setSnackbarOpen] = useState(false);
// // // //   const [snackbarMessage, setSnackbarMessage] = useState('');
// // // //   const [snackbarSeverity, setSnackbarSeverity] = useState('success');

// // // //   // PAYMENT STATE
// // // //   const [paymentData, setPaymentData] = useState({
// // // //     is_agreed_to_pay: false,
// // // //     is_not_agreed_to_pay: false,
// // // //     agreed_amount: '',
// // // //     no_of_installment: 0,
// // // //     agree_remarks: '',
// // // //   });

// // // //   const [showInstallmentWarning, setShowInstallmentWarning] = useState(false);
// // // //   const [pendingInstallmentValue, setPendingInstallmentValue] = useState('');

// // // //   // DOCS
// // // //   const [formData, setFormData] = useState({
// // // //     is_address_proof_submited: false,
// // // //     is_pan_card_submited: false,
// // // //     is_aadhar_card_submited: false,
// // // //     is_affidavit_submited: false,
// // // //     is_bank_statement_submited: false,
// // // //     current_address: '',
// // // //     updated_mobile_number: '',
// // // //   });

// // // //   // ORDER
// // // //   const [orderStatus, setOrderStatus] = useState({
// // // //     is_freezing_order_issued: false,
// // // //     is_bank_freezed: false,
// // // //     is_summons_issued: false,
// // // //     is_partial_un_freezing_order_submited: false,
// // // //     is_partial_un_freezed: false,
// // // //     is_defreezing_order_submited: false,
// // // //     is_bank_defreezed: false,
// // // //   });

// // // //   // Fetch all data
// // // //   const fetchAllData = async () => {
// // // //     if (!excessId) return;

// // // //     try {
// // // //       setLoading(true);

// // // //       const [docsRes, orderRes, paymentRes] = await Promise.all([
// // // //         api.get(`/excess_payment_mgmt/excess-docs-updater/${excessId}/`),
// // // //         api.get(`/excess_payment_mgmt/excess-order-updater/${excessId}/`),
// // // //         api.get(`/excess_payment_mgmt/excess-payment-updater/${excessId}/`),
// // // //       ]);

// // // //       setFormData(docsRes.data);

// // // //       setOrderStatus(orderRes.data);

// // // //       setPaymentData({
// // // //         is_agreed_to_pay: paymentRes.data.is_agreed_to_pay || false,
// // // //         is_not_agreed_to_pay: paymentRes.data.is_not_agreed_to_pay || false,
// // // //         agreed_amount: paymentRes.data.agreed_amount || '',
// // // //         no_of_installment:
// // // //           parseInt(paymentRes.data.no_of_installment, 10) || 0,
// // // //         agree_remarks: paymentRes.data.agree_remarks || '',
// // // //       });
// // // //     } catch (err) {
// // // //       setSnackbarMessage(
// // // //         err.response?.data?.error || 'Failed to load data.'
// // // //       );
// // // //       setSnackbarSeverity('error');
// // // //       setSnackbarOpen(true);
// // // //     } finally {
// // // //       setLoading(false);
// // // //     }
// // // //   };

// // // //   useEffect(() => {
// // // //     if (open) {
// // // //       fetchAllData();
// // // //     }
// // // //   }, [open, excessId]);

// // // //   const showError = (message) => {
// // // //     setSnackbarMessage(message);
// // // //     setSnackbarSeverity('error');
// // // //     setSnackbarOpen(true);
// // // //   };

// // // //   const handleChange = (e, section = 'docs') => {
// // // //     const { name, value, checked, type } = e.target;

// // // //     // Mobile validation
// // // //     if (name === 'updated_mobile_number') {
// // // //       if (!/^\d{0,10}$/.test(value)) return;
// // // //     }

// // // //     // =========================
// // // //     // DOCS
// // // //     // =========================
// // // //     if (section === 'docs') {
// // // //       setFormData((prev) => ({
// // // //         ...prev,
// // // //         [name]: type === 'checkbox' ? checked : value,
// // // //       }));
// // // //     }

// // // //     // =========================
// // // //     // ORDER STATUS
// // // //     // =========================
// // // //     else if (section === 'order') {
// // // //       // REVERSE VALIDATIONS

// // // //       // Cannot uncheck freezing if bank freezed checked
// // // //       if (
// // // //         name === 'is_freezing_order_issued' &&
// // // //         !checked &&
// // // //         orderStatus.is_bank_freezed
// // // //       ) {
// // // //         showError(
// // // //           'Please uncheck "Bank Freezed" before unchecking "Freezing Order Issued".'
// // // //         );
// // // //         return;
// // // //       }

// // // //       // Cannot uncheck bank freezed if summons issued checked
// // // //       if (
// // // //         name === 'is_bank_freezed' &&
// // // //         !checked &&
// // // //         orderStatus.is_summons_issued
// // // //       ) {
// // // //         showError(
// // // //           'Please uncheck "Summons Issued" before unchecking "Bank Freezed".'
// // // //         );
// // // //         return;
// // // //       }

// // // //       // Cannot uncheck summons if partial unfreeze submitted
// // // //       if (
// // // //         name === 'is_summons_issued' &&
// // // //         !checked &&
// // // //         orderStatus.is_partial_un_freezing_order_submited
// // // //       ) {
// // // //         showError(
// // // //           'Please uncheck "Partial Unfreeze Order Submitted" before unchecking "Summons Issued".'
// // // //         );
// // // //         return;
// // // //       }

// // // //       // Cannot uncheck partial unfreeze submitted if partially unfreezed
// // // //       if (
// // // //         name === 'is_partial_un_freezing_order_submited' &&
// // // //         !checked &&
// // // //         orderStatus.is_partial_un_freezed
// // // //       ) {
// // // //         showError(
// // // //           'Please uncheck "Partially Unfreezed" before unchecking "Partial Unfreeze Order Submitted".'
// // // //         );
// // // //         return;
// // // //       }

// // // //       // Cannot uncheck partially unfreezed if defreezing submitted
// // // //       if (
// // // //         name === 'is_partial_un_freezed' &&
// // // //         !checked &&
// // // //         orderStatus.is_defreezing_order_submited
// // // //       ) {
// // // //         showError(
// // // //           'Please uncheck "Defreezing Order Submitted" before unchecking "Partially Unfreezed".'
// // // //         );
// // // //         return;
// // // //       }

// // // //       // Cannot uncheck defreezing submitted if bank defreezed
// // // //       if (
// // // //         name === 'is_defreezing_order_submited' &&
// // // //         !checked &&
// // // //         orderStatus.is_bank_defreezed
// // // //       ) {
// // // //         showError(
// // // //           'Please uncheck "Bank Defreezed" before unchecking "Defreezing Order Submitted".'
// // // //         );
// // // //         return;
// // // //       }

// // // //       setOrderStatus((prev) => ({
// // // //         ...prev,
// // // //         [name]: checked,
// // // //       }));
// // // //     }

// // // //     // =========================
// // // //     // PAYMENT
// // // //     // =========================
// // // //     else if (section === 'payment') {
// // // //       if (name === 'no_of_installment') {
// // // //         setPendingInstallmentValue(value);
// // // //         setShowInstallmentWarning(true);
// // // //         return;
// // // //       }

// // // //       // Mutual exclusivity
// // // //       if (name === 'is_agreed_to_pay' && checked) {
// // // //         setPaymentData((prev) => ({
// // // //           ...prev,
// // // //           is_agreed_to_pay: true,
// // // //           is_not_agreed_to_pay: false,
// // // //         }));
// // // //         return;
// // // //       }

// // // //       if (name === 'is_not_agreed_to_pay' && checked) {
// // // //         setPaymentData((prev) => ({
// // // //           ...prev,
// // // //           is_not_agreed_to_pay: true,
// // // //           is_agreed_to_pay: false,
// // // //           agreed_amount: '',
// // // //           no_of_installment: 0,
// // // //         }));
// // // //         return;
// // // //       }

// // // //       setPaymentData((prev) => ({
// // // //         ...prev,
// // // //         [name]: type === 'checkbox' ? checked : value,
// // // //       }));
// // // //     }
// // // //   };

// // // //   const confirmInstallmentChange = () => {
// // // //     setPaymentData((prev) => ({
// // // //       ...prev,
// // // //       no_of_installment: parseInt(pendingInstallmentValue, 10) || 0,
// // // //     }));

// // // //     setPendingInstallmentValue('');
// // // //     setShowInstallmentWarning(false);
// // // //   };

// // // //   const cancelInstallmentChange = () => {
// // // //     setPendingInstallmentValue('');
// // // //     setShowInstallmentWarning(false);
// // // //   };

// // // //   const handleSubmit = async (e) => {
// // // //     e.preventDefault();

// // // //     if (!excessId) return;

// // // //     if (
// // // //       formData.updated_mobile_number &&
// // // //       formData.updated_mobile_number.length !== 10
// // // //     ) {
// // // //       setSnackbarMessage(
// // // //         'Mobile number must be exactly 10 digits'
// // // //       );
// // // //       setSnackbarSeverity('error');
// // // //       setSnackbarOpen(true);
// // // //       return;
// // // //     }

// // // //     let payloadPayment = { ...paymentData };

// // // //     if (!paymentData.is_agreed_to_pay) {
// // // //       payloadPayment = {
// // // //         is_agreed_to_pay: false,
// // // //         is_not_agreed_to_pay: true,
// // // //         agreed_amount: null,
// // // //         no_of_installment: 0,
// // // //         agree_remarks: paymentData.agree_remarks || '',
// // // //       };
// // // //     }

// // // //     setLoading(true);

// // // //     try {
// // // //       await Promise.all([
// // // //         api.patch(
// // // //           `/excess_payment_mgmt/excess-docs-updater/${excessId}/`,
// // // //           formData
// // // //         ),

// // // //         api.patch(
// // // //           `/excess_payment_mgmt/excess-order-updater/${excessId}/`,
// // // //           orderStatus
// // // //         ),

// // // //         api.patch(
// // // //           `/excess_payment_mgmt/excess-payment-updater/${excessId}/`,
// // // //           payloadPayment
// // // //         ),
// // // //       ]);

// // // //       await fetchAllData();

// // // //       setSnackbarMessage('Updated Successfully');
// // // //       setSnackbarSeverity('success');
// // // //       setSnackbarOpen(true);

// // // //       setTimeout(() => onClose(), 1000);
// // // //     } catch (err) {
// // // //       setSnackbarMessage(
// // // //         err.response?.data?.error ||
// // // //           err.response?.data?.message ||
// // // //           'Failed to update.'
// // // //       );

// // // //       setSnackbarSeverity('error');
// // // //       setSnackbarOpen(true);
// // // //     } finally {
// // // //       setLoading(false);
// // // //     }
// // // //   };

// // // //   const docsDisabled = !orderStatus.is_summons_issued;

// // // //   return (
// // // //     <>
// // // //       <Dialog
// // // //         open={open}
// // // //         onClose={onClose}
// // // //         maxWidth="md"
// // // //         fullWidth
// // // //         disableEscapeKeyDown
// // // //       >
// // // //         <DialogTitle>
// // // //           Edit Document & Order Status
// // // //         </DialogTitle>

// // // //         <DialogContent>
// // // //           <Box component="form" onSubmit={handleSubmit} p={2}>
// // // //             {/* REFERENCE ID */}
// // // //             <Typography variant="subtitle2" gutterBottom>
// // // //               Reference ID:{' '}
// // // //               <Box
// // // //                 component="span"
// // // //                 sx={{
// // // //                   backgroundColor: '#1976d2',
// // // //                   color: '#fff',
// // // //                   px: 1.5,
// // // //                   py: 0.5,
// // // //                   borderRadius: 1,
// // // //                   fontWeight: 600,
// // // //                   fontSize: '0.85rem',
// // // //                 }}
// // // //               >
// // // //                 {refId}
// // // //               </Box>
// // // //             </Typography>

// // // //             {/* EXCESS AMOUNT */}
// // // //             <Typography variant="subtitle2" gutterBottom>
// // // //               Excess Amount:{' '}
// // // //               <Box
// // // //                 component="span"
// // // //                 sx={{
// // // //                   backgroundColor: '#2e7d32',
// // // //                   color: '#fff',
// // // //                   px: 1.5,
// // // //                   py: 0.5,
// // // //                   borderRadius: 1,
// // // //                   fontWeight: 600,
// // // //                   fontSize: '0.85rem',
// // // //                 }}
// // // //               >
// // // //                 ₹ {excessAmt || 0}
// // // //               </Box>
// // // //             </Typography>

// // // //             <Typography
// // // //               variant="body2"
// // // //               sx={{
// // // //                 color: '#8B0000',
// // // //                 fontWeight: 600,
// // // //                 mb: 2,
// // // //               }}
// // // //             >
// // // //               Please add Reference Id on Hard copy
// // // //             </Typography>

// // // //             {/* ORDER STATUS */}
// // // //             <Typography variant="subtitle2" gutterBottom>
// // // //               Order Status
// // // //             </Typography>

// // // //             <FormControlLabel
// // // //               control={
// // // //                 <Checkbox
// // // //                   checked={
// // // //                     orderStatus.is_freezing_order_issued
// // // //                   }
// // // //                   name="is_freezing_order_issued"
// // // //                   onChange={(e) =>
// // // //                     handleChange(e, 'order')
// // // //                   }
// // // //                 />
// // // //               }
// // // //               label="Freezing Order Issued"
// // // //             />

// // // //             <FormControlLabel
// // // //               control={
// // // //                 <Checkbox
// // // //                   checked={orderStatus.is_bank_freezed}
// // // //                   name="is_bank_freezed"
// // // //                   disabled={
// // // //                     !orderStatus.is_freezing_order_issued
// // // //                   }
// // // //                   onChange={(e) =>
// // // //                     handleChange(e, 'order')
// // // //                   }
// // // //                 />
// // // //               }
// // // //               label="Bank Freezed"
// // // //             />

// // // //             <FormControlLabel
// // // //               control={
// // // //                 <Checkbox
// // // //                   checked={orderStatus.is_summons_issued}
// // // //                   name="is_summons_issued"
// // // //                   disabled={!orderStatus.is_bank_freezed}
// // // //                   onChange={(e) =>
// // // //                     handleChange(e, 'order')
// // // //                   }
// // // //                 />
// // // //               }
// // // //               label="Summons Issued"
// // // //             />

// // // //             <Divider sx={{ my: 2 }} />

// // // //             {/* PAYMENT */}
// // // //             <Typography variant="subtitle2" gutterBottom>
// // // //               Payment Agreement
// // // //             </Typography>

// // // //             <FormControlLabel
// // // //               control={
// // // //                 <Checkbox
// // // //                   checked={paymentData.is_agreed_to_pay}
// // // //                   name="is_agreed_to_pay"
// // // //                   disabled={!orderStatus.is_summons_issued}
// // // //                   onChange={(e) =>
// // // //                     handleChange(e, 'payment')
// // // //                   }
// // // //                 />
// // // //               }
// // // //               label="Agreed to Pay"
// // // //             />

// // // //             <FormControlLabel
// // // //               control={
// // // //                 <Checkbox
// // // //                   checked={
// // // //                     paymentData.is_not_agreed_to_pay
// // // //                   }
// // // //                   name="is_not_agreed_to_pay"
// // // //                   disabled={!orderStatus.is_summons_issued}
// // // //                   onChange={(e) =>
// // // //                     handleChange(e, 'payment')
// // // //                   }
// // // //                 />
// // // //               }
// // // //               label="Not Agreed to Pay"
// // // //             />

// // // //             {paymentData.is_agreed_to_pay &&
// // // //             !paymentData.is_not_agreed_to_pay ? (
// // // //               <>
// // // //                 <TextField
// // // //                   label="Agreed Amount"
// // // //                   type="number"
// // // //                   name="agreed_amount"
// // // //                   value={paymentData.agreed_amount}
// // // //                   onChange={(e) =>
// // // //                     handleChange(e, 'payment')
// // // //                   }
// // // //                   fullWidth
// // // //                   size="small"
// // // //                   sx={{ mt: 2 }}
// // // //                 />

// // // //                 <TextField
// // // //                   label="No of Installments"
// // // //                   type="number"
// // // //                   name="no_of_installment"
// // // //                   value={
// // // //                     paymentData.no_of_installment
// // // //                   }
// // // //                   onChange={(e) =>
// // // //                     handleChange(e, 'payment')
// // // //                   }
// // // //                   fullWidth
// // // //                   size="small"
// // // //                   sx={{ mt: 2 }}
// // // //                 />
// // // //               </>
// // // //             ) : null}

// // // //             <TextField
// // // //               label="Additional Remarks"
// // // //               name="agree_remarks"
// // // //               value={paymentData.agree_remarks}
// // // //               onChange={(e) =>
// // // //                 handleChange(e, 'payment')
// // // //               }
// // // //               fullWidth
// // // //               multiline
// // // //               rows={2}
// // // //               size="small"
// // // //               sx={{ mt: 2 }}
// // // //             />

// // // //             <Divider sx={{ my: 2 }} />

// // // //             {/* DOCS */}
// // // //             <Typography variant="subtitle2" gutterBottom>
// // // //               Proof of Submission
// // // //             </Typography>

// // // //             <Box
// // // //               display="flex"
// // // //               flexDirection="column"
// // // //               gap={1}
// // // //               mb={2}
// // // //             >
// // // //               <FormControlLabel
// // // //                 control={
// // // //                   <Checkbox
// // // //                     checked={
// // // //                       formData.is_address_proof_submited
// // // //                     }
// // // //                     name="is_address_proof_submited"
// // // //                     onChange={(e) =>
// // // //                       handleChange(e, 'docs')
// // // //                     }
// // // //                     disabled={docsDisabled}
// // // //                   />
// // // //                 }
// // // //                 label="Address Proof"
// // // //               />

// // // //               <FormControlLabel
// // // //                 control={
// // // //                   <Checkbox
// // // //                     checked={
// // // //                       formData.is_pan_card_submited
// // // //                     }
// // // //                     name="is_pan_card_submited"
// // // //                     onChange={(e) =>
// // // //                       handleChange(e, 'docs')
// // // //                     }
// // // //                     disabled={docsDisabled}
// // // //                   />
// // // //                 }
// // // //                 label="PAN Card"
// // // //               />

// // // //               <FormControlLabel
// // // //                 control={
// // // //                   <Checkbox
// // // //                     checked={
// // // //                       formData.is_aadhar_card_submited
// // // //                     }
// // // //                     name="is_aadhar_card_submited"
// // // //                     onChange={(e) =>
// // // //                       handleChange(e, 'docs')
// // // //                     }
// // // //                     disabled={docsDisabled}
// // // //                   />
// // // //                 }
// // // //                 label="Aadhar Card"
// // // //               />

// // // //               <FormControlLabel
// // // //                 control={
// // // //                   <Checkbox
// // // //                     checked={
// // // //                       formData.is_affidavit_submited
// // // //                     }
// // // //                     name="is_affidavit_submited"
// // // //                     onChange={(e) =>
// // // //                       handleChange(e, 'docs')
// // // //                     }
// // // //                     disabled={docsDisabled}
// // // //                   />
// // // //                 }
// // // //                 label="Affidavit"
// // // //               />

// // // //               <Typography variant="body2">
// // // //                 Download Affidavit Template:{' '}
// // // //                 <Link
// // // //                   href="https://splocamedia.s3.ap-south-1.amazonaws.com/templates/UN-FREEZE+THE+BANK+ACCOUNT.pdf"
// // // //                   target="_blank"
// // // //                 >
// // // //                   Click here
// // // //                 </Link>
// // // //               </Typography>

// // // //               <FormControlLabel
// // // //                 control={
// // // //                   <Checkbox
// // // //                     checked={
// // // //                       formData.is_bank_statement_submited
// // // //                     }
// // // //                     name="is_bank_statement_submited"
// // // //                     onChange={(e) =>
// // // //                       handleChange(e, 'docs')
// // // //                     }
// // // //                     disabled={docsDisabled}
// // // //                   />
// // // //                 }
// // // //                 label="Bank Statement"
// // // //               />
// // // //             </Box>

// // // //             <TextField
// // // //               label="Current Address"
// // // //               name="current_address"
// // // //               value={formData.current_address}
// // // //               onChange={(e) =>
// // // //                 handleChange(e, 'docs')
// // // //               }
// // // //               fullWidth
// // // //               multiline
// // // //               rows={2}
// // // //               size="small"
// // // //               sx={{ mb: 2 }}
// // // //             />

// // // //             <TextField
// // // //               label="Updated Mobile Number"
// // // //               name="updated_mobile_number"
// // // //               value={formData.updated_mobile_number}
// // // //               onChange={(e) =>
// // // //                 handleChange(e, 'docs')
// // // //               }
// // // //               fullWidth
// // // //               size="small"
// // // //               inputProps={{ maxLength: 10 }}
// // // //               helperText="Enter 10 digit mobile number"
// // // //             />

// // // //             <Divider sx={{ my: 3 }} />

// // // //             {/* PARTIAL UNFREEZE */}
// // // //             <Typography variant="subtitle2" gutterBottom>
// // // //               Partial Unfreeze
// // // //             </Typography>

// // // //             <FormControlLabel
// // // //               control={
// // // //                 <Checkbox
// // // //                   checked={
// // // //                     orderStatus.is_partial_un_freezing_order_submited
// // // //                   }
// // // //                   name="is_partial_un_freezing_order_submited"
// // // //                   onChange={(e) =>
// // // //                     handleChange(e, 'order')
// // // //                   }
// // // //                   disabled={
// // // //                     !orderStatus.is_summons_issued
// // // //                   }
// // // //                 />
// // // //               }
// // // //               label="Partial Unfreeze Order Submitted"
// // // //             />

// // // //             <Typography variant="body2">
// // // //               Template:{' '}
// // // //               <Link
// // // //                 href="https://splocamedia.s3.ap-south-1.amazonaws.com/templates/PARTIALLY+UN-FREEZE+THE+BANK+ACCOUNT.pdf"
// // // //                 target="_blank"
// // // //               >
// // // //                 Click here
// // // //               </Link>
// // // //             </Typography>

// // // //             <FormControlLabel
// // // //               control={
// // // //                 <Checkbox
// // // //                   checked={
// // // //                     orderStatus.is_partial_un_freezed
// // // //                   }
// // // //                   name="is_partial_un_freezed"
// // // //                   onChange={(e) =>
// // // //                     handleChange(e, 'order')
// // // //                   }
// // // //                   disabled={
// // // //                     !orderStatus.is_partial_un_freezing_order_submited
// // // //                   }
// // // //                 />
// // // //               }
// // // //               label="Partially Unfreezed"
// // // //             />

// // // //             <Divider sx={{ my: 2 }} />

// // // //             {/* FINAL DEFREEZE */}
// // // //             <Typography variant="subtitle2" gutterBottom>
// // // //               Final Defreeze
// // // //             </Typography>

// // // //             <FormControlLabel
// // // //               control={
// // // //                 <Checkbox
// // // //                   checked={
// // // //                     orderStatus.is_defreezing_order_submited
// // // //                   }
// // // //                   name="is_defreezing_order_submited"
// // // //                   onChange={(e) =>
// // // //                     handleChange(e, 'order')
// // // //                   }
// // // //                   disabled={
// // // //                     !orderStatus.is_partial_un_freezed
// // // //                   }
// // // //                 />
// // // //               }
// // // //               label="Defreezing Order Submitted"
// // // //             />

// // // //             <Typography variant="body2">
// // // //               Template:{' '}
// // // //               <Link
// // // //                 href="https://splocamedia.s3.ap-south-1.amazonaws.com/templates/UN-FREEZE+THE+BANK+ACCOUNT.pdf"
// // // //                 target="_blank"
// // // //               >
// // // //                 Click here
// // // //               </Link>
// // // //             </Typography>

// // // //             <FormControlLabel
// // // //               control={
// // // //                 <Checkbox
// // // //                   checked={
// // // //                     orderStatus.is_bank_defreezed
// // // //                   }
// // // //                   name="is_bank_defreezed"
// // // //                   onChange={(e) =>
// // // //                     handleChange(e, 'order')
// // // //                   }
// // // //                   disabled={
// // // //                     !orderStatus.is_defreezing_order_submited
// // // //                   }
// // // //                 />
// // // //               }
// // // //               label="Bank Defreezed"
// // // //             />
// // // //           </Box>
// // // //         </DialogContent>

// // // //         <DialogActions>
// // // //           <Button
// // // //             onClick={onClose}
// // // //             disabled={loading}
// // // //           >
// // // //             Cancel
// // // //           </Button>

// // // //           <Button
// // // //             type="submit"
// // // //             onClick={handleSubmit}
// // // //             variant="contained"
// // // //             disabled={loading}
// // // //           >
// // // //             {loading ? 'Saving...' : 'Save'}
// // // //           </Button>
// // // //         </DialogActions>
// // // //       </Dialog>

// // // //       {/* INSTALLMENT WARNING */}
// // // //       <Dialog open={showInstallmentWarning}>
// // // //         <DialogTitle>Warning</DialogTitle>

// // // //         <DialogContent>
// // // //           <Typography color="error">
// // // //             Changing number of installments will
// // // //             erase all existing installment data.
// // // //             This action cannot be undone.
// // // //           </Typography>
// // // //         </DialogContent>

// // // //         <DialogActions>
// // // //           <Button onClick={cancelInstallmentChange}>
// // // //             Cancel
// // // //           </Button>

// // // //           <Button
// // // //             onClick={confirmInstallmentChange}
// // // //             color="error"
// // // //             variant="contained"
// // // //           >
// // // //             Proceed
// // // //           </Button>
// // // //         </DialogActions>
// // // //       </Dialog>

// // // //       <SnackBarComponent
// // // //         open={snackbarOpen}
// // // //         message={snackbarMessage}
// // // //         severity={snackbarSeverity}
// // // //         onClose={() => setSnackbarOpen(false)}
// // // //       />
// // // //     </>
// // // //   );
// // // // };

// // // // export default DocsEditModal;


// // // import React, { useState, useEffect } from 'react';
// // // import {
// // //   Dialog,
// // //   DialogTitle,
// // //   DialogContent,
// // //   DialogActions,
// // //   Button,
// // //   Box,
// // //   Typography,
// // //   FormControlLabel,
// // //   Checkbox,
// // //   TextField,
// // //   Link,
// // //   Divider,
// // // } from '@mui/material';
// // // import api from '../../../api/axiosInterceptor';
// // // import { SnackBarComponent } from '../../../Components/snackBar/snackBar';

// // // const DocsEditModal = ({ open, onClose, excessId, refId, excessAmt }) => {
// // //   const [loading, setLoading] = useState(false);

// // //   const [snackbarOpen, setSnackbarOpen] = useState(false);
// // //   const [snackbarMessage, setSnackbarMessage] = useState('');
// // //   const [snackbarSeverity, setSnackbarSeverity] = useState('success');

// // //   // PAYMENT STATE
// // //   const [paymentData, setPaymentData] = useState({
// // //     is_agreed_to_pay: false,
// // //     is_not_agreed_to_pay: false,
// // //     agreed_amount: '',
// // //     no_of_installment: 0,
// // //     agree_remarks: '',
// // //   });

// // //   const [showInstallmentWarning, setShowInstallmentWarning] = useState(false);
// // //   const [pendingInstallmentValue, setPendingInstallmentValue] = useState('');

// // //   // DOCS
// // //   const [formData, setFormData] = useState({
// // //     is_address_proof_submited: false,
// // //     is_pan_card_submited: false,
// // //     is_aadhar_card_submited: false,
// // //     is_affidavit_submited: false,
// // //     is_bank_statement_submited: false,
// // //     current_address: '',
// // //     updated_mobile_number: '',
// // //   });

// // //   // ORDER
// // //   const [orderStatus, setOrderStatus] = useState({
// // //     is_freezing_order_issued: false,
// // //     is_bank_freezed: false,
// // //     is_summons_issued: false,
// // //     is_partial_un_freezing_order_submited: false,
// // //     is_partial_un_freezed: false,
// // //     is_defreezing_order_submited: false,
// // //     is_bank_defreezed: false,
// // //   });

// // //   // Fetch all data
// // //   const fetchAllData = async () => {
// // //     if (!excessId) return;

// // //     try {
// // //       setLoading(true);

// // //       const [docsRes, orderRes, paymentRes] = await Promise.all([
// // //         api.get(`/excess_payment_mgmt/excess-docs-updater/${excessId}/`),
// // //         api.get(`/excess_payment_mgmt/excess-order-updater/${excessId}/`),
// // //         api.get(`/excess_payment_mgmt/excess-payment-updater/${excessId}/`),
// // //       ]);

// // //       setFormData(docsRes.data);

// // //       setOrderStatus(orderRes.data);

// // //       setPaymentData({
// // //         is_agreed_to_pay: paymentRes.data.is_agreed_to_pay || false,
// // //         is_not_agreed_to_pay: paymentRes.data.is_not_agreed_to_pay || false,
// // //         agreed_amount: paymentRes.data.agreed_amount || '',
// // //         no_of_installment:
// // //           parseInt(paymentRes.data.no_of_installment, 10) || 0,
// // //         agree_remarks: paymentRes.data.agree_remarks || '',
// // //       });
// // //     } catch (err) {
// // //       setSnackbarMessage(
// // //         err.response?.data?.error || 'Failed to load data.'
// // //       );
// // //       setSnackbarSeverity('error');
// // //       setSnackbarOpen(true);
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   };

// // //   useEffect(() => {
// // //     if (open) {
// // //       fetchAllData();
// // //     }
// // //   }, [open, excessId]);

// // //   const showError = (message) => {
// // //     setSnackbarMessage(message);
// // //     setSnackbarSeverity('error');
// // //     setSnackbarOpen(true);
// // //   };

// // //   const handleChange = (e, section = 'docs') => {
// // //     const { name, value, checked, type } = e.target;

// // //     // Mobile validation
// // //     if (name === 'updated_mobile_number') {
// // //       if (!/^\d{0,10}$/.test(value)) return;
// // //     }

// // //     // =========================
// // //     // DOCS
// // //     // =========================
// // //     if (section === 'docs') {
// // //       setFormData((prev) => ({
// // //         ...prev,
// // //         [name]: type === 'checkbox' ? checked : value,
// // //       }));
// // //     }

// // //     // =========================
// // //     // ORDER STATUS
// // //     // =========================
// // //     else if (section === 'order') {
// // //       // REVERSE VALIDATIONS

// // //       // Cannot uncheck freezing if bank freezed checked
// // //       if (
// // //         name === 'is_freezing_order_issued' &&
// // //         !checked &&
// // //         orderStatus.is_bank_freezed
// // //       ) {
// // //         showError(
// // //           'Please uncheck "Bank Freezed" before unchecking "Freezing Order Issued".'
// // //         );
// // //         return;
// // //       }

// // //       // Cannot uncheck bank freezed if summons issued checked
// // //       if (
// // //         name === 'is_bank_freezed' &&
// // //         !checked &&
// // //         orderStatus.is_summons_issued
// // //       ) {
// // //         showError(
// // //           'Please uncheck "Summons Issued" before unchecking "Bank Freezed".'
// // //         );
// // //         return;
// // //       }

// // //       // Cannot uncheck summons if partial unfreeze submitted
// // //       if (
// // //         name === 'is_summons_issued' &&
// // //         !checked &&
// // //         orderStatus.is_partial_un_freezing_order_submited
// // //       ) {
// // //         showError(
// // //           'Please uncheck "Partial Unfreeze Order Submitted" before unchecking "Summons Issued".'
// // //         );
// // //         return;
// // //       }

// // //       // Cannot uncheck partial unfreeze submitted if partially unfreezed
// // //       if (
// // //         name === 'is_partial_un_freezing_order_submited' &&
// // //         !checked &&
// // //         orderStatus.is_partial_un_freezed
// // //       ) {
// // //         showError(
// // //           'Please uncheck "Partially Unfreezed" before unchecking "Partial Unfreeze Order Submitted".'
// // //         );
// // //         return;
// // //       }

// // //       // Cannot uncheck partially unfreezed if defreezing submitted
// // //       if (
// // //         name === 'is_partial_un_freezed' &&
// // //         !checked &&
// // //         orderStatus.is_defreezing_order_submited
// // //       ) {
// // //         showError(
// // //           'Please uncheck "Defreezing Order Submitted" before unchecking "Partial Unfreezed".'
// // //         );
// // //         return;
// // //       }

// // //       // Cannot uncheck defreezing submitted if bank defreezed
// // //       if (
// // //         name === 'is_defreezing_order_submited' &&
// // //         !checked &&
// // //         orderStatus.is_bank_defreezed
// // //       ) {
// // //         showError(
// // //           'Please uncheck "Bank Defreezed" before unchecking "Defreezing Order Submitted".'
// // //         );
// // //         return;
// // //       }

// // //       setOrderStatus((prev) => ({
// // //         ...prev,
// // //         [name]: checked,
// // //       }));
// // //     }

// // //     // =========================
// // //     // PAYMENT
// // //     // =========================
// // //     else if (section === 'payment') {
// // //       if (name === 'no_of_installment') {
// // //         setPendingInstallmentValue(value);
// // //         setShowInstallmentWarning(true);
// // //         return;
// // //       }

// // //       // Mutual exclusivity
// // //       if (name === 'is_agreed_to_pay' && checked) {
// // //         setPaymentData((prev) => ({
// // //           ...prev,
// // //           is_agreed_to_pay: true,
// // //           is_not_agreed_to_pay: false,
// // //         }));
// // //         return;
// // //       }

// // //       if (name === 'is_not_agreed_to_pay' && checked) {
// // //         setPaymentData((prev) => ({
// // //           ...prev,
// // //           is_not_agreed_to_pay: true,
// // //           is_agreed_to_pay: false,
// // //           agreed_amount: '',
// // //           no_of_installment: 0,
// // //         }));
// // //         return;
// // //       }

// // //       setPaymentData((prev) => ({
// // //         ...prev,
// // //         [name]: type === 'checkbox' ? checked : value,
// // //       }));
// // //     }
// // //   };

// // //   const confirmInstallmentChange = () => {
// // //     setPaymentData((prev) => ({
// // //       ...prev,
// // //       no_of_installment: parseInt(pendingInstallmentValue, 10) || 0,
// // //     }));

// // //     setPendingInstallmentValue('');
// // //     setShowInstallmentWarning(false);
// // //   };

// // //   const cancelInstallmentChange = () => {
// // //     setPendingInstallmentValue('');
// // //     setShowInstallmentWarning(false);
// // //   };

// // //   const handleSubmit = async (e) => {
// // //     e.preventDefault();

// // //     if (!excessId) return;

// // //     // Validation: Agreed Amount should not exceed Excess Amount
// // //     if (paymentData.is_agreed_to_pay) {
// // //       const agreed = parseFloat(paymentData.agreed_amount || 0);
// // //       const maxAllowed = parseFloat(excessAmt || 0);

// // //       // If agreed_amount is provided and exceeds max, show error
// // //       if (!Number.isFinite(agreed) || agreed < 0) {
// // //         setSnackbarMessage('Agreed Amount must be a valid non-negative number');
// // //         setSnackbarSeverity('error');
// // //         setSnackbarOpen(true);
// // //         return;
// // //       }

// // //       if (agreed > maxAllowed) {
// // //         setSnackbarMessage('Agreed Amount cannot exceed Excess Amount');
// // //         setSnackbarSeverity('error');
// // //         setSnackbarOpen(true);
// // //         return;
// // //       }
// // //     }

// // //     if (
// // //       formData.updated_mobile_number &&
// // //       formData.updated_mobile_number.length !== 10
// // //     ) {
// // //       setSnackbarMessage(
// // //         'Mobile number must be exactly 10 digits'
// // //       );
// // //       setSnackbarSeverity('error');
// // //       setSnackbarOpen(true);
// // //       return;
// // //     }

// // //     let payloadPayment = { ...paymentData };

// // //     if (!paymentData.is_agreed_to_pay) {
// // //       payloadPayment = {
// // //         is_agreed_to_pay: false,
// // //         is_not_agreed_to_pay: true,
// // //         agreed_amount: null,
// // //         no_of_installment: 0,
// // //         agree_remarks: paymentData.agree_remarks || '',
// // //       };
// // //     }

// // //     setLoading(true);

// // //     try {
// // //       await Promise.all([
// // //         api.patch(
// // //           `/excess_payment_mgmt/excess-docs-updater/${excessId}/`,
// // //           formData
// // //         ),

// // //         api.patch(
// // //           `/excess_payment_mgmt/excess-order-updater/${excessId}/`,
// // //           orderStatus
// // //         ),

// // //         api.patch(
// // //           `/excess_payment_mgmt/excess-payment-updater/${excessId}/`,
// // //           payloadPayment
// // //         ),
// // //       ]);

// // //       await fetchAllData();

// // //       setSnackbarMessage('Updated Successfully');
// // //       setSnackbarSeverity('success');
// // //       setSnackbarOpen(true);

// // //       setTimeout(() => onClose(), 1000);
// // //     } catch (err) {
// // //       setSnackbarMessage(
// // //         err.response?.data?.error ||
// // //           err.response?.data?.message ||
// // //           'Failed to update.'
// // //       );

// // //       setSnackbarSeverity('error');
// // //       setSnackbarOpen(true);
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   };

// // //   const docsDisabled = !orderStatus.is_summons_issued;

// // //   return (
// // //     <>
// // //       <Dialog
// // //         open={open}
// // //         onClose={onClose}
// // //         maxWidth="md"
// // //         fullWidth
// // //         disableEscapeKeyDown
// // //        >
// // //         <DialogTitle>
// // //           Edit Document & Order Status
// // //         </DialogTitle>

// // //         <DialogContent>
// // //           <Box component="form" onSubmit={handleSubmit} p={2}>
// // //             {/* REFERENCE ID */}
// // //             <Typography variant="subtitle2" gutterBottom>
// // //               Reference ID:{' '}
// // //               <Box
// // //                 component="span"
// // //                 sx={{
// // //                   backgroundColor: '#1976d2',
// // //                   color: '#fff',
// // //                   px: 1.5,
// // //                   py: 0.5,
// // //                   borderRadius: 1,
// // //                   fontWeight: 600,
// // //                   fontSize: '0.85rem',
// // //                 }}
// // //               >
// // //                 {refId}
// // //               </Box>
// // //             </Typography>

// // //             {/* EXCESS AMOUNT */}
// // //             <Typography variant="subtitle2" gutterBottom>
// // //               Excess Amount:{' '}
// // //               <Box
// // //                 component="span"
// // //                 sx={{
// // //                   backgroundColor: '#2e7d32',
// // //                   color: '#fff',
// // //                   px: 1.5,
// // //                   py: 0.5,
// // //                   borderRadius: 1,
// // //                   fontWeight: 600,
// // //                   fontSize: '0.85rem',
// // //                 }}
// // //               >
// // //                 ₹ {excessAmt || 0}
// // //               </Box>
// // //             </Typography>

// // //             <Typography
// // //               variant="body2"
// // //               sx={{
// // //                 color: '#8B0000',
// // //                 fontWeight: 600,
// // //                 mb: 2,
// // //               }}
// // //             >
// // //               Please add Reference Id on Hard copy
// // //             </Typography>

// // //             {/* ORDER STATUS */}
// // //             <Typography variant="subtitle2" gutterBottom>
// // //               Order Status
// // //             </Typography>

// // //             <FormControlLabel
// // //               control={
// // //                 <Checkbox
// // //                   checked={orderStatus.is_freezing_order_issued}
// // //                   name="is_freezing_order_issued"
// // //                   onChange={(e) =>
// // //                     handleChange(e, 'order')
// // //                   }
// // //                 />
// // //               }
// // //               label="Freezing Order Issued"
// // //             />

// // //             <FormControlLabel
// // //               control={
// // //                 <Checkbox
// // //                   checked={orderStatus.is_bank_freezed}
// // //                   name="is_bank_freezed"
// // //                   disabled={
// // //                     !orderStatus.is_freezing_order_issued
// // //                   }
// // //                   onChange={(e) =>
// // //                     handleChange(e, 'order')
// // //                   }
// // //                 />
// // //               }
// // //               label="Bank Freezed"
// // //             />

// // //             <FormControlLabel
// // //               control={
// // //                 <Checkbox
// // //                   checked={orderStatus.is_summons_issued}
// // //                   name="is_summons_issued"
// // //                   disabled={!orderStatus.is_bank_freezed}
// // //                   onChange={(e) =>
// // //                     handleChange(e, 'order')
// // //                   }
// // //                 />
// // //               }
// // //               label="Summons Issued"
// // //             />

// // //             <Divider sx={{ my: 2 }} />

// // //             {/* PAYMENT */}
// // //             <Typography variant="subtitle2" gutterBottom>
// // //               Payment Agreement
// // //             </Typography>

// // //             <FormControlLabel
// // //               control={
// // //                 <Checkbox
// // //                   checked={paymentData.is_agreed_to_pay}
// // //                   name="is_agreed_to_pay"
// // //                   disabled={!orderStatus.is_summons_issued}
// // //                   onChange={(e) =>
// // //                     handleChange(e, 'payment')
// // //                   }
// // //                 />
// // //               }
// // //               label="Agreed to Pay"
// // //             />

// // //             <FormControlLabel
// // //               control={
// // //                 <Checkbox
// // //                   checked={
// // //                     paymentData.is_not_agreed_to_pay
// // //                   }
// // //                   name="is_not_agreed_to_pay"
// // //                   disabled={!orderStatus.is_summons_issued}
// // //                   onChange={(e) =>
// // //                     handleChange(e, 'payment')
// // //                   }
// // //                 />
// // //               }
// // //               label="Not Agreed to Pay"
// // //             />

// // //             {paymentData.is_agreed_to_pay &&
// // //             !paymentData.is_not_agreed_to_pay ? (
// // //               <>
// // //                 <TextField
// // //                   label="Agreed Amount"
// // //                   type="number"
// // //                   name="agreed_amount"
// // //                   value={paymentData.agreed_amount}
// // //                   onChange={(e) =>
// // //                     handleChange(e, 'payment')
// // //                   }
// // //                   fullWidth
// // //                   size="small"
// // //                   sx={{ mt: 2 }}
// // //                 />

// // //                 <TextField
// // //                   label="No of Installments"
// // //                   type="number"
// // //                   name="no_of_installment"
// // //                   value={
// // //                     paymentData.no_of_installment
// // //                   }
// // //                   onChange={(e) =>
// // //                     handleChange(e, 'payment')
// // //                   }
// // //                   fullWidth
// // //                   size="small"
// // //                   sx={{ mt: 2 }}
// // //                 />
// // //               </>
// // //             ) : null}

// // //             <TextField
// // //               label="Additional Remarks"
// // //               name="agree_remarks"
// // //               value={paymentData.agree_remarks}
// // //               onChange={(e) =>
// // //                 handleChange(e, 'payment')
// // //               }
// // //               fullWidth
// // //               multiline
// // //               rows={2}
// // //               size="small"
// // //               sx={{ mt: 2 }}
// // //             />

// // //             <Divider sx={{ my: 2 }} />

// // //             {/* DOCS */}
// // //             <Typography variant="subtitle2" gutterBottom>
// // //               Proof of Submission
// // //             </Typography>

// // //             <Box
// // //               display="flex"
// // //               flexDirection="column"
// // //               gap={1}
// // //               mb={2}
// // //             >
// // //               <FormControlLabel
// // //                 control={
// // //                   <Checkbox
// // //                     checked={
// // //                       formData.is_address_proof_submited
// // //                     }
// // //                     name="is_address_proof_submited"
// // //                     onChange={(e) =>
// // //                       handleChange(e, 'docs')
// // //                     }
// // //                     disabled={docsDisabled}
// // //                   />
// // //                 }
// // //                 label="Address Proof"
// // //               />

// // //               <FormControlLabel
// // //                 control={
// // //                   <Checkbox
// // //                     checked={
// // //                       formData.is_pan_card_submited
// // //                     }
// // //                     name="is_pan_card_submited"
// // //                     onChange={(e) =>
// // //                       handleChange(e, 'docs')
// // //                     }
// // //                     disabled={docsDisabled}
// // //                   />
// // //                 }
// // //                 label="PAN Card"
// // //               />

// // //               <FormControlLabel
// // //                 control={
// // //                   <Checkbox
// // //                     checked={
// // //                       formData.is_aadhar_card_submited
// // //                     }
// // //                     name="is_aadhar_card_submited"
// // //                     onChange={(e) =>
// // //                       handleChange(e, 'docs')
// // //                     }
// // //                     disabled={docsDisabled}
// // //                   />
// // //                 }
// // //                 label="Aadhar Card"
// // //               />

// // //               <FormControlLabel
// // //                 control={
// // //                   <Checkbox
// // //                     checked={
// // //                       formData.is_affidavit_submited
// // //                     }
// // //                     name="is_affidavit_submited"
// // //                     onChange={(e) =>
// // //                       handleChange(e, 'docs')
// // //                     }
// // //                     disabled={docsDisabled}
// // //                   />
// // //                 }
// // //                 label="Affidavit"
// // //               />

// // //               <Typography variant="body2">
// // //                 Download Affidavit Template:{' '}
// // //                 <Link
// // //                   href="https://splocamedia.s3.ap-south-1.amazonaws.com/templates/UN-FREEZE+THE+BANK+ACCOUNT.pdf"
// // //                   target="_blank"
// // //                 >
// // //                   Click here
// // //                 </Link>
// // //               </Typography>

// // //               <FormControlLabel
// // //                 control={
// // //                   <Checkbox
// // //                     checked={
// // //                       formData.is_bank_statement_submited
// // //                     }
// // //                     name="is_bank_statement_submited"
// // //                     onChange={(e) =>
// // //                       handleChange(e, 'docs')
// // //                     }
// // //                     disabled={docsDisabled}
// // //                   />
// // //                 }
// // //                 label="Bank Statement"
// // //               />
// // //             </Box>

// // //             <TextField
// // //               label="Current Address"
// // //               name="current_address"
// // //               value={formData.current_address}
// // //               onChange={(e) =>
// // //                 handleChange(e, 'docs')
// // //               }
// // //               fullWidth
// // //               multiline
// // //               rows={2}
// // //               size="small"
// // //               sx={{ mb: 2 }}
// // //             />

// // //             <TextField
// // //               label="Updated Mobile Number"
// // //               name="updated_mobile_number"
// // //               value={formData.updated_mobile_number}
// // //               onChange={(e) =>
// // //                 handleChange(e, 'docs')
// // //               }
// // //               fullWidth
// // //               size="small"
// // //               inputProps={{ maxLength: 10 }}
// // //               helperText="Enter 10 digit mobile number"
// // //             />

// // //             <Divider sx={{ my: 3 }} />

// // //             {/* PARTIAL UNFREEZE */}
// // //             <Typography variant="subtitle2" gutterBottom>
// // //               Partial Unfreeze
// // //             </Typography>

// // //             <FormControlLabel
// // //               control={
// // //                 <Checkbox
// // //                   checked={
// // //                     orderStatus.is_partial_un_freezing_order_submited
// // //                   }
// // //                   name="is_partial_un_freezing_order_submited"
// // //                   onChange={(e) =>
// // //                     handleChange(e, 'order')
// // //                   }
// // //                   disabled={
// // //                     !orderStatus.is_summons_issued
// // //                   }
// // //                 />
// // //               }
// // //               label="Partial Unfreeze Order Submitted"
// // //             />

// // //             <Typography variant="body2">
// // //               Template:{' '}
// // //               <Link
// // //                 href="https://splocamedia.s3.ap-south-1.amazonaws.com/templates/PARTIALLY+UN-FREEZE+THE+BANK+ACCOUNT.pdf"
// // //                 target="_blank"
// // //               >
// // //                 Click here
// // //               </Link>
// // //             </Typography>

// // //             <FormControlLabel
// // //               control={
// // //                 <Checkbox
// // //                   checked={
// // //                     orderStatus.is_partial_un_freezed
// // //                   }
// // //                   name="is_partial_un_freezed"
// // //                   onChange={(e) =>
// // //                     handleChange(e, 'order')
// // //                   }
// // //                   disabled={
// // //                     !orderStatus.is_partial_un_freezing_order_submited
// // //                   }
// // //                 />
// // //               }
// // //               label="Partially Unfreezed"
// // //             />

// // //             <Divider sx={{ my: 2 }} />

// // //             {/* FINAL DEFREEZE */}
// // //             <Typography variant="subtitle2" gutterBottom>
// // //               Final Defreeze
// // //             </Typography>

// // //             <FormControlLabel
// // //               control={
// // //                 <Checkbox
// // //                   checked={
// // //                     orderStatus.is_defreezing_order_submited
// // //                   }
// // //                   name="is_defreezing_order_submited"
// // //                   onChange={(e) =>
// // //                     handleChange(e, 'order')
// // //                   }
// // //                   disabled={
// // //                     !orderStatus.is_partial_un_freezed
// // //                   }
// // //                 />
// // //               }
// // //               label="Defreezing Order Submitted"
// // //             />

// // //             <Typography variant="body2">
// // //               Template:{' '}
// // //               <Link
// // //                 href="https://splocamedia.s3.ap-south-1.amazonaws.com/templates/UN-FREEZE+THE+BANK+ACCOUNT.pdf"
// // //                 target="_blank"
// // //               >
// // //                 Click here
// // //               </Link>
// // //             </Typography>

// // //             <FormControlLabel
// // //               control={
// // //                 <Checkbox
// // //                   checked={
// // //                     orderStatus.is_bank_defreezed
// // //                   }
// // //                   name="is_bank_defreezed"
// // //                   onChange={(e) =>
// // //                     handleChange(e, 'order')
// // //                   }
// // //                   disabled={
// // //                     !orderStatus.is_defreezing_order_submited
// // //                   }
// // //                 />
// // //               }
// // //               label="Bank Defreezed"
// // //             />
// // //           </Box>
// // //         </DialogContent>

// // //         <DialogActions>
// // //           <Button
// // //             onClick={onClose}
// // //             disabled={loading}
// // //           >
// // //             Cancel
// // //           </Button>

// // //           <Button
// // //             type="submit"
// // //             onClick={handleSubmit}
// // //             variant="contained"
// // //             disabled={loading}
// // //           >
// // //             {loading ? 'Saving...' : 'Save'}
// // //           </Button>
// // //         </DialogActions>
// // //       </Dialog>

// // //       {/* INSTALLMENT WARNING */}
// // //       <Dialog open={showInstallmentWarning}>
// // //         <DialogTitle>Warning</DialogTitle>

// // //         <DialogContent>
// // //           <Typography color="error">
// // //             Changing number of installments will
// // //             erase all existing installment data.
// // //             This action cannot be undone.
// // //           </Typography>
// // //         </DialogContent>

// // //         <DialogActions>
// // //           <Button onClick={cancelInstallmentChange}>
// // //             Cancel
// // //           </Button>

// // //           <Button
// // //             onClick={confirmInstallmentChange}
// // //             color="error"
// // //             variant="contained"
// // //           >
// // //             Proceed
// // //           </Button>
// // //         </DialogActions>
// // //       </Dialog>

// // //       <SnackBarComponent
// // //         open={snackbarOpen}
// // //         message={snackbarMessage}
// // //         severity={snackbarSeverity}
// // //         onClose={() => setSnackbarOpen(false)}
// // //       />
// // //     </>
// // //   );
// // // };

// // // export default DocsEditModal;



// // // import React, { useState, useEffect } from 'react';
// // // import {
// // //   Dialog,
// // //   DialogTitle,
// // //   DialogContent,
// // //   DialogActions,
// // //   Button,
// // //   Box,
// // //   Typography,
// // //   FormControlLabel,
// // //   Checkbox,
// // //   TextField,
// // //   Link,
// // //   Divider,
// // //   IconButton,
// // //   Tooltip,
// // // } from '@mui/material';
// // // import UploadFileIcon from '@mui/icons-material/UploadFile';
// // // import VisibilityIcon from '@mui/icons-material/Visibility';
// // // import api from '../../../api/axiosInterceptor';
// // // import { SnackBarComponent } from '../../../Components/snackBar/snackBar';

// // // const MAX_DOC_FILE_SIZE = 2 * 1024 * 1024; // 2 MB, matches backend limit

// // // // file input name -> (boolean field, link field, human label)
// // // const DOC_FILE_MAP = {
// // //   address_proof_file: {
// // //     boolField: 'is_address_proof_submited',
// // //     linkField: 'address_proof_link',
// // //     label: 'Address Proof',
// // //   },
// // //   pan_card_file: {
// // //     boolField: 'is_pan_card_submited',
// // //     linkField: 'pan_card_link',
// // //     label: 'PAN Card',
// // //   },
// // //   aadhar_card_file: {
// // //     boolField: 'is_aadhar_card_submited',
// // //     linkField: 'aadhar_card_link',
// // //     label: 'Aadhar Card',
// // //   },
// // //   affidavit_file: {
// // //     boolField: 'is_affidavit_submited',
// // //     linkField: 'affidavit_link',
// // //     label: 'Affidavit',
// // //   },
// // //   bank_statement_file: {
// // //     boolField: 'is_bank_statement_submited',
// // //     linkField: 'bank_statement_link',
// // //     label: 'Bank Statement',
// // //   },
// // // };

// // // const DocsEditModal = ({ open, onClose, excessId, refId, excessAmt }) => {
// // //   const [loading, setLoading] = useState(false);

// // //   const [snackbarOpen, setSnackbarOpen] = useState(false);
// // //   const [snackbarMessage, setSnackbarMessage] = useState('');
// // //   const [snackbarSeverity, setSnackbarSeverity] = useState('success');

// // //   // PAYMENT STATE
// // //   const [paymentData, setPaymentData] = useState({
// // //     is_agreed_to_pay: false,
// // //     is_not_agreed_to_pay: false,
// // //     agreed_amount: '',
// // //     no_of_installment: 0,
// // //     agree_remarks: '',
// // //   });

// // //   const [showInstallmentWarning, setShowInstallmentWarning] = useState(false);
// // //   const [pendingInstallmentValue, setPendingInstallmentValue] = useState('');

// // //   // DOCS — checkboxes + link fields returned from the server
// // //   const [formData, setFormData] = useState({
// // //     is_address_proof_submited: false,
// // //     address_proof_link: '',
// // //     is_pan_card_submited: false,
// // //     pan_card_link: '',
// // //     is_aadhar_card_submited: false,
// // //     aadhar_card_link: '',
// // //     is_affidavit_submited: false,
// // //     affidavit_link: '',
// // //     is_bank_statement_submited: false,
// // //     bank_statement_link: '',
// // //     current_address: '',
// // //     updated_mobile_number: '',
// // //   });

// // //   // DOCS — files staged for upload (not yet sent) keyed by the multipart field name
// // //   const [docFiles, setDocFiles] = useState({});

// // //   // ORDER
// // //   const [orderStatus, setOrderStatus] = useState({
// // //     is_freezing_order_issued: false,
// // //     is_bank_freezed: false,
// // //     is_summons_issued: false,
// // //     is_partial_un_freezing_order_submited: false,
// // //     is_partial_un_freezed: false,
// // //     is_defreezing_order_submited: false,
// // //     is_bank_defreezed: false,
// // //   });

// // //   // Fetch all data
// // //   const fetchAllData = async () => {
// // //     if (!excessId) return;

// // //     try {
// // //       setLoading(true);

// // //       const [docsRes, orderRes, paymentRes] = await Promise.all([
// // //         api.get(`/excess_payment_mgmt/excess-docs-updater/${excessId}/`),
// // //         api.get(`/excess_payment_mgmt/excess-order-updater/${excessId}/`),
// // //         api.get(`/excess_payment_mgmt/excess-payment-updater/${excessId}/`),
// // //       ]);

// // //       setFormData((prev) => ({ ...prev, ...docsRes.data }));
// // //       setDocFiles({});

// // //       setOrderStatus(orderRes.data);

// // //       setPaymentData({
// // //         is_agreed_to_pay: paymentRes.data.is_agreed_to_pay || false,
// // //         is_not_agreed_to_pay: paymentRes.data.is_not_agreed_to_pay || false,
// // //         agreed_amount: paymentRes.data.agreed_amount || '',
// // //         no_of_installment:
// // //           parseInt(paymentRes.data.no_of_installment, 10) || 0,
// // //         agree_remarks: paymentRes.data.agree_remarks || '',
// // //       });
// // //     } catch (err) {
// // //       setSnackbarMessage(
// // //         err.response?.data?.error || 'Failed to load data.'
// // //       );
// // //       setSnackbarSeverity('error');
// // //       setSnackbarOpen(true);
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   };

// // //   useEffect(() => {
// // //     if (open) {
// // //       fetchAllData();
// // //     }
// // //   }, [open, excessId]);

// // //   const showError = (message) => {
// // //     setSnackbarMessage(message);
// // //     setSnackbarSeverity('error');
// // //     setSnackbarOpen(true);
// // //   };

// // //   const handleChange = (e, section = 'docs') => {
// // //     const { name, value, checked, type } = e.target;

// // //     // Mobile validation
// // //     if (name === 'updated_mobile_number') {
// // //       if (!/^\d{0,10}$/.test(value)) return;
// // //     }

// // //     // =========================
// // //     // DOCS
// // //     // =========================
// // //     if (section === 'docs') {
// // //       setFormData((prev) => ({
// // //         ...prev,
// // //         [name]: type === 'checkbox' ? checked : value,
// // //       }));
// // //     }

// // //     // =========================
// // //     // ORDER STATUS
// // //     // =========================
// // //     else if (section === 'order') {
// // //       // REVERSE VALIDATIONS

// // //       // Cannot uncheck freezing if bank freezed checked
// // //       if (
// // //         name === 'is_freezing_order_issued' &&
// // //         !checked &&
// // //         orderStatus.is_bank_freezed
// // //       ) {
// // //         showError(
// // //           'Please uncheck "Bank Freezed" before unchecking "Freezing Order Issued".'
// // //         );
// // //         return;
// // //       }

// // //       // Cannot uncheck bank freezed if summons issued checked
// // //       if (
// // //         name === 'is_bank_freezed' &&
// // //         !checked &&
// // //         orderStatus.is_summons_issued
// // //       ) {
// // //         showError(
// // //           'Please uncheck "Summons Issued" before unchecking "Bank Freezed".'
// // //         );
// // //         return;
// // //       }

// // //       // Cannot uncheck summons if partial unfreeze submitted
// // //       if (
// // //         name === 'is_summons_issued' &&
// // //         !checked &&
// // //         orderStatus.is_partial_un_freezing_order_submited
// // //       ) {
// // //         showError(
// // //           'Please uncheck "Partial Unfreeze Order Submitted" before unchecking "Summons Issued".'
// // //         );
// // //         return;
// // //       }

// // //       // Cannot uncheck partial unfreeze submitted if partially unfreezed
// // //       if (
// // //         name === 'is_partial_un_freezing_order_submited' &&
// // //         !checked &&
// // //         orderStatus.is_partial_un_freezed
// // //       ) {
// // //         showError(
// // //           'Please uncheck "Partially Unfreezed" before unchecking "Partial Unfreeze Order Submitted".'
// // //         );
// // //         return;
// // //       }

// // //       // Cannot uncheck partially unfreezed if defreezing submitted
// // //       if (
// // //         name === 'is_partial_un_freezed' &&
// // //         !checked &&
// // //         orderStatus.is_defreezing_order_submited
// // //       ) {
// // //         showError(
// // //           'Please uncheck "Defreezing Order Submitted" before unchecking "Partially Unfreezed".'
// // //         );
// // //         return;
// // //       }

// // //       // Cannot uncheck defreezing submitted if bank defreezed
// // //       if (
// // //         name === 'is_defreezing_order_submited' &&
// // //         !checked &&
// // //         orderStatus.is_bank_defreezed
// // //       ) {
// // //         showError(
// // //           'Please uncheck "Bank Defreezed" before unchecking "Defreezing Order Submitted".'
// // //         );
// // //         return;
// // //       }

// // //       setOrderStatus((prev) => ({
// // //         ...prev,
// // //         [name]: checked,
// // //       }));
// // //     }

// // //     // =========================
// // //     // PAYMENT
// // //     // =========================
// // //     else if (section === 'payment') {
// // //       if (name === 'no_of_installment') {
// // //         setPendingInstallmentValue(value);
// // //         setShowInstallmentWarning(true);
// // //         return;
// // //       }

// // //       // Mutual exclusivity
// // //       if (name === 'is_agreed_to_pay' && checked) {
// // //         setPaymentData((prev) => ({
// // //           ...prev,
// // //           is_agreed_to_pay: true,
// // //           is_not_agreed_to_pay: false,
// // //         }));
// // //         return;
// // //       }

// // //       if (name === 'is_not_agreed_to_pay' && checked) {
// // //         setPaymentData((prev) => ({
// // //           ...prev,
// // //           is_not_agreed_to_pay: true,
// // //           is_agreed_to_pay: false,
// // //           agreed_amount: '',
// // //           no_of_installment: 0,
// // //         }));
// // //         return;
// // //       }

// // //       setPaymentData((prev) => ({
// // //         ...prev,
// // //         [name]: type === 'checkbox' ? checked : value,
// // //       }));
// // //     }
// // //   };

// // //   // ── Document file upload ────────────────────────────────────────────────
// // //   const handleDocFileChange = (fileFieldName) => (e) => {
// // //     const file = e.target.files?.[0];
// // //     if (!file) return;

// // //     if (file.size > MAX_DOC_FILE_SIZE) {
// // //       showError(`${DOC_FILE_MAP[fileFieldName].label} file must be under 2 MB.`);
// // //       return;
// // //     }

// // //     setDocFiles((prev) => ({ ...prev, [fileFieldName]: file }));

// // //     // Uploading a file always marks that document as submitted, matching
// // //     // the backend behaviour — reflect it immediately in the checkbox.
// // //     const { boolField } = DOC_FILE_MAP[fileFieldName];
// // //     setFormData((prev) => ({ ...prev, [boolField]: true }));
// // //   };

// // //   const confirmInstallmentChange = () => {
// // //     setPaymentData((prev) => ({
// // //       ...prev,
// // //       no_of_installment: parseInt(pendingInstallmentValue, 10) || 0,
// // //     }));

// // //     setPendingInstallmentValue('');
// // //     setShowInstallmentWarning(false);
// // //   };

// // //   const cancelInstallmentChange = () => {
// // //     setPendingInstallmentValue('');
// // //     setShowInstallmentWarning(false);
// // //   };

// // //   const buildDocsFormData = () => {
// // //     const fd = new FormData();
// // //     fd.append('current_address', formData.current_address || '');
// // //     fd.append('updated_mobile_number', formData.updated_mobile_number || '');
// // //     fd.append('is_address_proof_submited', formData.is_address_proof_submited);
// // //     fd.append('is_pan_card_submited', formData.is_pan_card_submited);
// // //     fd.append('is_aadhar_card_submited', formData.is_aadhar_card_submited);
// // //     fd.append('is_affidavit_submited', formData.is_affidavit_submited);
// // //     fd.append('is_bank_statement_submited', formData.is_bank_statement_submited);

// // //     Object.keys(DOC_FILE_MAP).forEach((fileFieldName) => {
// // //       const file = docFiles[fileFieldName];
// // //       if (file) fd.append(fileFieldName, file);
// // //     });

// // //     return fd;
// // //   };

// // //   const handleSubmit = async (e) => {
// // //     e.preventDefault();

// // //     if (!excessId) return;

// // //     // Validation: Agreed Amount should not exceed Excess Amount
// // //     if (paymentData.is_agreed_to_pay) {
// // //       const agreed = parseFloat(paymentData.agreed_amount || 0);
// // //       const maxAllowed = parseFloat(excessAmt || 0);

// // //       if (!Number.isFinite(agreed) || agreed < 0) {
// // //         setSnackbarMessage('Agreed Amount must be a valid non-negative number');
// // //         setSnackbarSeverity('error');
// // //         setSnackbarOpen(true);
// // //         return;
// // //       }

// // //       if (agreed > maxAllowed) {
// // //         setSnackbarMessage('Agreed Amount cannot exceed Excess Amount');
// // //         setSnackbarSeverity('error');
// // //         setSnackbarOpen(true);
// // //         return;
// // //       }
// // //     }

// // //     if (
// // //       formData.updated_mobile_number &&
// // //       formData.updated_mobile_number.length !== 10
// // //     ) {
// // //       setSnackbarMessage('Mobile number must be exactly 10 digits');
// // //       setSnackbarSeverity('error');
// // //       setSnackbarOpen(true);
// // //       return;
// // //     }

// // //     let payloadPayment = { ...paymentData };

// // //     if (!paymentData.is_agreed_to_pay) {
// // //       payloadPayment = {
// // //         is_agreed_to_pay: false,
// // //         is_not_agreed_to_pay: true,
// // //         agreed_amount: null,
// // //         no_of_installment: 0,
// // //         agree_remarks: paymentData.agree_remarks || '',
// // //       };
// // //     }

// // //     setLoading(true);

// // //     try {
// // //       await Promise.all([
// // //         api.patch(
// // //           `/excess_payment_mgmt/excess-docs-updater/${excessId}/`,
// // //           buildDocsFormData(),
// // //           { headers: { 'Content-Type': 'multipart/form-data' } }
// // //         ),

// // //         api.patch(
// // //           `/excess_payment_mgmt/excess-order-updater/${excessId}/`,
// // //           orderStatus
// // //         ),

// // //         api.patch(
// // //           `/excess_payment_mgmt/excess-payment-updater/${excessId}/`,
// // //           payloadPayment
// // //         ),
// // //       ]);

// // //       await fetchAllData();

// // //       setSnackbarMessage('Updated Successfully');
// // //       setSnackbarSeverity('success');
// // //       setSnackbarOpen(true);

// // //       setTimeout(() => onClose(), 1000);
// // //     } catch (err) {
// // //       setSnackbarMessage(
// // //         err.response?.data?.error ||
// // //           err.response?.data?.message ||
// // //           'Failed to update.'
// // //       );

// // //       setSnackbarSeverity('error');
// // //       setSnackbarOpen(true);
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   };

// // //   const docsDisabled = !orderStatus.is_summons_issued;

// // //   // Small reusable row: checkbox + upload button + view link
// // //   const DocUploadRow = ({ fileFieldName, checkboxLabel }) => {
// // //     const { boolField, linkField } = DOC_FILE_MAP[fileFieldName];
// // //     const stagedFile = docFiles[fileFieldName];
// // //     const existingLink = formData[linkField];

// // //     return (
// // //       <Box
// // //         display="flex"
// // //         alignItems="center"
// // //         flexWrap="wrap"
// // //         gap={1}
// // //         sx={{ py: 0.5 }}
// // //       >
// // //         <FormControlLabel
// // //           sx={{ minWidth: 200 }}
// // //           control={
// // //             <Checkbox
// // //               checked={formData[boolField]}
// // //               name={boolField}
// // //               onChange={(e) => handleChange(e, 'docs')}
// // //               disabled={docsDisabled}
// // //             />
// // //           }
// // //           label={checkboxLabel}
// // //         />

// // //         <Tooltip title={docsDisabled ? 'Enable Summons Issued first' : 'Upload file (max 2 MB)'}>
// // //           <span>
// // //             <Button
// // //               size="small"
// // //               variant="outlined"
// // //               component="label"
// // //               startIcon={<UploadFileIcon fontSize="small" />}
// // //               disabled={docsDisabled}
// // //             >
// // //               {stagedFile ? stagedFile.name : 'Upload'}
// // //               <input
// // //                 type="file"
// // //                 hidden
// // //                 accept=".pdf,.jpg,.jpeg,.png"
// // //                 onChange={handleDocFileChange(fileFieldName)}
// // //               />
// // //             </Button>
// // //           </span>
// // //         </Tooltip>

// // //         {existingLink && (
// // //           <Tooltip title="View uploaded file">
// // //             <IconButton
// // //               size="small"
// // //               component={Link}
// // //               href={existingLink}
// // //               target="_blank"
// // //               rel="noopener"
// // //             >
// // //               <VisibilityIcon fontSize="small" />
// // //             </IconButton>
// // //           </Tooltip>
// // //         )}
// // //       </Box>
// // //     );
// // //   };

// // //   return (
// // //     <>
// // //       <Dialog
// // //         open={open}
// // //         onClose={onClose}
// // //         maxWidth="md"
// // //         fullWidth
// // //         disableEscapeKeyDown
// // //        >
// // //         <DialogTitle>
// // //           Edit Document & Order Status 1
// // //         </DialogTitle>

// // //         <DialogContent>
// // //           <Box component="form" onSubmit={handleSubmit} p={2}>
// // //             {/* REFERENCE ID */}
// // //             <Typography variant="subtitle2" gutterBottom>
// // //               Reference ID:{' '}
// // //               <Box
// // //                 component="span"
// // //                 sx={{
// // //                   backgroundColor: '#1976d2',
// // //                   color: '#fff',
// // //                   px: 1.5,
// // //                   py: 0.5,
// // //                   borderRadius: 1,
// // //                   fontWeight: 600,
// // //                   fontSize: '0.85rem',
// // //                 }}
// // //               >
// // //                 {refId}
// // //               </Box>
// // //             </Typography>

// // //             {/* EXCESS AMOUNT */}
// // //             <Typography variant="subtitle2" gutterBottom>
// // //               Excess Amount:{' '}
// // //               <Box
// // //                 component="span"
// // //                 sx={{
// // //                   backgroundColor: '#2e7d32',
// // //                   color: '#fff',
// // //                   px: 1.5,
// // //                   py: 0.5,
// // //                   borderRadius: 1,
// // //                   fontWeight: 600,
// // //                   fontSize: '0.85rem',
// // //                 }}
// // //               >
// // //                 ₹ {excessAmt || 0}
// // //               </Box>
// // //             </Typography>

// // //             <Typography
// // //               variant="body2"
// // //               sx={{
// // //                 color: '#8B0000',
// // //                 fontWeight: 600,
// // //                 mb: 2,
// // //               }}
// // //             >
// // //               Please add Reference Id on Hard copy
// // //             </Typography>

// // //             {/* ORDER STATUS */}
// // //             <Typography variant="subtitle2" gutterBottom>
// // //               Order Status
// // //             </Typography>

// // //             <FormControlLabel
// // //               control={
// // //                 <Checkbox
// // //                   checked={orderStatus.is_freezing_order_issued}
// // //                   name="is_freezing_order_issued"
// // //                   onChange={(e) =>
// // //                     handleChange(e, 'order')
// // //                   }
// // //                 />
// // //               }
// // //               label="Freezing Order Issued"
// // //             />

// // //             <FormControlLabel
// // //               control={
// // //                 <Checkbox
// // //                   checked={orderStatus.is_bank_freezed}
// // //                   name="is_bank_freezed"
// // //                   disabled={
// // //                     !orderStatus.is_freezing_order_issued
// // //                   }
// // //                   onChange={(e) =>
// // //                     handleChange(e, 'order')
// // //                   }
// // //                 />
// // //               }
// // //               label="Bank Freezed"
// // //             />

// // //             <FormControlLabel
// // //               control={
// // //                 <Checkbox
// // //                   checked={orderStatus.is_summons_issued}
// // //                   name="is_summons_issued"
// // //                   disabled={!orderStatus.is_bank_freezed}
// // //                   onChange={(e) =>
// // //                     handleChange(e, 'order')
// // //                   }
// // //                 />
// // //               }
// // //               label="Summons Issued"
// // //             />

// // //             <Divider sx={{ my: 2 }} />

// // //             {/* PAYMENT */}
// // //             <Typography variant="subtitle2" gutterBottom>
// // //               Payment Agreement
// // //             </Typography>

// // //             <FormControlLabel
// // //               control={
// // //                 <Checkbox
// // //                   checked={paymentData.is_agreed_to_pay}
// // //                   name="is_agreed_to_pay"
// // //                   disabled={!orderStatus.is_summons_issued}
// // //                   onChange={(e) =>
// // //                     handleChange(e, 'payment')
// // //                   }
// // //                 />
// // //               }
// // //               label="Agreed to Pay"
// // //             />

// // //             <FormControlLabel
// // //               control={
// // //                 <Checkbox
// // //                   checked={
// // //                     paymentData.is_not_agreed_to_pay
// // //                   }
// // //                   name="is_not_agreed_to_pay"
// // //                   disabled={!orderStatus.is_summons_issued}
// // //                   onChange={(e) =>
// // //                     handleChange(e, 'payment')
// // //                   }
// // //                 />
// // //               }
// // //               label="Not Agreed to Pay"
// // //             />

// // //             {paymentData.is_agreed_to_pay &&
// // //             !paymentData.is_not_agreed_to_pay ? (
// // //               <>
// // //                 <TextField
// // //                   label="Agreed Amount"
// // //                   type="number"
// // //                   name="agreed_amount"
// // //                   value={paymentData.agreed_amount}
// // //                   onChange={(e) =>
// // //                     handleChange(e, 'payment')
// // //                   }
// // //                   fullWidth
// // //                   size="small"
// // //                   sx={{ mt: 2 }}
// // //                 />

// // //                 <TextField
// // //                   label="No of Installments"
// // //                   type="number"
// // //                   name="no_of_installment"
// // //                   value={
// // //                     paymentData.no_of_installment
// // //                   }
// // //                   onChange={(e) =>
// // //                     handleChange(e, 'payment')
// // //                   }
// // //                   fullWidth
// // //                   size="small"
// // //                   sx={{ mt: 2 }}
// // //                 />
// // //               </>
// // //             ) : null}

// // //             <TextField
// // //               label="Additional Remarks"
// // //               name="agree_remarks"
// // //               value={paymentData.agree_remarks}
// // //               onChange={(e) =>
// // //                 handleChange(e, 'payment')
// // //               }
// // //               fullWidth
// // //               multiline
// // //               rows={2}
// // //               size="small"
// // //               sx={{ mt: 2 }}
// // //             />

// // //             <Divider sx={{ my: 2 }} />

// // //             {/* DOCS */}
// // //             <Typography variant="subtitle2" gutterBottom>
// // //               Proof of Submission
// // //             </Typography>
// // //             <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
// // //               Uploading a file automatically marks that document as submitted.
// // //               PDF/JPG/PNG, max 2 MB each.
// // //             </Typography>

// // //             <Box display="flex" flexDirection="column" mb={2}>
// // //               <DocUploadRow fileFieldName="address_proof_file" checkboxLabel="Address Proof" />
// // //               <DocUploadRow fileFieldName="pan_card_file" checkboxLabel="PAN Card" />
// // //               <DocUploadRow fileFieldName="aadhar_card_file" checkboxLabel="Aadhar Card" />

// // //               <Box sx={{ pl: 0.5, py: 0.5 }}>
// // //                 <DocUploadRow fileFieldName="affidavit_file" checkboxLabel="Affidavit" />
// // //                 <Typography variant="body2" sx={{ pl: 4 }}>
// // //                   Download Affidavit Template:{' '}
// // //                   <Link
// // //                     href="https://splocamedia.s3.ap-south-1.amazonaws.com/templates/UN-FREEZE+THE+BANK+ACCOUNT.pdf"
// // //                     target="_blank"
// // //                   >
// // //                     Click here
// // //                   </Link>
// // //                 </Typography>
// // //               </Box>

// // //               <DocUploadRow fileFieldName="bank_statement_file" checkboxLabel="Bank Statement" />
// // //             </Box>

// // //             <TextField
// // //               label="Current Address"
// // //               name="current_address"
// // //               value={formData.current_address}
// // //               onChange={(e) =>
// // //                 handleChange(e, 'docs')
// // //               }
// // //               fullWidth
// // //               multiline
// // //               rows={2}
// // //               size="small"
// // //               sx={{ mb: 2 }}
// // //             />

// // //             <TextField
// // //               label="Updated Mobile Number"
// // //               name="updated_mobile_number"
// // //               value={formData.updated_mobile_number}
// // //               onChange={(e) =>
// // //                 handleChange(e, 'docs')
// // //               }
// // //               fullWidth
// // //               size="small"
// // //               inputProps={{ maxLength: 10 }}
// // //               helperText="Enter 10 digit mobile number"
// // //             />

// // //             <Divider sx={{ my: 3 }} />

// // //             {/* PARTIAL UNFREEZE */}
// // //             <Typography variant="subtitle2" gutterBottom>
// // //               Partial Unfreeze
// // //             </Typography>

// // //             <FormControlLabel
// // //               control={
// // //                 <Checkbox
// // //                   checked={
// // //                     orderStatus.is_partial_un_freezing_order_submited
// // //                   }
// // //                   name="is_partial_un_freezing_order_submited"
// // //                   onChange={(e) =>
// // //                     handleChange(e, 'order')
// // //                   }
// // //                   disabled={
// // //                     !orderStatus.is_summons_issued
// // //                   }
// // //                 />
// // //               }
// // //               label="Partial Unfreeze Order Submitted"
// // //             />

// // //             <Typography variant="body2">
// // //               Template:{' '}
// // //               <Link
// // //                 href="https://splocamedia.s3.ap-south-1.amazonaws.com/templates/PARTIALLY+UN-FREEZE+THE+BANK+ACCOUNT.pdf"
// // //                 target="_blank"
// // //               >
// // //                 Click here
// // //               </Link>
// // //             </Typography>

// // //             <FormControlLabel
// // //               control={
// // //                 <Checkbox
// // //                   checked={
// // //                     orderStatus.is_partial_un_freezed
// // //                   }
// // //                   name="is_partial_un_freezed"
// // //                   onChange={(e) =>
// // //                     handleChange(e, 'order')
// // //                   }
// // //                   disabled={
// // //                     !orderStatus.is_partial_un_freezing_order_submited
// // //                   }
// // //                 />
// // //               }
// // //               label="Partially Unfreezed"
// // //             />

// // //             <Divider sx={{ my: 2 }} />

// // //             {/* FINAL DEFREEZE */}
// // //             <Typography variant="subtitle2" gutterBottom>
// // //               Final Defreeze
// // //             </Typography>

// // //             <FormControlLabel
// // //               control={
// // //                 <Checkbox
// // //                   checked={
// // //                     orderStatus.is_defreezing_order_submited
// // //                   }
// // //                   name="is_defreezing_order_submited"
// // //                   onChange={(e) =>
// // //                     handleChange(e, 'order')
// // //                   }
// // //                   disabled={
// // //                     !orderStatus.is_partial_un_freezed
// // //                   }
// // //                 />
// // //               }
// // //               label="Defreezing Order Submitted"
// // //             />

// // //             <Typography variant="body2">
// // //               Template:{' '}
// // //               <Link
// // //                 href="https://splocamedia.s3.ap-south-1.amazonaws.com/templates/UN-FREEZE+THE+BANK+ACCOUNT.pdf"
// // //                 target="_blank"
// // //               >
// // //                 Click here
// // //               </Link>
// // //             </Typography>

// // //             <FormControlLabel
// // //               control={
// // //                 <Checkbox
// // //                   checked={
// // //                     orderStatus.is_bank_defreezed
// // //                   }
// // //                   name="is_bank_defreezed"
// // //                   onChange={(e) =>
// // //                     handleChange(e, 'order')
// // //                   }
// // //                   disabled={
// // //                     !orderStatus.is_defreezing_order_submited
// // //                   }
// // //                 />
// // //               }
// // //               label="Bank Defreezed"
// // //             />
// // //           </Box>
// // //         </DialogContent>

// // //         <DialogActions>
// // //           <Button
// // //             onClick={onClose}
// // //             disabled={loading}
// // //           >
// // //             Cancel
// // //           </Button>

// // //           <Button
// // //             type="submit"
// // //             onClick={handleSubmit}
// // //             variant="contained"
// // //             disabled={loading}
// // //           >
// // //             {loading ? 'Saving...' : 'Save'}
// // //           </Button>
// // //         </DialogActions>
// // //       </Dialog>

// // //       {/* INSTALLMENT WARNING */}
// // //       <Dialog open={showInstallmentWarning}>
// // //         <DialogTitle>Warning</DialogTitle>

// // //         <DialogContent>
// // //           <Typography color="error">
// // //             Changing number of installments will
// // //             erase all existing installment data.
// // //             This action cannot be undone.
// // //           </Typography>
// // //         </DialogContent>

// // //         <DialogActions>
// // //           <Button onClick={cancelInstallmentChange}>
// // //             Cancel
// // //           </Button>

// // //           <Button
// // //             onClick={confirmInstallmentChange}
// // //             color="error"
// // //             variant="contained"
// // //           >
// // //             Proceed
// // //           </Button>
// // //         </DialogActions>
// // //       </Dialog>

// // //       <SnackBarComponent
// // //         open={snackbarOpen}
// // //         message={snackbarMessage}
// // //         severity={snackbarSeverity}
// // //         onClose={() => setSnackbarOpen(false)}
// // //       />
// // //     </>
// // //   );
// // // };

// // // export default DocsEditModal;



// // import React, { useState, useEffect } from 'react';
// // import {
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   DialogActions,
// //   Button,
// //   Box,
// //   Typography,
// //   FormControlLabel,
// //   Checkbox,
// //   TextField,
// //   Link,
// //   Divider,
// //   IconButton,
// //   Tooltip,
// //   FormControl,
// //   InputLabel,
// //   Select,
// //   MenuItem,
// // } from '@mui/material';
// // import UploadFileIcon from '@mui/icons-material/UploadFile';
// // import VisibilityIcon from '@mui/icons-material/Visibility';
// // import api from '../../../api/axiosInterceptor';
// // import { SnackBarComponent } from '../../../Components/snackBar/snackBar';
// // import { DELIVERY_STATUS_OPTIONS } from './workflowApi';

// // const MAX_DOC_FILE_SIZE = 5 * 1024 * 1024; // 5 MB, matches backend limit

// // // file input name -> (boolean field, link field, human label)
// // const DOC_FILE_MAP = {
// //   address_proof_file: {
// //     boolField: 'is_address_proof_submited',
// //     linkField: 'address_proof_link',
// //     label: 'Address Proof',
// //   },
// //   pan_card_file: {
// //     boolField: 'is_pan_card_submited',
// //     linkField: 'pan_card_link',
// //     label: 'PAN Card',
// //   },
// //   aadhar_card_file: {
// //     boolField: 'is_aadhar_card_submited',
// //     linkField: 'aadhar_card_link',
// //     label: 'Aadhar Card',
// //   },
// //   affidavit_file: {
// //     boolField: 'is_affidavit_submited',
// //     linkField: 'affidavit_link',
// //     label: 'Affidavit',
// //   },
// //   bank_statement_file: {
// //     boolField: 'is_bank_statement_submited',
// //     linkField: 'bank_statement_link',
// //     label: 'Bank Statement',
// //   },
// // };

// // const DocsEditModal = ({ open, onClose, excessId, refId, excessAmt }) => {
// //   const [loading, setLoading] = useState(false);

// //   const [snackbarOpen, setSnackbarOpen] = useState(false);
// //   const [snackbarMessage, setSnackbarMessage] = useState('');
// //   const [snackbarSeverity, setSnackbarSeverity] = useState('success');

// //   // PAYMENT STATE
// //   const [paymentData, setPaymentData] = useState({
// //     is_agreed_to_pay: false,
// //     is_not_agreed_to_pay: false,
// //     agreed_amount: '',
// //     no_of_installment: 0,
// //     agree_remarks: '',
// //   });

// //   const [showInstallmentWarning, setShowInstallmentWarning] = useState(false);
// //   const [pendingInstallmentValue, setPendingInstallmentValue] = useState('');

// //   // DOCS — checkboxes + link fields returned from the server
// //   const [formData, setFormData] = useState({
// //     is_address_proof_submited: false,
// //     address_proof_link: '',
// //     is_pan_card_submited: false,
// //     pan_card_link: '',
// //     is_aadhar_card_submited: false,
// //     aadhar_card_link: '',
// //     is_affidavit_submited: false,
// //     affidavit_link: '',
// //     is_bank_statement_submited: false,
// //     bank_statement_link: '',
// //     current_address: '',
// //     updated_mobile_number: '',
// //   });

// //   // DOCS — files staged for upload (not yet sent) keyed by the multipart field name
// //   const [docFiles, setDocFiles] = useState({});

// //   // ORDER
// //   const [orderStatus, setOrderStatus] = useState({
// //     is_freezing_order_delivered: 'waiting',
// //     is_freezing_order_issued: false,
// //     is_bank_freezed: false,
// //     is_summons_delivered: 'waiting',
// //     is_summons_issued: false,
// //     is_partial_un_freezing_order_submited: false,
// //     is_partial_un_freezed: false,
// //     is_defreezing_order_submited: false,
// //     is_bank_defreezed: false,
// //   });

// //   // Fetch all data
// //   const fetchAllData = async () => {
// //     if (!excessId) return;

// //     try {
// //       setLoading(true);

// //       const [docsRes, orderRes, paymentRes] = await Promise.all([
// //         api.get(`/excess_payment_mgmt/excess-docs-updater/${excessId}/`),
// //         api.get(`/excess_payment_mgmt/excess-order-updater/${excessId}/`),
// //         api.get(`/excess_payment_mgmt/excess-payment-updater/${excessId}/`),
// //       ]);

// //       setFormData((prev) => ({ ...prev, ...docsRes.data }));
// //       setDocFiles({});

// //       setOrderStatus(orderRes.data);

// //       setPaymentData({
// //         is_agreed_to_pay: paymentRes.data.is_agreed_to_pay || false,
// //         is_not_agreed_to_pay: paymentRes.data.is_not_agreed_to_pay || false,
// //         agreed_amount: paymentRes.data.agreed_amount || '',
// //         no_of_installment:
// //           parseInt(paymentRes.data.no_of_installment, 10) || 0,
// //         agree_remarks: paymentRes.data.agree_remarks || '',
// //       });
// //     } catch (err) {
// //       setSnackbarMessage(
// //         err.response?.data?.error || 'Failed to load data.'
// //       );
// //       setSnackbarSeverity('error');
// //       setSnackbarOpen(true);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     if (open) {
// //       fetchAllData();
// //     }
// //   }, [open, excessId]);

// //   const showError = (message) => {
// //     setSnackbarMessage(message);
// //     setSnackbarSeverity('error');
// //     setSnackbarOpen(true);
// //   };

// //   const handleChange = (e, section = 'docs') => {
// //     const { name, value, checked, type } = e.target;

// //     // Mobile validation
// //     if (name === 'updated_mobile_number') {
// //       if (!/^\d{0,10}$/.test(value)) return;
// //     }

// //     // =========================
// //     // DOCS
// //     // =========================
// //     if (section === 'docs') {
// //       setFormData((prev) => ({
// //         ...prev,
// //         [name]: type === 'checkbox' ? checked : value,
// //       }));
// //     }

// //     // =========================
// //     // ORDER STATUS
// //     // =========================
// //     else if (section === 'order') {
// //       // Freezing Order and Summons are now dropdowns (waiting / Delivered /
// //       // Returned to office) instead of checkboxes. The plain "issued"
// //       // booleans are derived automatically — true once the value moves off
// //       // "waiting" — same rule the backend applies.
// //       if (name === 'is_freezing_order_delivered') {
// //         if (value === 'waiting' && orderStatus.is_bank_freezed) {
// //           showError('Please undo "Bank Freezed" before resetting Freezing Order to "waiting".');
// //           return;
// //         }
// //         setOrderStatus((prev) => ({
// //           ...prev,
// //           is_freezing_order_delivered: value,
// //           is_freezing_order_issued: value !== 'waiting',
// //         }));
// //         return;
// //       }

// //       if (name === 'is_summons_delivered') {
// //         if (value === 'waiting' && orderStatus.is_partial_un_freezing_order_submited) {
// //           showError('Please undo "Partial Unfreeze Order Submitted" before resetting Summons to "waiting".');
// //           return;
// //         }
// //         setOrderStatus((prev) => ({
// //           ...prev,
// //           is_summons_delivered: value,
// //           is_summons_issued: value !== 'waiting',
// //         }));
// //         return;
// //       }

// //       // REVERSE VALIDATIONS (remaining checkbox fields)

// //       // Cannot uncheck bank freezed if summons issued
// //       if (
// //         name === 'is_bank_freezed' &&
// //         !checked &&
// //         orderStatus.is_summons_issued
// //       ) {
// //         showError(
// //           'Please reset "Summons" to waiting before unchecking "Bank Freezed".'
// //         );
// //         return;
// //       }

// //       // Cannot uncheck partial unfreeze submitted if partially unfreezed
// //       if (
// //         name === 'is_partial_un_freezing_order_submited' &&
// //         !checked &&
// //         orderStatus.is_partial_un_freezed
// //       ) {
// //         showError(
// //           'Please uncheck "Partially Unfreezed" before unchecking "Partial Unfreeze Order Submitted".'
// //         );
// //         return;
// //       }

// //       // Cannot uncheck partially unfreezed if defreezing submitted
// //       if (
// //         name === 'is_partial_un_freezed' &&
// //         !checked &&
// //         orderStatus.is_defreezing_order_submited
// //       ) {
// //         showError(
// //           'Please uncheck "Defreezing Order Submitted" before unchecking "Partially Unfreezed".'
// //         );
// //         return;
// //       }

// //       // Cannot uncheck defreezing submitted if bank defreezed
// //       if (
// //         name === 'is_defreezing_order_submited' &&
// //         !checked &&
// //         orderStatus.is_bank_defreezed
// //       ) {
// //         showError(
// //           'Please uncheck "Bank Defreezed" before unchecking "Defreezing Order Submitted".'
// //         );
// //         return;
// //       }

// //       setOrderStatus((prev) => ({
// //         ...prev,
// //         [name]: checked,
// //       }));
// //     }

// //     // =========================
// //     // PAYMENT
// //     // =========================
// //     else if (section === 'payment') {
// //       if (name === 'no_of_installment') {
// //         setPendingInstallmentValue(value);
// //         setShowInstallmentWarning(true);
// //         return;
// //       }

// //       // Mutual exclusivity
// //       if (name === 'is_agreed_to_pay' && checked) {
// //         setPaymentData((prev) => ({
// //           ...prev,
// //           is_agreed_to_pay: true,
// //           is_not_agreed_to_pay: false,
// //         }));
// //         return;
// //       }

// //       if (name === 'is_not_agreed_to_pay' && checked) {
// //         setPaymentData((prev) => ({
// //           ...prev,
// //           is_not_agreed_to_pay: true,
// //           is_agreed_to_pay: false,
// //           agreed_amount: '',
// //           no_of_installment: 0,
// //         }));
// //         return;
// //       }

// //       setPaymentData((prev) => ({
// //         ...prev,
// //         [name]: type === 'checkbox' ? checked : value,
// //       }));
// //     }
// //   };

// //   // ── Document file upload ────────────────────────────────────────────────
// //   const handleDocFileChange = (fileFieldName) => (e) => {
// //     const file = e.target.files?.[0];
// //     if (!file) return;

// //     if (file.size > MAX_DOC_FILE_SIZE) {
// //       showError(`${DOC_FILE_MAP[fileFieldName].label} file must be under 5 MB.`);
// //       return;
// //     }

// //     setDocFiles((prev) => ({ ...prev, [fileFieldName]: file }));

// //     // Uploading a file always marks that document as submitted, matching
// //     // the backend behaviour — reflect it immediately in the checkbox.
// //     const { boolField } = DOC_FILE_MAP[fileFieldName];
// //     setFormData((prev) => ({ ...prev, [boolField]: true }));
// //   };

// //   const confirmInstallmentChange = () => {
// //     setPaymentData((prev) => ({
// //       ...prev,
// //       no_of_installment: parseInt(pendingInstallmentValue, 10) || 0,
// //     }));

// //     setPendingInstallmentValue('');
// //     setShowInstallmentWarning(false);
// //   };

// //   const cancelInstallmentChange = () => {
// //     setPendingInstallmentValue('');
// //     setShowInstallmentWarning(false);
// //   };

// //   const buildDocsFormData = () => {
// //     const fd = new FormData();
// //     fd.append('current_address', formData.current_address || '');
// //     fd.append('updated_mobile_number', formData.updated_mobile_number || '');
// //     fd.append('is_address_proof_submited', formData.is_address_proof_submited);
// //     fd.append('is_pan_card_submited', formData.is_pan_card_submited);
// //     fd.append('is_aadhar_card_submited', formData.is_aadhar_card_submited);
// //     fd.append('is_affidavit_submited', formData.is_affidavit_submited);
// //     fd.append('is_bank_statement_submited', formData.is_bank_statement_submited);

// //     Object.keys(DOC_FILE_MAP).forEach((fileFieldName) => {
// //       const file = docFiles[fileFieldName];
// //       if (file) fd.append(fileFieldName, file);
// //     });

// //     return fd;
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();

// //     if (!excessId) return;

// //     // Validation: Agreed Amount should not exceed Excess Amount
// //     if (paymentData.is_agreed_to_pay) {
// //       const agreed = parseFloat(paymentData.agreed_amount || 0);
// //       const maxAllowed = parseFloat(excessAmt || 0);

// //       if (!Number.isFinite(agreed) || agreed < 0) {
// //         setSnackbarMessage('Agreed Amount must be a valid non-negative number');
// //         setSnackbarSeverity('error');
// //         setSnackbarOpen(true);
// //         return;
// //       }

// //       if (agreed > maxAllowed) {
// //         setSnackbarMessage('Agreed Amount cannot exceed Excess Amount');
// //         setSnackbarSeverity('error');
// //         setSnackbarOpen(true);
// //         return;
// //       }
// //     }

// //     if (
// //       formData.updated_mobile_number &&
// //       formData.updated_mobile_number.length !== 10
// //     ) {
// //       setSnackbarMessage('Mobile number must be exactly 10 digits');
// //       setSnackbarSeverity('error');
// //       setSnackbarOpen(true);
// //       return;
// //     }

// //     let payloadPayment = { ...paymentData };

// //     if (!paymentData.is_agreed_to_pay) {
// //       payloadPayment = {
// //         is_agreed_to_pay: false,
// //         is_not_agreed_to_pay: true,
// //         agreed_amount: null,
// //         no_of_installment: 0,
// //         agree_remarks: paymentData.agree_remarks || '',
// //       };
// //     }

// //     setLoading(true);

// //     try {
// //       await Promise.all([
// //         api.patch(
// //           `/excess_payment_mgmt/excess-docs-updater/${excessId}/`,
// //           buildDocsFormData(),
// //           { headers: { 'Content-Type': 'multipart/form-data' } }
// //         ),

// //         api.patch(
// //           `/excess_payment_mgmt/excess-order-updater/${excessId}/`,
// //           orderStatus
// //         ),

// //         api.patch(
// //           `/excess_payment_mgmt/excess-payment-updater/${excessId}/`,
// //           payloadPayment
// //         ),
// //       ]);

// //       await fetchAllData();

// //       setSnackbarMessage('Updated Successfully');
// //       setSnackbarSeverity('success');
// //       setSnackbarOpen(true);

// //       setTimeout(() => onClose(), 1000);
// //     } catch (err) {
// //       setSnackbarMessage(
// //         err.response?.data?.error ||
// //           err.response?.data?.message ||
// //           'Failed to update.'
// //       );

// //       setSnackbarSeverity('error');
// //       setSnackbarOpen(true);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const docsDisabled = !orderStatus.is_summons_issued;

// //   // Small reusable row: checkbox + upload button + view link
// //   const DocUploadRow = ({ fileFieldName, checkboxLabel }) => {
// //     const { boolField, linkField } = DOC_FILE_MAP[fileFieldName];
// //     const stagedFile = docFiles[fileFieldName];
// //     const existingLink = formData[linkField];

// //     return (
// //       <Box
// //         display="flex"
// //         alignItems="center"
// //         flexWrap="wrap"
// //         gap={1}
// //         sx={{ py: 0.5 }}
// //       >
// //         <FormControlLabel
// //           sx={{ minWidth: 200 }}
// //           control={
// //             <Checkbox
// //               checked={formData[boolField]}
// //               name={boolField}
// //               onChange={(e) => handleChange(e, 'docs')}
// //               disabled={docsDisabled}
// //             />
// //           }
// //           label={checkboxLabel}
// //         />

// //         <Tooltip title={docsDisabled ? 'Enable Summons Issued first' : 'Upload file (max 5 MB)'}>
// //           <span>
// //             <Button
// //               size="small"
// //               variant="outlined"
// //               component="label"
// //               startIcon={<UploadFileIcon fontSize="small" />}
// //               disabled={docsDisabled}
// //             >
// //               {stagedFile ? stagedFile.name : 'Upload'}
// //               <input
// //                 type="file"
// //                 hidden
// //                 accept=".pdf,.jpg,.jpeg,.png"
// //                 onChange={handleDocFileChange(fileFieldName)}
// //               />
// //             </Button>
// //           </span>
// //         </Tooltip>

// //         {existingLink && (
// //           <Tooltip title="View uploaded file">
// //             <IconButton
// //               size="small"
// //               component={Link}
// //               href={existingLink}
// //               target="_blank"
// //               rel="noopener"
// //             >
// //               <VisibilityIcon fontSize="small" />
// //             </IconButton>
// //           </Tooltip>
// //         )}
// //       </Box>
// //     );
// //   };

// //   return (
// //     <>
// //       <Dialog
// //         open={open}
// //         onClose={onClose}
// //         maxWidth="md"
// //         fullWidth
// //         disableEscapeKeyDown
// //        >
// //         <DialogTitle>
// //           Edit Document & Order Status
// //         </DialogTitle>

// //         <DialogContent>
// //           <Box component="form" onSubmit={handleSubmit} p={2}>
// //             {/* REFERENCE ID */}
// //             <Typography variant="subtitle2" gutterBottom>
// //               Reference ID:{' '}
// //               <Box
// //                 component="span"
// //                 sx={{
// //                   backgroundColor: '#1976d2',
// //                   color: '#fff',
// //                   px: 1.5,
// //                   py: 0.5,
// //                   borderRadius: 1,
// //                   fontWeight: 600,
// //                   fontSize: '0.85rem',
// //                 }}
// //               >
// //                 {refId}
// //               </Box>
// //             </Typography>

// //             {/* EXCESS AMOUNT */}
// //             <Typography variant="subtitle2" gutterBottom>
// //               Excess Amount:{' '}
// //               <Box
// //                 component="span"
// //                 sx={{
// //                   backgroundColor: '#2e7d32',
// //                   color: '#fff',
// //                   px: 1.5,
// //                   py: 0.5,
// //                   borderRadius: 1,
// //                   fontWeight: 600,
// //                   fontSize: '0.85rem',
// //                 }}
// //               >
// //                 ₹ {excessAmt || 0}
// //               </Box>
// //             </Typography>

// //             <Typography
// //               variant="body2"
// //               sx={{
// //                 color: '#8B0000',
// //                 fontWeight: 600,
// //                 mb: 2,
// //               }}
// //             >
// //               Please add Reference Id on Hard copy
// //             </Typography>

// //             {/* ORDER STATUS */}
// //             <Typography variant="subtitle2" gutterBottom>
// //               Order Status
// //             </Typography>

// //             <Box display="flex" gap={2} flexWrap="wrap" sx={{ mb: 1 }}>
// //               <FormControl size="small" sx={{ minWidth: 220 }}>
// //                 <InputLabel>Freezing Order</InputLabel>
// //                 <Select
// //                   label="Freezing Order"
// //                   name="is_freezing_order_delivered"
// //                   value={orderStatus.is_freezing_order_delivered || 'waiting'}
// //                   onChange={(e) => handleChange(e, 'order')}
// //                 >
// //                   {DELIVERY_STATUS_OPTIONS.map((opt) => (
// //                     <MenuItem key={opt} value={opt}>{opt}</MenuItem>
// //                   ))}
// //                 </Select>
// //               </FormControl>

// //               <FormControl size="small" sx={{ minWidth: 220 }} disabled={!orderStatus.is_bank_freezed}>
// //                 <InputLabel>Summons</InputLabel>
// //                 <Select
// //                   label="Summons"
// //                   name="is_summons_delivered"
// //                   value={orderStatus.is_summons_delivered || 'waiting'}
// //                   onChange={(e) => handleChange(e, 'order')}
// //                 >
// //                   {DELIVERY_STATUS_OPTIONS.map((opt) => (
// //                     <MenuItem key={opt} value={opt}>{opt}</MenuItem>
// //                   ))}
// //                 </Select>
// //               </FormControl>
// //             </Box>

// //             <FormControlLabel
// //               control={
// //                 <Checkbox
// //                   checked={orderStatus.is_bank_freezed}
// //                   name="is_bank_freezed"
// //                   disabled={
// //                     !orderStatus.is_freezing_order_issued
// //                   }
// //                   onChange={(e) =>
// //                     handleChange(e, 'order')
// //                   }
// //                 />
// //               }
// //               label="Bank Freezed"
// //             />

// //             <Divider sx={{ my: 2 }} />

// //             {/* PAYMENT */}
// //             <Typography variant="subtitle2" gutterBottom>
// //               Payment Agreement
// //             </Typography>

// //             <FormControlLabel
// //               control={
// //                 <Checkbox
// //                   checked={paymentData.is_agreed_to_pay}
// //                   name="is_agreed_to_pay"
// //                   disabled={!orderStatus.is_summons_issued}
// //                   onChange={(e) =>
// //                     handleChange(e, 'payment')
// //                   }
// //                 />
// //               }
// //               label="Agreed to Pay"
// //             />

// //             <FormControlLabel
// //               control={
// //                 <Checkbox
// //                   checked={
// //                     paymentData.is_not_agreed_to_pay
// //                   }
// //                   name="is_not_agreed_to_pay"
// //                   disabled={!orderStatus.is_summons_issued}
// //                   onChange={(e) =>
// //                     handleChange(e, 'payment')
// //                   }
// //                 />
// //               }
// //               label="Not Agreed to Pay"
// //             />

// //             {paymentData.is_agreed_to_pay &&
// //             !paymentData.is_not_agreed_to_pay ? (
// //               <>
// //                 <TextField
// //                   label="Agreed Amount"
// //                   type="number"
// //                   name="agreed_amount"
// //                   value={paymentData.agreed_amount}
// //                   onChange={(e) =>
// //                     handleChange(e, 'payment')
// //                   }
// //                   fullWidth
// //                   size="small"
// //                   sx={{ mt: 2 }}
// //                 />

// //                 <TextField
// //                   label="No of Installments"
// //                   type="number"
// //                   name="no_of_installment"
// //                   value={
// //                     paymentData.no_of_installment
// //                   }
// //                   onChange={(e) =>
// //                     handleChange(e, 'payment')
// //                   }
// //                   fullWidth
// //                   size="small"
// //                   sx={{ mt: 2 }}
// //                 />
// //               </>
// //             ) : null}

// //             <TextField
// //               label="Additional Remarks"
// //               name="agree_remarks"
// //               value={paymentData.agree_remarks}
// //               onChange={(e) =>
// //                 handleChange(e, 'payment')
// //               }
// //               fullWidth
// //               multiline
// //               rows={2}
// //               size="small"
// //               sx={{ mt: 2 }}
// //             />

// //             <Divider sx={{ my: 2 }} />

// //             {/* DOCS */}
// //             <Typography variant="subtitle2" gutterBottom>
// //               Proof of Submission
// //             </Typography>
// //             <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
// //               Uploading a file automatically marks that document as submitted.
// //               PDF/JPG/PNG, max 5 MB each.
// //             </Typography>

// //             <Box display="flex" flexDirection="column" mb={2}>
// //               <DocUploadRow fileFieldName="address_proof_file" checkboxLabel="Address Proof" />
// //               <DocUploadRow fileFieldName="pan_card_file" checkboxLabel="PAN Card" />
// //               <DocUploadRow fileFieldName="aadhar_card_file" checkboxLabel="Aadhar Card" />

// //               <Box sx={{ pl: 0.5, py: 0.5 }}>
// //                 <DocUploadRow fileFieldName="affidavit_file" checkboxLabel="Affidavit" />
// //                 <Typography variant="body2" sx={{ pl: 4 }}>
// //                   Download Affidavit Template:{' '}
// //                   <Link
// //                     href="https://splocamedia.s3.ap-south-1.amazonaws.com/templates/UN-FREEZE+THE+BANK+ACCOUNT.pdf"
// //                     target="_blank"
// //                   >
// //                     Click here
// //                   </Link>
// //                 </Typography>
// //               </Box>

// //               <DocUploadRow fileFieldName="bank_statement_file" checkboxLabel="Bank Statement" />
// //             </Box>

// //             <TextField
// //               label="Current Address"
// //               name="current_address"
// //               value={formData.current_address}
// //               onChange={(e) =>
// //                 handleChange(e, 'docs')
// //               }
// //               fullWidth
// //               multiline
// //               rows={2}
// //               size="small"
// //               sx={{ mb: 2 }}
// //             />

// //             <TextField
// //               label="Updated Mobile Number"
// //               name="updated_mobile_number"
// //               value={formData.updated_mobile_number}
// //               onChange={(e) =>
// //                 handleChange(e, 'docs')
// //               }
// //               fullWidth
// //               size="small"
// //               inputProps={{ maxLength: 10 }}
// //               helperText="Enter 10 digit mobile number"
// //             />

// //             <Divider sx={{ my: 3 }} />

// //             {/* PARTIAL UNFREEZE */}
// //             <Typography variant="subtitle2" gutterBottom>
// //               Partial Unfreeze
// //             </Typography>

// //             <FormControlLabel
// //               control={
// //                 <Checkbox
// //                   checked={
// //                     orderStatus.is_partial_un_freezing_order_submited
// //                   }
// //                   name="is_partial_un_freezing_order_submited"
// //                   onChange={(e) =>
// //                     handleChange(e, 'order')
// //                   }
// //                   disabled={
// //                     !orderStatus.is_summons_issued
// //                   }
// //                 />
// //               }
// //               label="Partial Unfreeze Order Submitted"
// //             />

// //             <Typography variant="body2">
// //               Template:{' '}
// //               <Link
// //                 href="https://splocamedia.s3.ap-south-1.amazonaws.com/templates/PARTIALLY+UN-FREEZE+THE+BANK+ACCOUNT.pdf"
// //                 target="_blank"
// //               >
// //                 Click here
// //               </Link>
// //             </Typography>

// //             <FormControlLabel
// //               control={
// //                 <Checkbox
// //                   checked={
// //                     orderStatus.is_partial_un_freezed
// //                   }
// //                   name="is_partial_un_freezed"
// //                   onChange={(e) =>
// //                     handleChange(e, 'order')
// //                   }
// //                   disabled={
// //                     !orderStatus.is_partial_un_freezing_order_submited
// //                   }
// //                 />
// //               }
// //               label="Partially Unfreezed"
// //             />

// //             <Divider sx={{ my: 2 }} />

// //             {/* FINAL DEFREEZE */}
// //             <Typography variant="subtitle2" gutterBottom>
// //               Final Defreeze
// //             </Typography>

// //             <FormControlLabel
// //               control={
// //                 <Checkbox
// //                   checked={
// //                     orderStatus.is_defreezing_order_submited
// //                   }
// //                   name="is_defreezing_order_submited"
// //                   onChange={(e) =>
// //                     handleChange(e, 'order')
// //                   }
// //                   disabled={
// //                     !orderStatus.is_partial_un_freezed
// //                   }
// //                 />
// //               }
// //               label="Defreezing Order Submitted"
// //             />

// //             <Typography variant="body2">
// //               Template:{' '}
// //               <Link
// //                 href="https://splocamedia.s3.ap-south-1.amazonaws.com/templates/UN-FREEZE+THE+BANK+ACCOUNT.pdf"
// //                 target="_blank"
// //               >
// //                 Click here
// //               </Link>
// //             </Typography>

// //             <FormControlLabel
// //               control={
// //                 <Checkbox
// //                   checked={
// //                     orderStatus.is_bank_defreezed
// //                   }
// //                   name="is_bank_defreezed"
// //                   onChange={(e) =>
// //                     handleChange(e, 'order')
// //                   }
// //                   disabled={
// //                     !orderStatus.is_defreezing_order_submited
// //                   }
// //                 />
// //               }
// //               label="Bank Defreezed"
// //             />
// //           </Box>
// //         </DialogContent>

// //         <DialogActions>
// //           <Button
// //             onClick={onClose}
// //             disabled={loading}
// //           >
// //             Cancel
// //           </Button>

// //           <Button
// //             type="submit"
// //             onClick={handleSubmit}
// //             variant="contained"
// //             disabled={loading}
// //           >
// //             {loading ? 'Saving...' : 'Save'}
// //           </Button>
// //         </DialogActions>
// //       </Dialog>

// //       {/* INSTALLMENT WARNING */}
// //       <Dialog open={showInstallmentWarning}>
// //         <DialogTitle>Warning</DialogTitle>

// //         <DialogContent>
// //           <Typography color="error">
// //             Changing number of installments will
// //             erase all existing installment data.
// //             This action cannot be undone.
// //           </Typography>
// //         </DialogContent>

// //         <DialogActions>
// //           <Button onClick={cancelInstallmentChange}>
// //             Cancel
// //           </Button>

// //           <Button
// //             onClick={confirmInstallmentChange}
// //             color="error"
// //             variant="contained"
// //           >
// //             Proceed
// //           </Button>
// //         </DialogActions>
// //       </Dialog>

// //       <SnackBarComponent
// //         open={snackbarOpen}
// //         message={snackbarMessage}
// //         severity={snackbarSeverity}
// //         onClose={() => setSnackbarOpen(false)}
// //       />
// //     </>
// //   );
// // };

// // export default DocsEditModal;


// import React, { useState, useEffect } from 'react';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Box,
//   Typography,
//   FormControlLabel,
//   Checkbox,
//   TextField,
//   Link,
//   Divider,
//   IconButton,
//   Tooltip,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
// } from '@mui/material';
// import UploadFileIcon from '@mui/icons-material/UploadFile';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import api from '../../../api/axiosInterceptor';
// import { SnackBarComponent } from '../../../Components/snackBar/snackBar';
// import { DELIVERY_STATUS_OPTIONS, MAX_DOC_FILE_SIZE, MAX_BANK_STATEMENT_FILE_SIZE } from './workflowApi';

// // file input name -> (boolean field, link field, human label, max bytes)
// const DOC_FILE_MAP = {
//   address_proof_file: {
//     boolField: 'is_address_proof_submited',
//     linkField: 'address_proof_link',
//     label: 'Address Proof',
//     maxSize: MAX_DOC_FILE_SIZE,
//   },
//   pan_card_file: {
//     boolField: 'is_pan_card_submited',
//     linkField: 'pan_card_link',
//     label: 'PAN Card',
//     maxSize: MAX_DOC_FILE_SIZE,
//   },
//   aadhar_card_file: {
//     boolField: 'is_aadhar_card_submited',
//     linkField: 'aadhar_card_link',
//     label: 'Aadhar Card',
//     maxSize: MAX_DOC_FILE_SIZE,
//   },
//   affidavit_file: {
//     boolField: 'is_affidavit_submited',
//     linkField: 'affidavit_link',
//     label: 'Affidavit',
//     maxSize: MAX_DOC_FILE_SIZE,
//   },
//   bank_statement_file: {
//     boolField: 'is_bank_statement_submited',
//     linkField: 'bank_statement_link',
//     label: 'Bank Statement',
//     maxSize: MAX_BANK_STATEMENT_FILE_SIZE,
//   },
// };

// const DocsEditModal = ({ open, onClose, excessId, refId, excessAmt }) => {
//   const [loading, setLoading] = useState(false);

//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('success');

//   // PAYMENT STATE
//   const [paymentData, setPaymentData] = useState({
//     is_agreed_to_pay: false,
//     is_not_agreed_to_pay: false,
//     agreed_amount: '',
//     no_of_installment: 0,
//     agree_remarks: '',
//   });

//   const [showInstallmentWarning, setShowInstallmentWarning] = useState(false);
//   const [pendingInstallmentValue, setPendingInstallmentValue] = useState('');

//   // DOCS — checkboxes + link fields returned from the server
//   const [formData, setFormData] = useState({
//     is_address_proof_submited: false,
//     address_proof_link: '',
//     is_pan_card_submited: false,
//     pan_card_link: '',
//     is_aadhar_card_submited: false,
//     aadhar_card_link: '',
//     is_affidavit_submited: false,
//     affidavit_link: '',
//     is_bank_statement_submited: false,
//     bank_statement_link: '',
//     current_address: '',
//     updated_mobile_number: '',
//   });

//   // DOCS — files staged for upload (not yet sent) keyed by the multipart field name
//   const [docFiles, setDocFiles] = useState({});

//   // ORDER
//   const [orderStatus, setOrderStatus] = useState({
//     is_freezing_order_delivered: 'waiting',
//     is_freezing_order_issued: false,
//     is_bank_freezed: false,
//     is_summons_delivered: 'waiting',
//     is_summons_issued: false,
//     is_partial_un_freezing_order_submited: false,
//     is_partial_un_freezed: false,
//     is_defreezing_order_submited: false,
//     is_bank_defreezed: false,
//   });

//   // Fetch all data
//   const fetchAllData = async () => {
//     if (!excessId) return;

//     try {
//       setLoading(true);

//       const [docsRes, orderRes, paymentRes] = await Promise.all([
//         api.get(`/excess_payment_mgmt/excess-docs-updater/${excessId}/`),
//         api.get(`/excess_payment_mgmt/excess-order-updater/${excessId}/`),
//         api.get(`/excess_payment_mgmt/excess-payment-updater/${excessId}/`),
//       ]);

//       setFormData((prev) => ({ ...prev, ...docsRes.data }));
//       setDocFiles({});

//       setOrderStatus(orderRes.data);

//       setPaymentData({
//         is_agreed_to_pay: paymentRes.data.is_agreed_to_pay || false,
//         is_not_agreed_to_pay: paymentRes.data.is_not_agreed_to_pay || false,
//         agreed_amount: paymentRes.data.agreed_amount || '',
//         no_of_installment:
//           parseInt(paymentRes.data.no_of_installment, 10) || 0,
//         agree_remarks: paymentRes.data.agree_remarks || '',
//       });
//     } catch (err) {
//       setSnackbarMessage(
//         err.response?.data?.error || 'Failed to load data.'
//       );
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (open) {
//       fetchAllData();
//     }
//   }, [open, excessId]);

//   const showError = (message) => {
//     setSnackbarMessage(message);
//     setSnackbarSeverity('error');
//     setSnackbarOpen(true);
//   };

//   const handleChange = (e, section = 'docs') => {
//     const { name, value, checked, type } = e.target;

//     // Mobile validation
//     if (name === 'updated_mobile_number') {
//       if (!/^\d{0,10}$/.test(value)) return;
//     }

//     // =========================
//     // DOCS
//     // =========================
//     if (section === 'docs') {
//       setFormData((prev) => ({
//         ...prev,
//         [name]: type === 'checkbox' ? checked : value,
//       }));
//     }

//     // =========================
//     // ORDER STATUS
//     // =========================
//     else if (section === 'order') {
//       // Freezing Order and Summons are now dropdowns (waiting / Delivered /
//       // Returned to office) instead of checkboxes. The plain "issued"
//       // booleans are derived automatically — true once the value moves off
//       // "waiting" — same rule the backend applies.
//       if (name === 'is_freezing_order_delivered') {
//         if (value === 'waiting' && orderStatus.is_bank_freezed) {
//           showError('Please undo "Bank Freezed" before resetting Freezing Order to "waiting".');
//           return;
//         }
//         setOrderStatus((prev) => ({
//           ...prev,
//           is_freezing_order_delivered: value,
//           is_freezing_order_issued: value !== 'waiting',
//         }));
//         return;
//       }

//       if (name === 'is_summons_delivered') {
//         if (value === 'waiting' && orderStatus.is_partial_un_freezing_order_submited) {
//           showError('Please undo "Partial Unfreeze Order Submitted" before resetting Summons to "waiting".');
//           return;
//         }
//         setOrderStatus((prev) => ({
//           ...prev,
//           is_summons_delivered: value,
//           is_summons_issued: value !== 'waiting',
//         }));
//         return;
//       }

//       // REVERSE VALIDATIONS (remaining checkbox fields)

//       // Cannot uncheck bank freezed if summons issued
//       if (
//         name === 'is_bank_freezed' &&
//         !checked &&
//         orderStatus.is_summons_issued
//       ) {
//         showError(
//           'Please reset "Summons" to waiting before unchecking "Bank Freezed".'
//         );
//         return;
//       }

//       // Cannot uncheck partial unfreeze submitted if partially unfreezed
//       if (
//         name === 'is_partial_un_freezing_order_submited' &&
//         !checked &&
//         orderStatus.is_partial_un_freezed
//       ) {
//         showError(
//           'Please uncheck "Partially Unfreezed" before unchecking "Partial Unfreeze Order Submitted".'
//         );
//         return;
//       }

//       // Cannot uncheck partially unfreezed if defreezing submitted
//       if (
//         name === 'is_partial_un_freezed' &&
//         !checked &&
//         orderStatus.is_defreezing_order_submited
//       ) {
//         showError(
//           'Please uncheck "Defreezing Order Submitted" before unchecking "Partially Unfreezed".'
//         );
//         return;
//       }

//       // Cannot uncheck defreezing submitted if bank defreezed
//       if (
//         name === 'is_defreezing_order_submited' &&
//         !checked &&
//         orderStatus.is_bank_defreezed
//       ) {
//         showError(
//           'Please uncheck "Bank Defreezed" before unchecking "Defreezing Order Submitted".'
//         );
//         return;
//       }

//       setOrderStatus((prev) => ({
//         ...prev,
//         [name]: checked,
//       }));
//     }

//     // =========================
//     // PAYMENT
//     // =========================
//     else if (section === 'payment') {
//       if (name === 'no_of_installment') {
//         setPendingInstallmentValue(value);
//         setShowInstallmentWarning(true);
//         return;
//       }

//       // Mutual exclusivity
//       if (name === 'is_agreed_to_pay' && checked) {
//         setPaymentData((prev) => ({
//           ...prev,
//           is_agreed_to_pay: true,
//           is_not_agreed_to_pay: false,
//         }));
//         return;
//       }

//       if (name === 'is_not_agreed_to_pay' && checked) {
//         setPaymentData((prev) => ({
//           ...prev,
//           is_not_agreed_to_pay: true,
//           is_agreed_to_pay: false,
//           agreed_amount: '',
//           no_of_installment: 0,
//         }));
//         return;
//       }

//       setPaymentData((prev) => ({
//         ...prev,
//         [name]: type === 'checkbox' ? checked : value,
//       }));
//     }
//   };

//   // ── Document file upload ────────────────────────────────────────────────
//   const handleDocFileChange = (fileFieldName) => (e) => {
//     const file = e.target.files?.[0];
//     if (!file) return;

//     const { maxSize, label } = DOC_FILE_MAP[fileFieldName];
//     if (file.size > maxSize) {
//       showError(`${label} file must be under ${Math.round(maxSize / (1024 * 1024))} MB.`);
//       return;
//     }

//     setDocFiles((prev) => ({ ...prev, [fileFieldName]: file }));

//     // Uploading a file always marks that document as submitted, matching
//     // the backend behaviour — reflect it immediately in the checkbox.
//     const { boolField } = DOC_FILE_MAP[fileFieldName];
//     setFormData((prev) => ({ ...prev, [boolField]: true }));
//   };

//   const confirmInstallmentChange = () => {
//     setPaymentData((prev) => ({
//       ...prev,
//       no_of_installment: parseInt(pendingInstallmentValue, 10) || 0,
//     }));

//     setPendingInstallmentValue('');
//     setShowInstallmentWarning(false);
//   };

//   const cancelInstallmentChange = () => {
//     setPendingInstallmentValue('');
//     setShowInstallmentWarning(false);
//   };

//   const buildDocsFormData = () => {
//     const fd = new FormData();
//     fd.append('current_address', formData.current_address || '');
//     fd.append('updated_mobile_number', formData.updated_mobile_number || '');
//     fd.append('is_address_proof_submited', formData.is_address_proof_submited);
//     fd.append('is_pan_card_submited', formData.is_pan_card_submited);
//     fd.append('is_aadhar_card_submited', formData.is_aadhar_card_submited);
//     fd.append('is_affidavit_submited', formData.is_affidavit_submited);
//     fd.append('is_bank_statement_submited', formData.is_bank_statement_submited);

//     Object.keys(DOC_FILE_MAP).forEach((fileFieldName) => {
//       const file = docFiles[fileFieldName];
//       if (file) fd.append(fileFieldName, file);
//     });

//     return fd;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!excessId) return;

//     // Validation: Agreed Amount should not exceed Excess Amount
//     if (paymentData.is_agreed_to_pay) {
//       const agreed = parseFloat(paymentData.agreed_amount || 0);
//       const maxAllowed = parseFloat(excessAmt || 0);

//       if (!Number.isFinite(agreed) || agreed < 0) {
//         setSnackbarMessage('Agreed Amount must be a valid non-negative number');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         return;
//       }

//       if (agreed > maxAllowed) {
//         setSnackbarMessage('Agreed Amount cannot exceed Excess Amount');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         return;
//       }
//     }

//     if (
//       formData.updated_mobile_number &&
//       formData.updated_mobile_number.length !== 10
//     ) {
//       setSnackbarMessage('Mobile number must be exactly 10 digits');
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//       return;
//     }

//     let payloadPayment = { ...paymentData };

//     if (!paymentData.is_agreed_to_pay) {
//       payloadPayment = {
//         is_agreed_to_pay: false,
//         is_not_agreed_to_pay: true,
//         agreed_amount: null,
//         no_of_installment: 0,
//         agree_remarks: paymentData.agree_remarks || '',
//       };
//     }

//     setLoading(true);

//     try {
//       await Promise.all([
//         api.patch(
//           `/excess_payment_mgmt/excess-docs-updater/${excessId}/`,
//           buildDocsFormData(),
//           { headers: { 'Content-Type': 'multipart/form-data' } }
//         ),

//         api.patch(
//           `/excess_payment_mgmt/excess-order-updater/${excessId}/`,
//           orderStatus
//         ),

//         api.patch(
//           `/excess_payment_mgmt/excess-payment-updater/${excessId}/`,
//           payloadPayment
//         ),
//       ]);

//       await fetchAllData();

//       setSnackbarMessage('Updated Successfully');
//       setSnackbarSeverity('success');
//       setSnackbarOpen(true);

//       setTimeout(() => onClose(), 1000);
//     } catch (err) {
//       setSnackbarMessage(
//         err.response?.data?.error ||
//           err.response?.data?.message ||
//           'Failed to update.'
//       );

//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const docsDisabled = !orderStatus.is_summons_issued;

//   // Small reusable row: checkbox + upload button + view link
//   const DocUploadRow = ({ fileFieldName, checkboxLabel }) => {
//     const { boolField, linkField, maxSize } = DOC_FILE_MAP[fileFieldName];
//     const stagedFile = docFiles[fileFieldName];
//     const existingLink = formData[linkField];
//     const maxSizeLabel = `${Math.round(maxSize / (1024 * 1024))} MB`;

//     return (
//       <Box
//         display="flex"
//         alignItems="center"
//         flexWrap="wrap"
//         gap={1}
//         sx={{ py: 0.5 }}
//       >
//         <FormControlLabel
//           sx={{ minWidth: 200 }}
//           control={
//             <Checkbox
//               checked={formData[boolField]}
//               name={boolField}
//               onChange={(e) => handleChange(e, 'docs')}
//               disabled={docsDisabled}
//             />
//           }
//           label={checkboxLabel}
//         />

//         <Tooltip title={docsDisabled ? 'Enable Summons Issued first' : `Upload file (max ${maxSizeLabel})`}>
//           <span>
//             <Button
//               size="small"
//               variant="outlined"
//               component="label"
//               startIcon={<UploadFileIcon fontSize="small" />}
//               disabled={docsDisabled}
//             >
//               {stagedFile ? stagedFile.name : 'Upload'}
//               <input
//                 type="file"
//                 hidden
//                 accept=".pdf,.jpg,.jpeg,.png"
//                 onChange={handleDocFileChange(fileFieldName)}
//               />
//             </Button>
//           </span>
//         </Tooltip>

//         {existingLink && (
//           <Tooltip title="View uploaded file">
//             <IconButton
//               size="small"
//               component={Link}
//               href={existingLink}
//               target="_blank"
//               rel="noopener"
//             >
//               <VisibilityIcon fontSize="small" />
//             </IconButton>
//           </Tooltip>
//         )}
//       </Box>
//     );
//   };

//   return (
//     <>
//       <Dialog
//         open={open}
//         onClose={onClose}
//         maxWidth="md"
//         fullWidth
//         disableEscapeKeyDown
//        >
//         <DialogTitle>
//           Edit Document & Order Status
//         </DialogTitle>

//         <DialogContent>
//           <Box component="form" onSubmit={handleSubmit} p={2}>
//             {/* REFERENCE ID */}
//             <Typography variant="subtitle2" gutterBottom>
//               Reference ID:{' '}
//               <Box
//                 component="span"
//                 sx={{
//                   backgroundColor: '#1976d2',
//                   color: '#fff',
//                   px: 1.5,
//                   py: 0.5,
//                   borderRadius: 1,
//                   fontWeight: 600,
//                   fontSize: '0.85rem',
//                 }}
//               >
//                 {refId}
//               </Box>
//             </Typography>

//             {/* EXCESS AMOUNT */}
//             <Typography variant="subtitle2" gutterBottom>
//               Excess Amount:{' '}
//               <Box
//                 component="span"
//                 sx={{
//                   backgroundColor: '#2e7d32',
//                   color: '#fff',
//                   px: 1.5,
//                   py: 0.5,
//                   borderRadius: 1,
//                   fontWeight: 600,
//                   fontSize: '0.85rem',
//                 }}
//               >
//                 ₹ {excessAmt || 0}
//               </Box>
//             </Typography>

//             <Typography
//               variant="body2"
//               sx={{
//                 color: '#8B0000',
//                 fontWeight: 600,
//                 mb: 2,
//               }}
//             >
//               Please add Reference Id on Hard copy
//             </Typography>

//             {/* ORDER STATUS */}
//             <Typography variant="subtitle2" gutterBottom>
//               Order Status
//             </Typography>

//             <Box display="flex" gap={2} flexWrap="wrap" sx={{ mb: 1 }}>
//               <FormControl size="small" sx={{ minWidth: 220 }}>
//                 <InputLabel>Freezing Order</InputLabel>
//                 <Select
//                   label="Freezing Order"
//                   name="is_freezing_order_delivered"
//                   value={orderStatus.is_freezing_order_delivered || 'waiting'}
//                   onChange={(e) => handleChange(e, 'order')}
//                 >
//                   {DELIVERY_STATUS_OPTIONS.map((opt) => (
//                     <MenuItem key={opt} value={opt}>{opt}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>

//               <FormControl size="small" sx={{ minWidth: 220 }} disabled={!orderStatus.is_bank_freezed}>
//                 <InputLabel>Summons</InputLabel>
//                 <Select
//                   label="Summons"
//                   name="is_summons_delivered"
//                   value={orderStatus.is_summons_delivered || 'waiting'}
//                   onChange={(e) => handleChange(e, 'order')}
//                 >
//                   {DELIVERY_STATUS_OPTIONS.map((opt) => (
//                     <MenuItem key={opt} value={opt}>{opt}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Box>

//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={orderStatus.is_bank_freezed}
//                   name="is_bank_freezed"
//                   disabled={
//                     !orderStatus.is_freezing_order_issued
//                   }
//                   onChange={(e) =>
//                     handleChange(e, 'order')
//                   }
//                 />
//               }
//               label="Bank Freezed"
//             />

//             <Divider sx={{ my: 2 }} />

//             {/* PAYMENT */}
//             <Typography variant="subtitle2" gutterBottom>
//               Payment Agreement
//             </Typography>

//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={paymentData.is_agreed_to_pay}
//                   name="is_agreed_to_pay"
//                   disabled={!orderStatus.is_summons_issued}
//                   onChange={(e) =>
//                     handleChange(e, 'payment')
//                   }
//                 />
//               }
//               label="Agreed to Pay"
//             />

//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={
//                     paymentData.is_not_agreed_to_pay
//                   }
//                   name="is_not_agreed_to_pay"
//                   disabled={!orderStatus.is_summons_issued}
//                   onChange={(e) =>
//                     handleChange(e, 'payment')
//                   }
//                 />
//               }
//               label="Not Agreed to Pay"
//             />

//             {paymentData.is_agreed_to_pay &&
//             !paymentData.is_not_agreed_to_pay ? (
//               <>
//                 <TextField
//                   label="Agreed Amount"
//                   type="number"
//                   name="agreed_amount"
//                   value={paymentData.agreed_amount}
//                   onChange={(e) =>
//                     handleChange(e, 'payment')
//                   }
//                   fullWidth
//                   size="small"
//                   sx={{ mt: 2 }}
//                 />

//                 <TextField
//                   label="No of Installments"
//                   type="number"
//                   name="no_of_installment"
//                   value={
//                     paymentData.no_of_installment
//                   }
//                   onChange={(e) =>
//                     handleChange(e, 'payment')
//                   }
//                   fullWidth
//                   size="small"
//                   sx={{ mt: 2 }}
//                 />
//               </>
//             ) : null}

//             <TextField
//               label="Additional Remarks"
//               name="agree_remarks"
//               value={paymentData.agree_remarks}
//               onChange={(e) =>
//                 handleChange(e, 'payment')
//               }
//               fullWidth
//               multiline
//               rows={2}
//               size="small"
//               sx={{ mt: 2 }}
//             />

//             <Divider sx={{ my: 2 }} />

//             {/* DOCS */}
//             <Typography variant="subtitle2" gutterBottom>
//               Proof of Submission
//             </Typography>
//             <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
//               Uploading a file automatically marks that document as submitted.
//               PDF/JPG/PNG — 2 MB max (Bank Statement up to 10 MB).
//             </Typography>

//             <Box display="flex" flexDirection="column" mb={2}>
//               <DocUploadRow fileFieldName="address_proof_file" checkboxLabel="Address Proof" />
//               <DocUploadRow fileFieldName="pan_card_file" checkboxLabel="PAN Card" />
//               <DocUploadRow fileFieldName="aadhar_card_file" checkboxLabel="Aadhar Card" />

//               <Box sx={{ pl: 0.5, py: 0.5 }}>
//                 <DocUploadRow fileFieldName="affidavit_file" checkboxLabel="Affidavit" />
//                 <Typography variant="body2" sx={{ pl: 4 }}>
//                   Download Affidavit Template:{' '}
//                   <Link
//                     href="https://splocamedia.s3.ap-south-1.amazonaws.com/templates/UN-FREEZE+THE+BANK+ACCOUNT.pdf"
//                     target="_blank"
//                   >
//                     Click here
//                   </Link>
//                 </Typography>
//               </Box>

//               <DocUploadRow fileFieldName="bank_statement_file" checkboxLabel="Bank Statement" />
//             </Box>

//             <TextField
//               label="Current Address"
//               name="current_address"
//               value={formData.current_address}
//               onChange={(e) =>
//                 handleChange(e, 'docs')
//               }
//               fullWidth
//               multiline
//               rows={2}
//               size="small"
//               sx={{ mb: 2 }}
//             />

//             <TextField
//               label="Updated Mobile Number"
//               name="updated_mobile_number"
//               value={formData.updated_mobile_number}
//               onChange={(e) =>
//                 handleChange(e, 'docs')
//               }
//               fullWidth
//               size="small"
//               inputProps={{ maxLength: 10 }}
//               helperText="Enter 10 digit mobile number"
//             />

//             <Divider sx={{ my: 3 }} />

//             {/* PARTIAL UNFREEZE */}
//             <Typography variant="subtitle2" gutterBottom>
//               Partial Unfreeze
//             </Typography>

//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={
//                     orderStatus.is_partial_un_freezing_order_submited
//                   }
//                   name="is_partial_un_freezing_order_submited"
//                   onChange={(e) =>
//                     handleChange(e, 'order')
//                   }
//                   disabled={
//                     !orderStatus.is_summons_issued
//                   }
//                 />
//               }
//               label="Partial Unfreeze Order Submitted"
//             />

//             <Typography variant="body2">
//               Template:{' '}
//               <Link
//                 href="https://splocamedia.s3.ap-south-1.amazonaws.com/templates/PARTIALLY+UN-FREEZE+THE+BANK+ACCOUNT.pdf"
//                 target="_blank"
//               >
//                 Click here
//               </Link>
//             </Typography>

//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={
//                     orderStatus.is_partial_un_freezed
//                   }
//                   name="is_partial_un_freezed"
//                   onChange={(e) =>
//                     handleChange(e, 'order')
//                   }
//                   disabled={
//                     !orderStatus.is_partial_un_freezing_order_submited
//                   }
//                 />
//               }
//               label="Partially Unfreezed"
//             />

//             <Divider sx={{ my: 2 }} />

//             {/* FINAL DEFREEZE */}
//             <Typography variant="subtitle2" gutterBottom>
//               Final Defreeze
//             </Typography>

//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={
//                     orderStatus.is_defreezing_order_submited
//                   }
//                   name="is_defreezing_order_submited"
//                   onChange={(e) =>
//                     handleChange(e, 'order')
//                   }
//                   disabled={
//                     !orderStatus.is_partial_un_freezed
//                   }
//                 />
//               }
//               label="Defreezing Order Submitted"
//             />

//             <Typography variant="body2">
//               Template:{' '}
//               <Link
//                 href="https://splocamedia.s3.ap-south-1.amazonaws.com/templates/UN-FREEZE+THE+BANK+ACCOUNT.pdf"
//                 target="_blank"
//               >
//                 Click here
//               </Link>
//             </Typography>

//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={
//                     orderStatus.is_bank_defreezed
//                   }
//                   name="is_bank_defreezed"
//                   onChange={(e) =>
//                     handleChange(e, 'order')
//                   }
//                   disabled={
//                     !orderStatus.is_defreezing_order_submited
//                   }
//                 />
//               }
//               label="Bank Defreezed"
//             />
//           </Box>
//         </DialogContent>

//         <DialogActions>
//           <Button
//             onClick={onClose}
//             disabled={loading}
//           >
//             Cancel
//           </Button>

//           <Button
//             type="submit"
//             onClick={handleSubmit}
//             variant="contained"
//             disabled={loading}
//           >
//             {loading ? 'Saving...' : 'Save'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* INSTALLMENT WARNING */}
//       <Dialog open={showInstallmentWarning}>
//         <DialogTitle>Warning</DialogTitle>

//         <DialogContent>
//           <Typography color="error">
//             Changing number of installments will
//             erase all existing installment data.
//             This action cannot be undone.
//           </Typography>
//         </DialogContent>

//         <DialogActions>
//           <Button onClick={cancelInstallmentChange}>
//             Cancel
//           </Button>

//           <Button
//             onClick={confirmInstallmentChange}
//             color="error"
//             variant="contained"
//           >
//             Proceed
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={() => setSnackbarOpen(false)}
//       />
//     </>
//   );
// };

// export default DocsEditModal;


// import React, { useState, useEffect } from 'react';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Box,
//   Typography,
//   FormControlLabel,
//   Checkbox,
//   TextField,
//   Link,
//   Divider,
//   IconButton,
//   Tooltip,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
// } from '@mui/material';
// import UploadFileIcon from '@mui/icons-material/UploadFile';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import api from '../../../api/axiosInterceptor';
// import { SnackBarComponent } from '../../../Components/snackBar/snackBar';
// import { DELIVERY_STATUS_OPTIONS, MAX_DOC_FILE_SIZE, MAX_BANK_STATEMENT_FILE_SIZE } from './workflowApi';

// // file input name -> (boolean field, link field, human label, max bytes)
// const DOC_FILE_MAP = {
//   address_proof_file: {
//     boolField: 'is_address_proof_submited',
//     linkField: 'address_proof_link',
//     label: 'Address Proof',
//     maxSize: MAX_DOC_FILE_SIZE,
//   },
//   pan_card_file: {
//     boolField: 'is_pan_card_submited',
//     linkField: 'pan_card_link',
//     label: 'PAN Card',
//     maxSize: MAX_DOC_FILE_SIZE,
//   },
//   aadhar_card_file: {
//     boolField: 'is_aadhar_card_submited',
//     linkField: 'aadhar_card_link',
//     label: 'Aadhar Card',
//     maxSize: MAX_DOC_FILE_SIZE,
//   },
//   affidavit_file: {
//     boolField: 'is_affidavit_submited',
//     linkField: 'affidavit_link',
//     label: 'Affidavit',
//     maxSize: MAX_DOC_FILE_SIZE,
//   },
//   bank_statement_file: {
//     boolField: 'is_bank_statement_submited',
//     linkField: 'bank_statement_link',
//     label: 'Bank Statement',
//     maxSize: MAX_BANK_STATEMENT_FILE_SIZE,
//   },
// };

// // NOTE: Partial Unfreeze / Final Defreeze (with uploads) have moved to their
// // own component — ClosureStatusModal.jsx — since they belong to post-payment
// // closure, not this pre-decision document set. This modal now only owns:
// // Freezing/Summons delivery status, Bank Freezed, the 5 documents, and the
// // Payment Agreement (agreed amount / installments).
// const DocsEditModal = ({ open, onClose, excessId, refId, excessAmt, readOnly = false }) => {
//   const [loading, setLoading] = useState(false);

//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('success');

//   // PAYMENT STATE
//   const [paymentData, setPaymentData] = useState({
//     is_agreed_to_pay: false,
//     is_not_agreed_to_pay: false,
//     agreed_amount: '',
//     no_of_installment: 0,
//     agree_remarks: '',
//   });

//   const [showInstallmentWarning, setShowInstallmentWarning] = useState(false);
//   const [pendingInstallmentValue, setPendingInstallmentValue] = useState('');

//   // DOCS — checkboxes + link fields returned from the server
//   const [formData, setFormData] = useState({
//     is_address_proof_submited: false,
//     address_proof_link: '',
//     is_pan_card_submited: false,
//     pan_card_link: '',
//     is_aadhar_card_submited: false,
//     aadhar_card_link: '',
//     is_affidavit_submited: false,
//     affidavit_link: '',
//     is_bank_statement_submited: false,
//     bank_statement_link: '',
//     current_address: '',
//     updated_mobile_number: '',
//   });

//   // DOCS — files staged for upload (not yet sent) keyed by the multipart field name
//   const [docFiles, setDocFiles] = useState({});

//   // ORDER — only the fields this modal actually owns
//   const [orderStatus, setOrderStatus] = useState({
//     is_freezing_order_delivered: 'waiting',
//     is_freezing_order_issued: false,
//     is_bank_freezed: false,
//     is_summons_delivered: 'waiting',
//     is_summons_issued: false,
//   });

//   // Fetch all data
//   const fetchAllData = async () => {
//     if (!excessId) return;

//     try {
//       setLoading(true);

//       const [docsRes, orderRes, paymentRes] = await Promise.all([
//         api.get(`/excess_payment_mgmt/excess-docs-updater/${excessId}/`),
//         api.get(`/excess_payment_mgmt/excess-order-updater/${excessId}/`),
//         api.get(`/excess_payment_mgmt/excess-payment-updater/${excessId}/`),
//       ]);

//       setFormData((prev) => ({ ...prev, ...docsRes.data }));
//       setDocFiles({});

//       setOrderStatus((prev) => ({
//         ...prev,
//         is_freezing_order_delivered: orderRes.data.is_freezing_order_delivered,
//         is_freezing_order_issued: orderRes.data.is_freezing_order_issued,
//         is_bank_freezed: orderRes.data.is_bank_freezed,
//         is_summons_delivered: orderRes.data.is_summons_delivered,
//         is_summons_issued: orderRes.data.is_summons_issued,
//       }));

//       setPaymentData({
//         is_agreed_to_pay: paymentRes.data.is_agreed_to_pay || false,
//         is_not_agreed_to_pay: paymentRes.data.is_not_agreed_to_pay || false,
//         agreed_amount: paymentRes.data.agreed_amount || '',
//         no_of_installment:
//           parseInt(paymentRes.data.no_of_installment, 10) || 0,
//         agree_remarks: paymentRes.data.agree_remarks || '',
//       });
//     } catch (err) {
//       setSnackbarMessage(
//         err.response?.data?.error || 'Failed to load data.'
//       );
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (open) {
//       fetchAllData();
//     }
//   }, [open, excessId]);

//   const showError = (message) => {
//     setSnackbarMessage(message);
//     setSnackbarSeverity('error');
//     setSnackbarOpen(true);
//   };

//   const handleChange = (e, section = 'docs') => {
//     if (readOnly) return;
//     const { name, value, checked, type } = e.target;

//     // Mobile validation
//     if (name === 'updated_mobile_number') {
//       if (!/^\d{0,10}$/.test(value)) return;
//     }

//     // =========================
//     // DOCS
//     // =========================
//     if (section === 'docs') {
//       setFormData((prev) => ({
//         ...prev,
//         [name]: type === 'checkbox' ? checked : value,
//       }));
//     }

//     // =========================
//     // ORDER STATUS
//     // =========================
//     else if (section === 'order') {
//       // Freezing Order and Summons are dropdowns (waiting / Delivered /
//       // Returned to office). The plain "issued" booleans are derived
//       // automatically — true once the value moves off "waiting" — same
//       // rule the backend applies.
//       if (name === 'is_freezing_order_delivered') {
//         if (value === 'waiting' && orderStatus.is_bank_freezed) {
//           showError('Please undo "Bank Freezed" before resetting Freezing Order to "waiting".');
//           return;
//         }
//         setOrderStatus((prev) => ({
//           ...prev,
//           is_freezing_order_delivered: value,
//           is_freezing_order_issued: value !== 'waiting',
//         }));
//         return;
//       }

//       if (name === 'is_summons_delivered') {
//         setOrderStatus((prev) => ({
//           ...prev,
//           is_summons_delivered: value,
//           is_summons_issued: value !== 'waiting',
//         }));
//         return;
//       }

//       // Cannot uncheck bank freezed if summons already delivered
//       if (
//         name === 'is_bank_freezed' &&
//         !checked &&
//         orderStatus.is_summons_issued
//       ) {
//         showError(
//           'Please reset "Summons" to waiting before unchecking "Bank Freezed".'
//         );
//         return;
//       }

//       setOrderStatus((prev) => ({
//         ...prev,
//         [name]: checked,
//       }));
//     }

//     // =========================
//     // PAYMENT
//     // =========================
//     else if (section === 'payment') {
//       if (name === 'no_of_installment') {
//         setPendingInstallmentValue(value);
//         setShowInstallmentWarning(true);
//         return;
//       }

//       // Mutual exclusivity
//       if (name === 'is_agreed_to_pay' && checked) {
//         setPaymentData((prev) => ({
//           ...prev,
//           is_agreed_to_pay: true,
//           is_not_agreed_to_pay: false,
//         }));
//         return;
//       }

//       if (name === 'is_not_agreed_to_pay' && checked) {
//         setPaymentData((prev) => ({
//           ...prev,
//           is_not_agreed_to_pay: true,
//           is_agreed_to_pay: false,
//           agreed_amount: '',
//           no_of_installment: 0,
//         }));
//         return;
//       }

//       setPaymentData((prev) => ({
//         ...prev,
//         [name]: type === 'checkbox' ? checked : value,
//       }));
//     }
//   };

//   // ── Document file upload ────────────────────────────────────────────────
//   const handleDocFileChange = (fileFieldName) => (e) => {
//     if (readOnly) return;
//     const file = e.target.files?.[0];
//     if (!file) return;

//     const { maxSize, label } = DOC_FILE_MAP[fileFieldName];
//     if (file.size > maxSize) {
//       showError(`${label} file must be under ${Math.round(maxSize / (1024 * 1024))} MB.`);
//       return;
//     }

//     setDocFiles((prev) => ({ ...prev, [fileFieldName]: file }));

//     // Uploading a file always marks that document as submitted, matching
//     // the backend behaviour — reflect it immediately in the checkbox.
//     const { boolField } = DOC_FILE_MAP[fileFieldName];
//     setFormData((prev) => ({ ...prev, [boolField]: true }));
//   };

//   const confirmInstallmentChange = () => {
//     setPaymentData((prev) => ({
//       ...prev,
//       no_of_installment: parseInt(pendingInstallmentValue, 10) || 0,
//     }));

//     setPendingInstallmentValue('');
//     setShowInstallmentWarning(false);
//   };

//   const cancelInstallmentChange = () => {
//     setPendingInstallmentValue('');
//     setShowInstallmentWarning(false);
//   };

//   const buildDocsFormData = () => {
//     const fd = new FormData();
//     fd.append('current_address', formData.current_address || '');
//     fd.append('updated_mobile_number', formData.updated_mobile_number || '');
//     fd.append('is_address_proof_submited', formData.is_address_proof_submited);
//     fd.append('is_pan_card_submited', formData.is_pan_card_submited);
//     fd.append('is_aadhar_card_submited', formData.is_aadhar_card_submited);
//     fd.append('is_affidavit_submited', formData.is_affidavit_submited);
//     fd.append('is_bank_statement_submited', formData.is_bank_statement_submited);

//     Object.keys(DOC_FILE_MAP).forEach((fileFieldName) => {
//       const file = docFiles[fileFieldName];
//       if (file) fd.append(fileFieldName, file);
//     });

//     return fd;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (readOnly || !excessId) return;

//     // Validation: Agreed Amount should not exceed Excess Amount
//     if (paymentData.is_agreed_to_pay) {
//       const agreed = parseFloat(paymentData.agreed_amount || 0);
//       const maxAllowed = parseFloat(excessAmt || 0);

//       if (!Number.isFinite(agreed) || agreed < 0) {
//         setSnackbarMessage('Agreed Amount must be a valid non-negative number');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         return;
//       }

//       if (agreed > maxAllowed) {
//         setSnackbarMessage('Agreed Amount cannot exceed Excess Amount');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         return;
//       }
//     }

//     if (
//       formData.updated_mobile_number &&
//       formData.updated_mobile_number.length !== 10
//     ) {
//       setSnackbarMessage('Mobile number must be exactly 10 digits');
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//       return;
//     }

//     let payloadPayment = { ...paymentData };

//     if (!paymentData.is_agreed_to_pay) {
//       payloadPayment = {
//         is_agreed_to_pay: false,
//         is_not_agreed_to_pay: true,
//         agreed_amount: null,
//         no_of_installment: 0,
//         agree_remarks: paymentData.agree_remarks || '',
//       };
//     }

//     setLoading(true);

//     try {
//       await Promise.all([
//         api.patch(
//           `/excess_payment_mgmt/excess-docs-updater/${excessId}/`,
//           buildDocsFormData(),
//           { headers: { 'Content-Type': 'multipart/form-data' } }
//         ),

//         api.patch(
//           `/excess_payment_mgmt/excess-order-updater/${excessId}/`,
//           {
//             is_freezing_order_delivered: orderStatus.is_freezing_order_delivered,
//             is_summons_delivered: orderStatus.is_summons_delivered,
//             is_bank_freezed: orderStatus.is_bank_freezed,
//           }
//         ),

//         api.patch(
//           `/excess_payment_mgmt/excess-payment-updater/${excessId}/`,
//           payloadPayment
//         ),
//       ]);

//       await fetchAllData();

//       setSnackbarMessage('Updated Successfully');
//       setSnackbarSeverity('success');
//       setSnackbarOpen(true);

//       setTimeout(() => onClose(), 1000);
//     } catch (err) {
//       setSnackbarMessage(
//         err.response?.data?.error ||
//           err.response?.data?.message ||
//           'Failed to update.'
//       );

//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const docsDisabled = readOnly || !orderStatus.is_summons_issued;

//   // Small reusable row: checkbox + upload button + view link
//   const DocUploadRow = ({ fileFieldName, checkboxLabel }) => {
//     const { boolField, linkField, maxSize } = DOC_FILE_MAP[fileFieldName];
//     const stagedFile = docFiles[fileFieldName];
//     const existingLink = formData[linkField];
//     const maxSizeLabel = `${Math.round(maxSize / (1024 * 1024))} MB`;

//     return (
//       <Box
//         display="flex"
//         alignItems="center"
//         flexWrap="wrap"
//         gap={1}
//         sx={{ py: 0.5 }}
//       >
//         <FormControlLabel
//           sx={{ minWidth: 200 }}
//           control={
//             <Checkbox
//               checked={formData[boolField]}
//               name={boolField}
//               onChange={(e) => handleChange(e, 'docs')}
//               disabled={docsDisabled}
//             />
//           }
//           label={checkboxLabel}
//         />

//         <Tooltip title={docsDisabled ? (readOnly ? 'View only' : 'Enable Summons first') : `Upload file (max ${maxSizeLabel})`}>
//           <span>
//             <Button
//               size="small"
//               variant="outlined"
//               component="label"
//               startIcon={<UploadFileIcon fontSize="small" />}
//               disabled={docsDisabled}
//             >
//               {stagedFile ? stagedFile.name : 'Upload'}
//               <input
//                 type="file"
//                 hidden
//                 accept=".pdf,.jpg,.jpeg,.png"
//                 onChange={handleDocFileChange(fileFieldName)}
//               />
//             </Button>
//           </span>
//         </Tooltip>

//         {existingLink && (
//           <Tooltip title="View uploaded file">
//             <IconButton
//               size="small"
//               component={Link}
//               href={existingLink}
//               target="_blank"
//               rel="noopener"
//             >
//               <VisibilityIcon fontSize="small" />
//             </IconButton>
//           </Tooltip>
//         )}
//       </Box>
//     );
//   };

//   return (
//     <>
//       <Dialog
//         open={open}
//         onClose={onClose}
//         maxWidth="md"
//         fullWidth
//         disableEscapeKeyDown
//        >
//         <DialogTitle>
//           {readOnly ? 'View Documents & Order Status (Read Only)' : 'Edit Document & Order Status'}
//         </DialogTitle>

//         <DialogContent>
//           <Box component="form" onSubmit={handleSubmit} p={2}>
//             {/* REFERENCE ID */}
//             <Typography variant="subtitle2" gutterBottom>
//               Reference ID:{' '}
//               <Box
//                 component="span"
//                 sx={{
//                   backgroundColor: '#1976d2',
//                   color: '#fff',
//                   px: 1.5,
//                   py: 0.5,
//                   borderRadius: 1,
//                   fontWeight: 600,
//                   fontSize: '0.85rem',
//                 }}
//               >
//                 {refId}
//               </Box>
//             </Typography>

//             {/* EXCESS AMOUNT */}
//             <Typography variant="subtitle2" gutterBottom>
//               Excess Amount:{' '}
//               <Box
//                 component="span"
//                 sx={{
//                   backgroundColor: '#2e7d32',
//                   color: '#fff',
//                   px: 1.5,
//                   py: 0.5,
//                   borderRadius: 1,
//                   fontWeight: 600,
//                   fontSize: '0.85rem',
//                 }}
//               >
//                 ₹ {excessAmt || 0}
//               </Box>
//             </Typography>

//             <Typography
//               variant="body2"
//               sx={{
//                 color: '#8B0000',
//                 fontWeight: 600,
//                 mb: 2,
//               }}
//             >
//               Please add Reference Id on Hard copy
//             </Typography>

//             {/* ORDER STATUS */}
//             <Typography variant="subtitle2" gutterBottom>
//               Order Status
//             </Typography>

//             <Box display="flex" gap={2} flexWrap="wrap" sx={{ mb: 1 }}>
//               <FormControl size="small" sx={{ minWidth: 220 }} disabled={readOnly}>
//                 <InputLabel>Freezing Order</InputLabel>
//                 <Select
//                   label="Freezing Order"
//                   name="is_freezing_order_delivered"
//                   value={orderStatus.is_freezing_order_delivered || 'waiting'}
//                   onChange={(e) => handleChange(e, 'order')}
//                 >
//                   {DELIVERY_STATUS_OPTIONS.map((opt) => (
//                     <MenuItem key={opt} value={opt}>{opt}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>

//               <FormControl size="small" sx={{ minWidth: 220 }} disabled={readOnly || !orderStatus.is_bank_freezed}>
//                 <InputLabel>Summons</InputLabel>
//                 <Select
//                   label="Summons"
//                   name="is_summons_delivered"
//                   value={orderStatus.is_summons_delivered || 'waiting'}
//                   onChange={(e) => handleChange(e, 'order')}
//                 >
//                   {DELIVERY_STATUS_OPTIONS.map((opt) => (
//                     <MenuItem key={opt} value={opt}>{opt}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Box>

//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={orderStatus.is_bank_freezed}
//                   name="is_bank_freezed"
//                   disabled={
//                     readOnly || !orderStatus.is_freezing_order_issued
//                   }
//                   onChange={(e) =>
//                     handleChange(e, 'order')
//                   }
//                 />
//               }
//               label="Bank Freezed"
//             />

//             <Divider sx={{ my: 2 }} />

//             {/* PAYMENT */}
//             <Typography variant="subtitle2" gutterBottom>
//               Payment Agreement
//             </Typography>

//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={paymentData.is_agreed_to_pay}
//                   name="is_agreed_to_pay"
//                   disabled={readOnly || !orderStatus.is_summons_issued}
//                   onChange={(e) =>
//                     handleChange(e, 'payment')
//                   }
//                 />
//               }
//               label="Agreed to Pay"
//             />

//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={
//                     paymentData.is_not_agreed_to_pay
//                   }
//                   name="is_not_agreed_to_pay"
//                   disabled={readOnly || !orderStatus.is_summons_issued}
//                   onChange={(e) =>
//                     handleChange(e, 'payment')
//                   }
//                 />
//               }
//               label="Not Agreed to Pay"
//             />

//             {paymentData.is_agreed_to_pay &&
//             !paymentData.is_not_agreed_to_pay ? (
//               <>
//                 <TextField
//                   label="Agreed Amount"
//                   type="number"
//                   name="agreed_amount"
//                   value={paymentData.agreed_amount}
//                   onChange={(e) =>
//                     handleChange(e, 'payment')
//                   }
//                   fullWidth
//                   size="small"
//                   disabled={readOnly}
//                   sx={{ mt: 2 }}
//                 />

//                 <TextField
//                   label="No of Installments"
//                   type="number"
//                   name="no_of_installment"
//                   value={
//                     paymentData.no_of_installment
//                   }
//                   onChange={(e) =>
//                     handleChange(e, 'payment')
//                   }
//                   fullWidth
//                   size="small"
//                   disabled={readOnly}
//                   sx={{ mt: 2 }}
//                 />
//               </>
//             ) : null}

//             <TextField
//               label="Additional Remarks"
//               name="agree_remarks"
//               value={paymentData.agree_remarks}
//               onChange={(e) =>
//                 handleChange(e, 'payment')
//               }
//               fullWidth
//               multiline
//               rows={2}
//               size="small"
//               disabled={readOnly}
//               sx={{ mt: 2 }}
//             />

//             <Divider sx={{ my: 2 }} />

//             {/* DOCS */}
//             <Typography variant="subtitle2" gutterBottom>
//               Proof of Submission
//             </Typography>
//             <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
//               Uploading a file automatically marks that document as submitted.
//               PDF/JPG/PNG — 2 MB max (Bank Statement up to 10 MB).
//             </Typography>

//             <Box display="flex" flexDirection="column" mb={2}>
//               <DocUploadRow fileFieldName="address_proof_file" checkboxLabel="Address Proof" />
//               <DocUploadRow fileFieldName="pan_card_file" checkboxLabel="PAN Card" />
//               <DocUploadRow fileFieldName="aadhar_card_file" checkboxLabel="Aadhar Card" />

//               <Box sx={{ pl: 0.5, py: 0.5 }}>
//                 <DocUploadRow fileFieldName="affidavit_file" checkboxLabel="Affidavit" />
//                 <Typography variant="body2" sx={{ pl: 4 }}>
//                   Download Affidavit Template:{' '}
//                   <Link
//                     href="https://splocamedia.s3.ap-south-1.amazonaws.com/templates/UN-FREEZE+THE+BANK+ACCOUNT.pdf"
//                     target="_blank"
//                   >
//                     Click here
//                   </Link>
//                 </Typography>
//               </Box>

//               <DocUploadRow fileFieldName="bank_statement_file" checkboxLabel="Bank Statement" />
//             </Box>

//             <TextField
//               label="Current Address"
//               name="current_address"
//               value={formData.current_address}
//               onChange={(e) =>
//                 handleChange(e, 'docs')
//               }
//               fullWidth
//               multiline
//               rows={2}
//               size="small"
//               disabled={readOnly}
//               sx={{ mb: 2 }}
//             />

//             <TextField
//               label="Updated Mobile Number"
//               name="updated_mobile_number"
//               value={formData.updated_mobile_number}
//               onChange={(e) =>
//                 handleChange(e, 'docs')
//               }
//               fullWidth
//               size="small"
//               disabled={readOnly}
//               inputProps={{ maxLength: 10 }}
//               helperText="Enter 10 digit mobile number"
//             />
//           </Box>
//         </DialogContent>

//         <DialogActions>
//           <Button
//             onClick={onClose}
//             disabled={loading}
//           >
//             {readOnly ? 'Close' : 'Cancel'}
//           </Button>

//           {!readOnly && (
//             <Button
//               type="submit"
//               onClick={handleSubmit}
//               variant="contained"
//               disabled={loading}
//             >
//               {loading ? 'Saving...' : 'Save'}
//             </Button>
//           )}
//         </DialogActions>
//       </Dialog>

//       {/* INSTALLMENT WARNING */}
//       <Dialog open={showInstallmentWarning}>
//         <DialogTitle>Warning</DialogTitle>

//         <DialogContent>
//           <Typography color="error">
//             Changing number of installments will
//             erase all existing installment data.
//             This action cannot be undone.
//           </Typography>
//         </DialogContent>

//         <DialogActions>
//           <Button onClick={cancelInstallmentChange}>
//             Cancel
//           </Button>

//           <Button
//             onClick={confirmInstallmentChange}
//             color="error"
//             variant="contained"
//           >
//             Proceed
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={() => setSnackbarOpen(false)}
//       />
//     </>
//   );
// };

// export default DocsEditModal;


// import React, { useState, useEffect } from 'react';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Box,
//   Typography,
//   FormControlLabel,
//   Checkbox,
//   TextField,
//   Link,
//   Divider,
//   IconButton,
//   Tooltip,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
// } from '@mui/material';
// import UploadFileIcon from '@mui/icons-material/UploadFile';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import api from '../../../api/axiosInterceptor';
// import { SnackBarComponent } from '../../../Components/snackBar/snackBar';
// import { DELIVERY_STATUS_OPTIONS, MAX_DOC_FILE_SIZE, MAX_BANK_STATEMENT_FILE_SIZE } from './workflowApi';

// // file input name -> (boolean field, link field, human label, max bytes)
// const DOC_FILE_MAP = {
//   address_proof_file: {
//     boolField: 'is_address_proof_submited',
//     linkField: 'address_proof_link',
//     label: 'Address Proof',
//     maxSize: MAX_DOC_FILE_SIZE,
//   },
//   pan_card_file: {
//     boolField: 'is_pan_card_submited',
//     linkField: 'pan_card_link',
//     label: 'PAN Card',
//     maxSize: MAX_DOC_FILE_SIZE,
//   },
//   aadhar_card_file: {
//     boolField: 'is_aadhar_card_submited',
//     linkField: 'aadhar_card_link',
//     label: 'Aadhar Card',
//     maxSize: MAX_DOC_FILE_SIZE,
//   },
//   affidavit_file: {
//     boolField: 'is_affidavit_submited',
//     linkField: 'affidavit_link',
//     label: 'Affidavit',
//     maxSize: MAX_DOC_FILE_SIZE,
//   },
//   bank_statement_file: {
//     boolField: 'is_bank_statement_submited',
//     linkField: 'bank_statement_link',
//     label: 'Bank Statement',
//     maxSize: MAX_BANK_STATEMENT_FILE_SIZE,
//   },
// };

// // NOTE: Partial Unfreeze / Final Defreeze (with uploads) have moved to their
// // own component — ClosureStatusModal.jsx — since they belong to post-payment
// // closure, not this pre-decision document set. This modal now only owns:
// // Freezing/Summons delivery status, Bank Freezed, the 5 documents, and the
// // Payment Agreement (agreed amount / installments).
// const DocsEditModal = ({ open, onClose, excessId, refId, excessAmt, readOnly = false }) => {
//   const [loading, setLoading] = useState(false);

//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('success');

//   // PAYMENT STATE
//   const [paymentData, setPaymentData] = useState({
//     is_agreed_to_pay: false,
//     is_not_agreed_to_pay: false,
//     agreed_amount: '',
//     no_of_installment: 0,
//     agree_remarks: '',
//   });

//   const [showInstallmentWarning, setShowInstallmentWarning] = useState(false);
//   const [pendingInstallmentValue, setPendingInstallmentValue] = useState('');

//   // Holds the installment count as it exists on the server. Used only to show
//   // the user a hint ("Previous: X") — it is never fed back into the editable
//   // field, so the user can't accidentally save without re-entering it, which
//   // previously risked silently carrying stale data into workflow decisions.
//   const [existingInstallment, setExistingInstallment] = useState(0);
//   const [existingAmount, setExistingAmount] = useState(0);

//   // DOCS — checkboxes + link fields returned from the server
//   const [formData, setFormData] = useState({
//     is_address_proof_submited: false,
//     address_proof_link: '',
//     is_pan_card_submited: false,
//     pan_card_link: '',
//     is_aadhar_card_submited: false,
//     aadhar_card_link: '',
//     is_affidavit_submited: false,
//     affidavit_link: '',
//     is_bank_statement_submited: false,
//     bank_statement_link: '',
//     current_address: '',
//     updated_mobile_number: '',
//   });

//   // DOCS — files staged for upload (not yet sent) keyed by the multipart field name
//   const [docFiles, setDocFiles] = useState({});

//   // ORDER — only the fields this modal actually owns
//   const [orderStatus, setOrderStatus] = useState({
//     is_freezing_order_delivered: 'waiting',
//     is_freezing_order_issued: false,
//     is_bank_freezed: false,
//     is_summons_delivered: 'waiting',
//     is_summons_issued: false,
//   });

//   // Fetch all data
//   const fetchAllData = async () => {
//     if (!excessId) return;

//     try {
//       setLoading(true);

//       const [docsRes, orderRes, paymentRes] = await Promise.all([
//         api.get(`/excess_payment_mgmt/excess-docs-updater/${excessId}/`),
//         api.get(`/excess_payment_mgmt/excess-order-updater/${excessId}/`),
//         api.get(`/excess_payment_mgmt/excess-payment-updater/${excessId}/`),
//       ]);

//       setFormData((prev) => ({ ...prev, ...docsRes.data }));
//       setDocFiles({});

//       setOrderStatus((prev) => ({
//         ...prev,
//         is_freezing_order_delivered: orderRes.data.is_freezing_order_delivered,
//         is_freezing_order_issued: orderRes.data.is_freezing_order_issued,
//         is_bank_freezed: orderRes.data.is_bank_freezed,
//         is_summons_delivered: orderRes.data.is_summons_delivered,
//         is_summons_issued: orderRes.data.is_summons_issued,
//       }));

//       const savedInstallment = parseInt(paymentRes.data.no_of_installment, 10) || 0;
//       const savedAmount = parseFloat(paymentRes.data.agreed_amount) || 0;
//       setExistingInstallment(savedInstallment);
//       setExistingAmount(savedAmount);

//       setPaymentData({
//         is_agreed_to_pay: paymentRes.data.is_agreed_to_pay || false,
//         is_not_agreed_to_pay: paymentRes.data.is_not_agreed_to_pay || false,
//         agreed_amount: paymentRes.data.agreed_amount || '',
//         // In read-only (view) mode show the real saved value. In edit mode,
//         // leave it blank so the user is forced to consciously re-enter it —
//         // silently resubmitting a stale prefilled value could otherwise
//         // drive a workflow decision off outdated installment data.
//         no_of_installment: readOnly ? savedInstallment : '',
//         agree_remarks: paymentRes.data.agree_remarks || '',
//       });
//     } catch (err) {
//       setSnackbarMessage(
//         err.response?.data?.error || 'Failed to load data.'
//       );
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (open) {
//       fetchAllData();
//     }
//   }, [open, excessId]);

//   const showError = (message) => {
//     setSnackbarMessage(message);
//     setSnackbarSeverity('error');
//     setSnackbarOpen(true);
//   };

//   const handleChange = (e, section = 'docs') => {
//     if (readOnly) return;
//     const { name, value, checked, type } = e.target;

//     // Mobile validation
//     if (name === 'updated_mobile_number') {
//       if (!/^\d{0,10}$/.test(value)) return;
//     }

//     // =========================
//     // DOCS
//     // =========================
//     if (section === 'docs') {
//       setFormData((prev) => ({
//         ...prev,
//         [name]: type === 'checkbox' ? checked : value,
//       }));
//     }

//     // =========================
//     // ORDER STATUS
//     // =========================
//     else if (section === 'order') {
//       // Freezing Order and Summons are dropdowns (waiting / Delivered /
//       // Returned to office). The plain "issued" booleans are derived
//       // automatically — true once the value moves off "waiting" — same
//       // rule the backend applies.
//       if (name === 'is_freezing_order_delivered') {
//         if (value === 'waiting' && orderStatus.is_bank_freezed) {
//           showError('Please undo "Bank Freezed" before resetting Freezing Order to "waiting".');
//           return;
//         }
//         setOrderStatus((prev) => ({
//           ...prev,
//           is_freezing_order_delivered: value,
//           is_freezing_order_issued: value !== 'waiting',
//         }));
//         return;
//       }

//       if (name === 'is_summons_delivered') {
//         setOrderStatus((prev) => ({
//           ...prev,
//           is_summons_delivered: value,
//           is_summons_issued: value !== 'waiting',
//         }));
//         return;
//       }

//       // Cannot uncheck bank freezed if summons already delivered
//       if (
//         name === 'is_bank_freezed' &&
//         !checked &&
//         orderStatus.is_summons_issued
//       ) {
//         showError(
//           'Please reset "Summons" to waiting before unchecking "Bank Freezed".'
//         );
//         return;
//       }

//       setOrderStatus((prev) => ({
//         ...prev,
//         [name]: checked,
//       }));
//     }

//     // =========================
//     // PAYMENT
//     // =========================
//     else if (section === 'payment') {
//       if (name === 'no_of_installment') {
//         const enteredValue = parseInt(value, 10) || 0;

//         // The installment schedule depends on BOTH the count and the
//         // agreed amount (each installment's value is derived from the
//         // amount). So skip the destructive warning only when neither has
//         // changed from what's saved — if the amount was edited, the
//         // schedule has to be recreated even if the count itself is the
//         // same number as before.
//         const currentAmount = parseFloat(paymentData.agreed_amount) || 0;
//         const amountUnchanged = currentAmount === existingAmount;

//         if (enteredValue === existingInstallment && amountUnchanged) {
//           setPaymentData((prev) => ({
//             ...prev,
//             no_of_installment: value,
//           }));
//           return;
//         }

//         setPendingInstallmentValue(value);
//         setShowInstallmentWarning(true);
//         return;
//       }

//       // Mutual exclusivity
//       if (name === 'is_agreed_to_pay' && checked) {
//         setPaymentData((prev) => ({
//           ...prev,
//           is_agreed_to_pay: true,
//           is_not_agreed_to_pay: false,
//         }));
//         return;
//       }

//       if (name === 'is_not_agreed_to_pay' && checked) {
//         setPaymentData((prev) => ({
//           ...prev,
//           is_not_agreed_to_pay: true,
//           is_agreed_to_pay: false,
//           agreed_amount: '',
//           no_of_installment: '',
//         }));
//         return;
//       }

//       setPaymentData((prev) => ({
//         ...prev,
//         [name]: type === 'checkbox' ? checked : value,
//       }));
//     }
//   };

//   // ── Document file upload ────────────────────────────────────────────────
//   const handleDocFileChange = (fileFieldName) => (e) => {
//     if (readOnly) return;
//     const file = e.target.files?.[0];
//     if (!file) return;

//     const { maxSize, label } = DOC_FILE_MAP[fileFieldName];
//     if (file.size > maxSize) {
//       showError(`${label} file must be under ${Math.round(maxSize / (1024 * 1024))} MB.`);
//       return;
//     }

//     setDocFiles((prev) => ({ ...prev, [fileFieldName]: file }));

//     // Uploading a file always marks that document as submitted, matching
//     // the backend behaviour — reflect it immediately in the checkbox.
//     const { boolField } = DOC_FILE_MAP[fileFieldName];
//     setFormData((prev) => ({ ...prev, [boolField]: true }));
//   };

//   const confirmInstallmentChange = () => {
//     setPaymentData((prev) => ({
//       ...prev,
//       no_of_installment: parseInt(pendingInstallmentValue, 10) || 0,
//     }));

//     setPendingInstallmentValue('');
//     setShowInstallmentWarning(false);
//   };

//   const cancelInstallmentChange = () => {
//     setPendingInstallmentValue('');
//     setShowInstallmentWarning(false);
//   };

//   const buildDocsFormData = () => {
//     const fd = new FormData();
//     fd.append('current_address', formData.current_address || '');
//     fd.append('updated_mobile_number', formData.updated_mobile_number || '');
//     fd.append('is_address_proof_submited', formData.is_address_proof_submited);
//     fd.append('is_pan_card_submited', formData.is_pan_card_submited);
//     fd.append('is_aadhar_card_submited', formData.is_aadhar_card_submited);
//     fd.append('is_affidavit_submited', formData.is_affidavit_submited);
//     fd.append('is_bank_statement_submited', formData.is_bank_statement_submited);

//     Object.keys(DOC_FILE_MAP).forEach((fileFieldName) => {
//       const file = docFiles[fileFieldName];
//       if (file) fd.append(fileFieldName, file);
//     });

//     return fd;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (readOnly || !excessId) return;

//     // Validation: Agreed Amount should not exceed Excess Amount
//     if (paymentData.is_agreed_to_pay) {
//       const agreed = parseFloat(paymentData.agreed_amount || 0);
//       const maxAllowed = parseFloat(excessAmt || 0);

//       if (!Number.isFinite(agreed) || agreed < 0) {
//         setSnackbarMessage('Agreed Amount must be a valid non-negative number');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         return;
//       }

//       if (agreed > maxAllowed) {
//         setSnackbarMessage('Agreed Amount cannot exceed Excess Amount');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         return;
//       }

//       // No of Installments is mandatory whenever "Agreed to Pay" is set —
//       // it is intentionally left blank on load (even if a value already
//       // exists on the server) so the user has to consciously re-enter it
//       // rather than unknowingly resubmitting stale data.
//       const installmentEntered =
//         paymentData.no_of_installment !== '' &&
//         paymentData.no_of_installment !== null &&
//         paymentData.no_of_installment !== undefined &&
//         Number(paymentData.no_of_installment) > 0;

//       if (!installmentEntered) {
//         setSnackbarMessage('Please enter No of Installments');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         return;
//       }
//     }

//     if (
//       formData.updated_mobile_number &&
//       formData.updated_mobile_number.length !== 10
//     ) {
//       setSnackbarMessage('Mobile number must be exactly 10 digits');
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//       return;
//     }

//     let payloadPayment = { ...paymentData };

//     if (!paymentData.is_agreed_to_pay) {
//       payloadPayment = {
//         is_agreed_to_pay: false,
//         is_not_agreed_to_pay: true,
//         agreed_amount: 0,
//         no_of_installment: 0,
//         agree_remarks: paymentData.agree_remarks || '',
//       };
//     } else {
//       payloadPayment.no_of_installment = parseInt(paymentData.no_of_installment, 10) || 0;
//     }

//     setLoading(true);

//     try {
//       await Promise.all([
//         api.patch(
//           `/excess_payment_mgmt/excess-docs-updater/${excessId}/`,
//           buildDocsFormData(),
//           { headers: { 'Content-Type': 'multipart/form-data' } }
//         ),

//         api.patch(
//           `/excess_payment_mgmt/excess-order-updater/${excessId}/`,
//           {
//             is_freezing_order_delivered: orderStatus.is_freezing_order_delivered,
//             is_summons_delivered: orderStatus.is_summons_delivered,
//             is_bank_freezed: orderStatus.is_bank_freezed,
//           }
//         ),

//         api.patch(
//           `/excess_payment_mgmt/excess-payment-updater/${excessId}/`,
//           payloadPayment
//         ),
//       ]);

//       await fetchAllData();

//       setSnackbarMessage('Updated Successfully');
//       setSnackbarSeverity('success');
//       setSnackbarOpen(true);

//       setTimeout(() => onClose(), 1000);
//     } catch (err) {
//       setSnackbarMessage(
//         err.response?.data?.error ||
//           err.response?.data?.message ||
//           'Failed to update.'
//       );

//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const docsDisabled = readOnly || !orderStatus.is_summons_issued;

//   // Small reusable row: checkbox + upload button + view link
//   const DocUploadRow = ({ fileFieldName, checkboxLabel }) => {
//     const { boolField, linkField, maxSize } = DOC_FILE_MAP[fileFieldName];
//     const stagedFile = docFiles[fileFieldName];
//     const existingLink = formData[linkField];
//     const maxSizeLabel = `${Math.round(maxSize / (1024 * 1024))} MB`;

//     return (
//       <Box
//         display="flex"
//         alignItems="center"
//         flexWrap="wrap"
//         gap={1}
//         sx={{ py: 0.5 }}
//       >
//         <FormControlLabel
//           sx={{ minWidth: 200 }}
//           control={
//             <Checkbox
//               checked={formData[boolField]}
//               name={boolField}
//               onChange={(e) => handleChange(e, 'docs')}
//               disabled={docsDisabled}
//             />
//           }
//           label={checkboxLabel}
//         />

//         <Tooltip title={docsDisabled ? (readOnly ? 'View only' : 'Enable Summons first') : `Upload file (max ${maxSizeLabel})`}>
//           <span>
//             <Button
//               size="small"
//               variant="outlined"
//               component="label"
//               startIcon={<UploadFileIcon fontSize="small" />}
//               disabled={docsDisabled}
//             >
//               {stagedFile ? stagedFile.name : 'Upload'}
//               <input
//                 type="file"
//                 hidden
//                 accept=".pdf,.jpg,.jpeg,.png"
//                 onChange={handleDocFileChange(fileFieldName)}
//               />
//             </Button>
//           </span>
//         </Tooltip>

//         {existingLink && (
//           <Tooltip title="View uploaded file">
//             <IconButton
//               size="small"
//               component={Link}
//               href={existingLink}
//               target="_blank"
//               rel="noopener"
//             >
//               <VisibilityIcon fontSize="small" />
//             </IconButton>
//           </Tooltip>
//         )}
//       </Box>
//     );
//   };

//   return (
//     <>
//       <Dialog
//         open={open}
//         onClose={onClose}
//         maxWidth="md"
//         fullWidth
//         disableEscapeKeyDown
//        >
//         <DialogTitle>
//           {readOnly ? 'View Documents & Order Status (Read Only)' : 'Edit Document & Order Status'}
//         </DialogTitle>

//         <DialogContent>
//           <Box component="form" onSubmit={handleSubmit} p={2}>
//             {/* REFERENCE ID */}
//             <Typography variant="subtitle2" gutterBottom>
//               Reference ID:{' '}
//               <Box
//                 component="span"
//                 sx={{
//                   backgroundColor: '#1976d2',
//                   color: '#fff',
//                   px: 1.5,
//                   py: 0.5,
//                   borderRadius: 1,
//                   fontWeight: 600,
//                   fontSize: '0.85rem',
//                 }}
//               >
//                 {refId}
//               </Box>
//             </Typography>

//             {/* EXCESS AMOUNT */}
//             <Typography variant="subtitle2" gutterBottom>
//               Excess Amount:{' '}
//               <Box
//                 component="span"
//                 sx={{
//                   backgroundColor: '#2e7d32',
//                   color: '#fff',
//                   px: 1.5,
//                   py: 0.5,
//                   borderRadius: 1,
//                   fontWeight: 600,
//                   fontSize: '0.85rem',
//                 }}
//               >
//                 ₹ {excessAmt || 0}
//               </Box>
//             </Typography>

//             <Typography
//               variant="body2"
//               sx={{
//                 color: '#8B0000',
//                 fontWeight: 600,
//                 mb: 2,
//               }}
//             >
//               Please add Reference Id on Hard copy
//             </Typography>

//             {/* ORDER STATUS */}
//             <Typography variant="subtitle2" gutterBottom>
//               Order Status
//             </Typography>

//             <Box display="flex" gap={2} flexWrap="wrap" sx={{ mb: 1 }}>
//               <FormControl size="small" sx={{ minWidth: 220 }} disabled={readOnly}>
//                 <InputLabel>Freezing Order</InputLabel>
//                 <Select
//                   label="Freezing Order"
//                   name="is_freezing_order_delivered"
//                   value={orderStatus.is_freezing_order_delivered || 'waiting'}
//                   onChange={(e) => handleChange(e, 'order')}
//                 >
//                   {DELIVERY_STATUS_OPTIONS.map((opt) => (
//                     <MenuItem key={opt} value={opt}>{opt}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>

//               <FormControl size="small" sx={{ minWidth: 220 }} disabled={readOnly || !orderStatus.is_bank_freezed}>
//                 <InputLabel>Summons</InputLabel>
//                 <Select
//                   label="Summons"
//                   name="is_summons_delivered"
//                   value={orderStatus.is_summons_delivered || 'waiting'}
//                   onChange={(e) => handleChange(e, 'order')}
//                 >
//                   {DELIVERY_STATUS_OPTIONS.map((opt) => (
//                     <MenuItem key={opt} value={opt}>{opt}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Box>

//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={orderStatus.is_bank_freezed}
//                   name="is_bank_freezed"
//                   disabled={
//                     readOnly || !orderStatus.is_freezing_order_issued
//                   }
//                   onChange={(e) =>
//                     handleChange(e, 'order')
//                   }
//                 />
//               }
//               label="Bank Freezed"
//             />

//             <Divider sx={{ my: 2 }} />

//             {/* PAYMENT */}
//             <Typography variant="subtitle2" gutterBottom>
//               Payment Agreement
//             </Typography>

//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={paymentData.is_agreed_to_pay}
//                   name="is_agreed_to_pay"
//                   disabled={readOnly || !orderStatus.is_summons_issued}
//                   onChange={(e) =>
//                     handleChange(e, 'payment')
//                   }
//                 />
//               }
//               label="Agreed to Pay"
//             />

//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={
//                     paymentData.is_not_agreed_to_pay
//                   }
//                   name="is_not_agreed_to_pay"
//                   disabled={readOnly || !orderStatus.is_summons_issued}
//                   onChange={(e) =>
//                     handleChange(e, 'payment')
//                   }
//                 />
//               }
//               label="Not Agreed to Pay"
//             />

//             {paymentData.is_agreed_to_pay &&
//             !paymentData.is_not_agreed_to_pay ? (
//               <>
//                 <TextField
//                   label="Agreed Amount"
//                   type="number"
//                   name="agreed_amount"
//                   value={paymentData.agreed_amount}
//                   onChange={(e) =>
//                     handleChange(e, 'payment')
//                   }
//                   fullWidth
//                   size="small"
//                   disabled={readOnly}
//                   sx={{ mt: 2 }}
//                 />

//                 <TextField
//                   label="No of Installments"
//                   type="number"
//                   name="no_of_installment"
//                   value={
//                     paymentData.no_of_installment
//                   }
//                   onChange={(e) =>
//                     handleChange(e, 'payment')
//                   }
//                   fullWidth
//                   size="small"
//                   disabled={readOnly}
//                   required={!readOnly}
//                   placeholder={!readOnly && existingInstallment ? `Previous: ${existingInstallment} — re-enter to confirm` : ''}
//                   helperText={!readOnly && existingInstallment ? `Previous value was ${existingInstallment}. Re-entry required.` : ''}
//                   sx={{ mt: 2 }}
//                 />
//               </>
//             ) : null}

//             <TextField
//               label="Additional Remarks"
//               name="agree_remarks"
//               value={paymentData.agree_remarks}
//               onChange={(e) =>
//                 handleChange(e, 'payment')
//               }
//               fullWidth
//               multiline
//               rows={2}
//               size="small"
//               disabled={readOnly}
//               sx={{ mt: 2 }}
//             />

//             <Divider sx={{ my: 2 }} />

//             {/* DOCS */}
//             <Typography variant="subtitle2" gutterBottom>
//               Proof of Submission
//             </Typography>
//             <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
//               Uploading a file automatically marks that document as submitted.
//               PDF/JPG/PNG — 2 MB max (Bank Statement up to 10 MB).
//             </Typography>

//             <Box display="flex" flexDirection="column" mb={2}>
//               <DocUploadRow fileFieldName="address_proof_file" checkboxLabel="Address Proof" />
//               <DocUploadRow fileFieldName="pan_card_file" checkboxLabel="PAN Card" />
//               <DocUploadRow fileFieldName="aadhar_card_file" checkboxLabel="Aadhar Card" />

//               <Box sx={{ pl: 0.5, py: 0.5 }}>
//                 <DocUploadRow fileFieldName="affidavit_file" checkboxLabel="Affidavit" />
//                 <Typography variant="body2" sx={{ pl: 4 }}>
//                   Download Affidavit Template:{' '}
//                   <Link
//                     href="https://splocamedia.s3.ap-south-1.amazonaws.com/templates/UN-FREEZE+THE+BANK+ACCOUNT.pdf"
//                     target="_blank"
//                   >
//                     Click here
//                   </Link>
//                 </Typography>
//               </Box>

//               <DocUploadRow fileFieldName="bank_statement_file" checkboxLabel="Bank Statement" />
//             </Box>

//             <TextField
//               label="Current Address"
//               name="current_address"
//               value={formData.current_address}
//               onChange={(e) =>
//                 handleChange(e, 'docs')
//               }
//               fullWidth
//               multiline
//               rows={2}
//               size="small"
//               disabled={readOnly}
//               sx={{ mb: 2 }}
//             />

//             <TextField
//               label="Updated Mobile Number"
//               name="updated_mobile_number"
//               value={formData.updated_mobile_number}
//               onChange={(e) =>
//                 handleChange(e, 'docs')
//               }
//               fullWidth
//               size="small"
//               disabled={readOnly}
//               inputProps={{ maxLength: 10 }}
//               helperText="Enter 10 digit mobile number"
//             />
//           </Box>
//         </DialogContent>

//         <DialogActions>
//           <Button
//             onClick={onClose}
//             disabled={loading}
//           >
//             {readOnly ? 'Close' : 'Cancel'}
//           </Button>

//           {!readOnly && (
//             <Button
//               type="submit"
//               onClick={handleSubmit}
//               variant="contained"
//               disabled={loading}
//             >
//               {loading ? 'Saving...' : 'Save'}
//             </Button>
//           )}
//         </DialogActions>
//       </Dialog>

//       {/* INSTALLMENT WARNING */}
//       <Dialog open={showInstallmentWarning}>
//         <DialogTitle>Warning</DialogTitle>

//         <DialogContent>
//           <Typography color="error">
//             Changing number of installments will
//             erase all existing installment data.
//             This action cannot be undone.
//           </Typography>
//         </DialogContent>

//         <DialogActions>
//           <Button onClick={cancelInstallmentChange}>
//             Cancel
//           </Button>

//           <Button
//             onClick={confirmInstallmentChange}
//             color="error"
//             variant="contained"
//           >
//             Proceed
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={() => setSnackbarOpen(false)}
//       />
//     </>
//   );
// };

// export default DocsEditModal;


import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
  TextField,
  Link,
  Divider,
  IconButton,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import VisibilityIcon from '@mui/icons-material/Visibility';
import api from '../../../api/axiosInterceptor';
import { SnackBarComponent } from '../../../Components/snackBar/snackBar';
import { DELIVERY_STATUS_OPTIONS, MAX_DOC_FILE_SIZE, MAX_BANK_STATEMENT_FILE_SIZE } from './workflowApi';

// file input name -> (boolean field, link field, human label, max bytes)
const DOC_FILE_MAP = {
  address_proof_file: {
    boolField: 'is_address_proof_submited',
    linkField: 'address_proof_link',
    label: 'Address Proof',
    maxSize: MAX_DOC_FILE_SIZE,
  },
  pan_card_file: {
    boolField: 'is_pan_card_submited',
    linkField: 'pan_card_link',
    label: 'PAN Card',
    maxSize: MAX_DOC_FILE_SIZE,
  },
  aadhar_card_file: {
    boolField: 'is_aadhar_card_submited',
    linkField: 'aadhar_card_link',
    label: 'Aadhar Card',
    maxSize: MAX_DOC_FILE_SIZE,
  },
  affidavit_file: {
    boolField: 'is_affidavit_submited',
    linkField: 'affidavit_link',
    label: 'Affidavit',
    maxSize: MAX_DOC_FILE_SIZE,
  },
  bank_statement_file: {
    boolField: 'is_bank_statement_submited',
    linkField: 'bank_statement_link',
    label: 'Bank Statement',
    maxSize: MAX_BANK_STATEMENT_FILE_SIZE,
  },
};

// NOTE: Partial Unfreeze / Final Defreeze (with uploads) have moved to their
// own component — ClosureStatusModal.jsx — since they belong to post-payment
// closure, not this pre-decision document set. This modal now only owns:
// Freezing/Summons delivery status, Bank Freezed, the 5 documents, and the
// Payment Agreement (agreed amount / installments).
const DocsEditModal = ({ open, onClose, excessId, refId, excessAmt, readOnly = false }) => {
  const [loading, setLoading] = useState(false);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  // PAYMENT STATE
  const [paymentData, setPaymentData] = useState({
    is_agreed_to_pay: false,
    is_not_agreed_to_pay: false,
    agreed_amount: '',
    no_of_installment: 0,
    agree_remarks: '',
  });

  // Shared destructive-change warning dialog + shared Proceed/Cancel handlers
  // (confirmInstallmentChange / cancelInstallmentChange below). Both the
  // "edit No of Installments" flow AND the "switch to Not Agreed to Pay"
  // flow go through the SAME pendingInstallmentValue + same buttons — the
  // Proceed button always ends up resetting no_of_installment the same way.
  // `warningType` only changes the message text shown in the dialog.
  const [showInstallmentWarning, setShowInstallmentWarning] = useState(false);
  const [warningType, setWarningType] = useState('installment');
  const [pendingInstallmentValue, setPendingInstallmentValue] = useState('');
  // Only used by the 'notAgree' flow, so confirmInstallmentChange knows it
  // also needs to flip the agree/not-agree flags and clear agreed_amount —
  // on top of resetting no_of_installment via the exact same code path.
  const [pendingNotAgree, setPendingNotAgree] = useState(false);

  // Holds the installment count as it exists on the server. Used only to show
  // the user a hint ("Previous: X") — it is never fed back into the editable
  // field, so the user can't accidentally save without re-entering it, which
  // previously risked silently carrying stale data into workflow decisions.
  const [existingInstallment, setExistingInstallment] = useState(0);
  const [existingAmount, setExistingAmount] = useState(0);

  // DOCS — checkboxes + link fields returned from the server
  const [formData, setFormData] = useState({
    is_address_proof_submited: false,
    address_proof_link: '',
    is_pan_card_submited: false,
    pan_card_link: '',
    is_aadhar_card_submited: false,
    aadhar_card_link: '',
    is_affidavit_submited: false,
    affidavit_link: '',
    is_bank_statement_submited: false,
    bank_statement_link: '',
    current_address: '',
    updated_mobile_number: '',
  });

  // DOCS — files staged for upload (not yet sent) keyed by the multipart field name
  const [docFiles, setDocFiles] = useState({});

  // ORDER — only the fields this modal actually owns
  const [orderStatus, setOrderStatus] = useState({
    is_freezing_order_delivered: 'waiting',
    is_freezing_order_issued: false,
    is_bank_freezed: false,
    is_summons_delivered: 'waiting',
    is_summons_issued: false,
  });

  // Fetch all data
  const fetchAllData = async () => {
    if (!excessId) return;

    try {
      setLoading(true);

      const [docsRes, orderRes, paymentRes] = await Promise.all([
        api.get(`/excess_payment_mgmt/excess-docs-updater/${excessId}/`),
        api.get(`/excess_payment_mgmt/excess-order-updater/${excessId}/`),
        api.get(`/excess_payment_mgmt/excess-payment-updater/${excessId}/`),
      ]);

      setFormData((prev) => ({ ...prev, ...docsRes.data }));
      setDocFiles({});

      setOrderStatus((prev) => ({
        ...prev,
        is_freezing_order_delivered: orderRes.data.is_freezing_order_delivered,
        is_freezing_order_issued: orderRes.data.is_freezing_order_issued,
        is_bank_freezed: orderRes.data.is_bank_freezed,
        is_summons_delivered: orderRes.data.is_summons_delivered,
        is_summons_issued: orderRes.data.is_summons_issued,
      }));

      const savedInstallment = parseInt(paymentRes.data.no_of_installment, 10) || 0;
      const savedAmount = parseFloat(paymentRes.data.agreed_amount) || 0;
      setExistingInstallment(savedInstallment);
      setExistingAmount(savedAmount);

      setPaymentData({
        is_agreed_to_pay: paymentRes.data.is_agreed_to_pay || false,
        is_not_agreed_to_pay: paymentRes.data.is_not_agreed_to_pay || false,
        agreed_amount: paymentRes.data.agreed_amount || '',
        // In read-only (view) mode show the real saved value. In edit mode,
        // leave it blank so the user is forced to consciously re-enter it —
        // silently resubmitting a stale prefilled value could otherwise
        // drive a workflow decision off outdated installment data.
        no_of_installment: readOnly ? savedInstallment : '',
        agree_remarks: paymentRes.data.agree_remarks || '',
      });
    } catch (err) {
      setSnackbarMessage(
        err.response?.data?.error || 'Failed to load data.'
      );
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      fetchAllData();
    }
  }, [open, excessId]);

  const showError = (message) => {
    setSnackbarMessage(message);
    setSnackbarSeverity('error');
    setSnackbarOpen(true);
  };

  const handleChange = (e, section = 'docs') => {
    if (readOnly) return;
    const { name, value, checked, type } = e.target;

    // Mobile validation
    if (name === 'updated_mobile_number') {
      if (!/^\d{0,10}$/.test(value)) return;
    }

    // =========================
    // DOCS
    // =========================
    if (section === 'docs') {
      setFormData((prev) => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value,
      }));
    }

    // =========================
    // ORDER STATUS
    // =========================
    else if (section === 'order') {
      // Freezing Order and Summons are dropdowns (waiting / Delivered /
      // Returned to office). The plain "issued" booleans are derived
      // automatically — true once the value moves off "waiting" — same
      // rule the backend applies.
      if (name === 'is_freezing_order_delivered') {
        if (value === 'waiting' && orderStatus.is_bank_freezed) {
          showError('Please undo "Bank Freezed" before resetting Freezing Order to "waiting".');
          return;
        }
        setOrderStatus((prev) => ({
          ...prev,
          is_freezing_order_delivered: value,
          is_freezing_order_issued: value !== 'waiting',
        }));
        return;
      }

      if (name === 'is_summons_delivered') {
        setOrderStatus((prev) => ({
          ...prev,
          is_summons_delivered: value,
          is_summons_issued: value !== 'waiting',
        }));
        return;
      }

      // Cannot uncheck bank freezed if summons already delivered
      if (
        name === 'is_bank_freezed' &&
        !checked &&
        orderStatus.is_summons_issued
      ) {
        showError(
          'Please reset "Summons" to waiting before unchecking "Bank Freezed".'
        );
        return;
      }

      setOrderStatus((prev) => ({
        ...prev,
        [name]: checked,
      }));
    }

    // =========================
    // PAYMENT
    // =========================
    else if (section === 'payment') {
      if (name === 'no_of_installment') {
        const enteredValue = parseInt(value, 10) || 0;

        // The installment schedule depends on BOTH the count and the
        // agreed amount (each installment's value is derived from the
        // amount). So skip the destructive warning only when neither has
        // changed from what's saved — if the amount was edited, the
        // schedule has to be recreated even if the count itself is the
        // same number as before.
        const currentAmount = parseFloat(paymentData.agreed_amount) || 0;
        const amountUnchanged = currentAmount === existingAmount;

        if (enteredValue === existingInstallment && amountUnchanged) {
          setPaymentData((prev) => ({
            ...prev,
            no_of_installment: value,
          }));
          return;
        }

        setWarningType('installment');
        setPendingInstallmentValue(value);
        setShowInstallmentWarning(true);
        return;
      }

      // Mutual exclusivity
      if (name === 'is_agreed_to_pay' && checked) {
        setPaymentData((prev) => ({
          ...prev,
          is_agreed_to_pay: true,
          is_not_agreed_to_pay: false,
        }));
        return;
      }

      if (name === 'is_not_agreed_to_pay' && checked) {
        // If installment count and/or agreed amount already exist (either
        // saved on the server, or already entered on this screen), switching
        // to "Not Agreed to Pay" will erase that data on save. Reuse the exact
        // same pending-installment-change warning + same Proceed/Cancel
        // buttons used for editing "No of Installments" directly — Proceed
        // always resets no_of_installment through confirmInstallmentChange;
        // here it additionally flips the agree flags via pendingNotAgree.
        const currentAmount = parseFloat(paymentData.agreed_amount) || 0;
        const currentInstallment = parseInt(paymentData.no_of_installment, 10) || 0;
        const hasInstallmentData =
          existingInstallment > 0 ||
          existingAmount > 0 ||
          currentAmount > 0 ||
          currentInstallment > 0;

        if (hasInstallmentData) {
          setWarningType('notAgree');
          setPendingNotAgree(true);
          setPendingInstallmentValue('0'); // same field confirmInstallmentChange always resets
          setShowInstallmentWarning(true);
          return; // don't touch payment state yet — wait for confirmation
        }

        setPaymentData((prev) => ({
          ...prev,
          is_not_agreed_to_pay: true,
          is_agreed_to_pay: false,
          agreed_amount: '',
          no_of_installment: '',
        }));
        return;
      }

      setPaymentData((prev) => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value,
      }));
    }
  };

  // ── Document file upload ────────────────────────────────────────────────
  const handleDocFileChange = (fileFieldName) => (e) => {
    if (readOnly) return;
    const file = e.target.files?.[0];
    if (!file) return;

    const { maxSize, label } = DOC_FILE_MAP[fileFieldName];
    if (file.size > maxSize) {
      showError(`${label} file must be under ${Math.round(maxSize / (1024 * 1024))} MB.`);
      return;
    }

    setDocFiles((prev) => ({ ...prev, [fileFieldName]: file }));

    // Uploading a file always marks that document as submitted, matching
    // the backend behaviour — reflect it immediately in the checkbox.
    const { boolField } = DOC_FILE_MAP[fileFieldName];
    setFormData((prev) => ({ ...prev, [boolField]: true }));
  };

  // Confirms whichever destructive change triggered the warning dialog.
  const confirmInstallmentChange = () => {
    if (warningType === 'notAgree') {
      setPaymentData((prev) => ({
        ...prev,
        is_not_agreed_to_pay: true,
        is_agreed_to_pay: false,
        agreed_amount: '',
        no_of_installment: '',
      }));
    } else {
      setPaymentData((prev) => ({
        ...prev,
        no_of_installment: parseInt(pendingInstallmentValue, 10) || 0,
      }));
    }

    setPendingInstallmentValue('');
    setShowInstallmentWarning(false);
    setWarningType('installment');
  };

  const cancelInstallmentChange = () => {
    setPendingInstallmentValue('');
    setShowInstallmentWarning(false);
    setWarningType('installment');
  };

  const buildDocsFormData = () => {
    const fd = new FormData();
    fd.append('current_address', formData.current_address || '');
    fd.append('updated_mobile_number', formData.updated_mobile_number || '');
    fd.append('is_address_proof_submited', formData.is_address_proof_submited);
    fd.append('is_pan_card_submited', formData.is_pan_card_submited);
    fd.append('is_aadhar_card_submited', formData.is_aadhar_card_submited);
    fd.append('is_affidavit_submited', formData.is_affidavit_submited);
    fd.append('is_bank_statement_submited', formData.is_bank_statement_submited);

    Object.keys(DOC_FILE_MAP).forEach((fileFieldName) => {
      const file = docFiles[fileFieldName];
      if (file) fd.append(fileFieldName, file);
    });

    return fd;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (readOnly || !excessId) return;

    // Validation: Agreed Amount should not exceed Excess Amount
    if (paymentData.is_agreed_to_pay) {
      const agreed = parseFloat(paymentData.agreed_amount || 0);
      const maxAllowed = parseFloat(excessAmt || 0);

      if (!Number.isFinite(agreed) || agreed < 0) {
        setSnackbarMessage('Agreed Amount must be a valid non-negative number');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        return;
      }

      if (agreed > maxAllowed) {
        setSnackbarMessage('Agreed Amount cannot exceed Excess Amount');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        return;
      }

      // No of Installments is mandatory whenever "Agreed to Pay" is set —
      // it is intentionally left blank on load (even if a value already
      // exists on the server) so the user has to consciously re-enter it
      // rather than unknowingly resubmitting stale data.
      const installmentEntered =
        paymentData.no_of_installment !== '' &&
        paymentData.no_of_installment !== null &&
        paymentData.no_of_installment !== undefined &&
        Number(paymentData.no_of_installment) > 0;

      if (!installmentEntered) {
        setSnackbarMessage('Please enter No of Installments');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        return;
      }
    }

    if (
      formData.updated_mobile_number &&
      formData.updated_mobile_number.length !== 10
    ) {
      setSnackbarMessage('Mobile number must be exactly 10 digits');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      return;
    }

    let payloadPayment = { ...paymentData };

    if (!paymentData.is_agreed_to_pay) {
      payloadPayment = {
        is_agreed_to_pay: false,
        is_not_agreed_to_pay: true,
        agreed_amount: 0,
        no_of_installment: 0,
        agree_remarks: paymentData.agree_remarks || '',
      };
    } else {
      payloadPayment.no_of_installment = parseInt(paymentData.no_of_installment, 10) || 0;
    }

    setLoading(true);

    try {
      await Promise.all([
        api.patch(
          `/excess_payment_mgmt/excess-docs-updater/${excessId}/`,
          buildDocsFormData(),
          { headers: { 'Content-Type': 'multipart/form-data' } }
        ),

        api.patch(
          `/excess_payment_mgmt/excess-order-updater/${excessId}/`,
          {
            is_freezing_order_delivered: orderStatus.is_freezing_order_delivered,
            is_summons_delivered: orderStatus.is_summons_delivered,
            is_bank_freezed: orderStatus.is_bank_freezed,
          }
        ),

        api.patch(
          `/excess_payment_mgmt/excess-payment-updater/${excessId}/`,
          payloadPayment
        ),
      ]);

      await fetchAllData();

      setSnackbarMessage('Updated Successfully');
      setSnackbarSeverity('success');
      setSnackbarOpen(true);

      setTimeout(() => onClose(), 1000);
    } catch (err) {
      setSnackbarMessage(
        err.response?.data?.error ||
          err.response?.data?.message ||
          'Failed to update.'
      );

      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const docsDisabled = readOnly || !orderStatus.is_summons_issued;

  // Small reusable row: checkbox + upload button + view link
  const DocUploadRow = ({ fileFieldName, checkboxLabel }) => {
    const { boolField, linkField, maxSize } = DOC_FILE_MAP[fileFieldName];
    const stagedFile = docFiles[fileFieldName];
    const existingLink = formData[linkField];
    const maxSizeLabel = `${Math.round(maxSize / (1024 * 1024))} MB`;

    return (
      <Box
        display="flex"
        alignItems="center"
        flexWrap="wrap"
        gap={1}
        sx={{ py: 0.5 }}
      >
        <FormControlLabel
          sx={{ minWidth: 200 }}
          control={
            <Checkbox
              checked={formData[boolField]}
              name={boolField}
              onChange={(e) => handleChange(e, 'docs')}
              disabled={docsDisabled}
            />
          }
          label={checkboxLabel}
        />

        <Tooltip title={docsDisabled ? (readOnly ? 'View only' : 'Enable Summons first') : `Upload file (max ${maxSizeLabel})`}>
          <span>
            <Button
              size="small"
              variant="outlined"
              component="label"
              startIcon={<UploadFileIcon fontSize="small" />}
              disabled={docsDisabled}
            >
              {stagedFile ? stagedFile.name : 'Upload'}
              <input
                type="file"
                hidden
                accept=".pdf,.jpg,.jpeg,.png"
                onChange={handleDocFileChange(fileFieldName)}
              />
            </Button>
          </span>
        </Tooltip>

        {existingLink && (
          <Tooltip title="View uploaded file">
            <IconButton
              size="small"
              component={Link}
              href={existingLink}
              target="_blank"
              rel="noopener"
            >
              <VisibilityIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    );
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="md"
        fullWidth
        disableEscapeKeyDown
       >
        <DialogTitle>
          {readOnly ? 'View Documents & Order Status (Read Only)' : 'Edit Document & Order Status'}
        </DialogTitle>

        <DialogContent>
          <Box component="form" onSubmit={handleSubmit} p={2}>
            {/* REFERENCE ID */}
            <Typography variant="subtitle2" gutterBottom>
              Reference ID:{' '}
              <Box
                component="span"
                sx={{
                  backgroundColor: '#1976d2',
                  color: '#fff',
                  px: 1.5,
                  py: 0.5,
                  borderRadius: 1,
                  fontWeight: 600,
                  fontSize: '0.85rem',
                }}
              >
                {refId}
              </Box>
            </Typography>

            {/* EXCESS AMOUNT */}
            <Typography variant="subtitle2" gutterBottom>
              Excess Amount:{' '}
              <Box
                component="span"
                sx={{
                  backgroundColor: '#2e7d32',
                  color: '#fff',
                  px: 1.5,
                  py: 0.5,
                  borderRadius: 1,
                  fontWeight: 600,
                  fontSize: '0.85rem',
                }}
              >
                ₹ {excessAmt || 0}
              </Box>
            </Typography>

            <Typography
              variant="body2"
              sx={{
                color: '#8B0000',
                fontWeight: 600,
                mb: 2,
              }}
            >
              Please add Reference Id on Hard copy
            </Typography>

            {/* ORDER STATUS */}
            <Typography variant="subtitle2" gutterBottom>
              Order Status
            </Typography>

            <Box display="flex" gap={2} flexWrap="wrap" sx={{ mb: 1 }}>
              <FormControl size="small" sx={{ minWidth: 220 }} disabled={readOnly}>
                <InputLabel>Freezing Order</InputLabel>
                <Select
                  label="Freezing Order"
                  name="is_freezing_order_delivered"
                  value={orderStatus.is_freezing_order_delivered || 'waiting'}
                  onChange={(e) => handleChange(e, 'order')}
                >
                  {DELIVERY_STATUS_OPTIONS.map((opt) => (
                    <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl size="small" sx={{ minWidth: 220 }} disabled={readOnly || !orderStatus.is_bank_freezed}>
                <InputLabel>Summons</InputLabel>
                <Select
                  label="Summons"
                  name="is_summons_delivered"
                  value={orderStatus.is_summons_delivered || 'waiting'}
                  onChange={(e) => handleChange(e, 'order')}
                >
                  {DELIVERY_STATUS_OPTIONS.map((opt) => (
                    <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            <FormControlLabel
              control={
                <Checkbox
                  checked={orderStatus.is_bank_freezed}
                  name="is_bank_freezed"
                  disabled={
                    readOnly || !orderStatus.is_freezing_order_issued
                  }
                  onChange={(e) =>
                    handleChange(e, 'order')
                  }
                />
              }
              label="Bank Freezed"
            />

            <Divider sx={{ my: 2 }} />

            {/* PAYMENT */}
            <Typography variant="subtitle2" gutterBottom>
              Payment Agreement
            </Typography>

            <FormControlLabel
              control={
                <Checkbox
                  checked={paymentData.is_agreed_to_pay}
                  name="is_agreed_to_pay"
                  disabled={readOnly || !orderStatus.is_summons_issued}
                  onChange={(e) =>
                    handleChange(e, 'payment')
                  }
                />
              }
              label="Agreed to Pay"
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={
                    paymentData.is_not_agreed_to_pay
                  }
                  name="is_not_agreed_to_pay"
                  disabled={readOnly || !orderStatus.is_summons_issued}
                  onChange={(e) =>
                    handleChange(e, 'payment')
                  }
                />
              }
              label="Not Agreed to Pay"
            />

            {paymentData.is_agreed_to_pay &&
            !paymentData.is_not_agreed_to_pay ? (
              <>
                <TextField
                  label="Agreed Amount"
                  type="number"
                  name="agreed_amount"
                  value={paymentData.agreed_amount}
                  onChange={(e) =>
                    handleChange(e, 'payment')
                  }
                  fullWidth
                  size="small"
                  disabled={readOnly}
                  sx={{ mt: 2 }}
                />

                <TextField
                  label="No of Installments"
                  type="number"
                  name="no_of_installment"
                  value={
                    paymentData.no_of_installment
                  }
                  onChange={(e) =>
                    handleChange(e, 'payment')
                  }
                  fullWidth
                  size="small"
                  disabled={readOnly}
                  required={!readOnly}
                  placeholder={!readOnly && existingInstallment ? `Previous: ${existingInstallment} — re-enter to confirm` : ''}
                  helperText={!readOnly && existingInstallment ? `Previous value was ${existingInstallment}. Re-entry required.` : ''}
                  sx={{ mt: 2 }}
                />
              </>
            ) : null}

            <TextField
              label="Additional Remarks"
              name="agree_remarks"
              value={paymentData.agree_remarks}
              onChange={(e) =>
                handleChange(e, 'payment')
              }
              fullWidth
              multiline
              rows={2}
              size="small"
              disabled={readOnly}
              sx={{ mt: 2 }}
            />

            <Divider sx={{ my: 2 }} />

            {/* DOCS */}
            <Typography variant="subtitle2" gutterBottom>
              Proof of Submission
            </Typography>
            <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
              Uploading a file automatically marks that document as submitted.
              PDF/JPG/PNG — 2 MB max (Bank Statement up to 10 MB).
            </Typography>

            <Box display="flex" flexDirection="column" mb={2}>
              <DocUploadRow fileFieldName="address_proof_file" checkboxLabel="Address Proof" />
              <DocUploadRow fileFieldName="pan_card_file" checkboxLabel="PAN Card" />
              <DocUploadRow fileFieldName="aadhar_card_file" checkboxLabel="Aadhar Card" />

              <Box sx={{ pl: 0.5, py: 0.5 }}>
                <DocUploadRow fileFieldName="affidavit_file" checkboxLabel="Affidavit" />
                <Typography variant="body2" sx={{ pl: 4 }}>
                  Download Affidavit Template:{' '}
                  <Link
                    href="https://splocamedia.s3.ap-south-1.amazonaws.com/templates/EPMS_document/Affidavit_English.pdf"
                    target="_blank"
                  >
                    Click here
                  </Link>
                </Typography>
              </Box>

              <DocUploadRow fileFieldName="bank_statement_file" checkboxLabel="Bank Statement" />
            </Box>

            <TextField
              label="Current Address"
              name="current_address"
              value={formData.current_address}
              onChange={(e) =>
                handleChange(e, 'docs')
              }
              fullWidth
              multiline
              rows={2}
              size="small"
              disabled={readOnly}
              sx={{ mb: 2 }}
            />

            <TextField
              label="Updated Mobile Number"
              name="updated_mobile_number"
              value={formData.updated_mobile_number}
              onChange={(e) =>
                handleChange(e, 'docs')
              }
              fullWidth
              size="small"
              disabled={readOnly}
              inputProps={{ maxLength: 10 }}
              helperText="Enter 10 digit mobile number"
            />
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={onClose}
            disabled={loading}
          >
            {readOnly ? 'Close' : 'Cancel'}
          </Button>

          {!readOnly && (
            <Button
              type="submit"
              onClick={handleSubmit}
              variant="contained"
              disabled={loading}
            >
              {loading ? 'Saving...' : 'Save'}
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* DESTRUCTIVE CHANGE WARNING (installment edit OR switching to Not Agreed to Pay) */}
      <Dialog open={showInstallmentWarning}>
        <DialogTitle>Warning</DialogTitle>

        <DialogContent>
          <Typography color="error">
            {warningType === 'notAgree'
              ? 'Switching to "Not Agreed to Pay" will erase the existing Agreed Amount and No of Installments data. This action cannot be undone.'
              : 'Changing number of installments will erase all existing installment data. This action cannot be undone.'}
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button onClick={cancelInstallmentChange}>
            Cancel
          </Button>

          <Button
            onClick={confirmInstallmentChange}
            color="error"
            variant="contained"
          >
            Proceed
          </Button>
        </DialogActions>
      </Dialog>

      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={() => setSnackbarOpen(false)}
      />
    </>
  );
};

export default DocsEditModal;